
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5cc2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5cc2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iyjrR", function(module, exports) {
module.exports = import("8BShk").then(()=>parcelRequire('jaZ7o'));

});

parcelRegister("8ZFBQ", function(module, exports) {
module.exports = import("ilUZb").then(()=>parcelRequire('6fGU3'));

});

const $c9407a767cd80aee$export$1f12680e68c5100d = {
    en: {
        'Enter names below': 'Enter names below',
        Shuffle: 'Shuffle',
        Start: 'Start',
        Map: 'Map',
        Recording: 'Recording',
        'The winner is': 'The winner is',
        'Using skills': 'Using skills',
        'Buy me a coffee': 'Buy me a coffee',
        First: 'First',
        Last: 'Last',
        Multiple: 'Multiple',
        'Wheel of fortune': 'Wheel of fortune',
        BubblePop: 'BubblePop',
        'Pot of greed': 'Pot of greed',
        'Yoru ni Kakeru': 'Into The Night (by item4)',
        'Shake!': 'Shake!',
        'Input names separated by commas or line feed here': 'Input names separated by commas or line feed here',
        'This program is freeware and may be used freely anywhere, including in broadcasts and videos.': 'This program is freeware and may be used freely anywhere, including in broadcasts and videos.',
        Close: 'Close',
        'The result has been copied': 'The result has been copied',
        'Default maps': 'Default maps',
        'Downloaded maps': 'Downloaded maps',
        'Get more maps': 'Get more maps',
        'Remove this map': 'Remove this map',
        'Remove this downloaded map?': 'Remove this downloaded map?',
        'Map installed': 'Map installed',
        'Map updated': 'Map updated',
        'This map is already installed': 'This map is already installed',
        'Failed to install the map': 'Failed to install the map',
        'You can keep up to 30 downloaded maps. Remove some maps first.': 'You can keep up to 30 downloaded maps. Remove some maps first.',
        'Not enough storage. Remove some downloaded maps first.': 'Not enough storage. Remove some downloaded maps first.',
        'Cannot save maps in this browser': 'Cannot save maps in this browser',
        'Map Share': 'Map Share',
        Popular: 'Popular',
        Latest: 'Latest',
        'Most downloaded': 'Most downloaded',
        'My maps': 'My maps',
        'Search by title or author': 'Search by title or author',
        Install: 'Install',
        'Installing...': 'Installing...',
        Update: 'Update',
        Use: 'Use',
        'In use': 'In use',
        Remove: 'Remove',
        'Load more': 'Load more',
        'Loading...': 'Loading...',
        'Failed to load maps': 'Failed to load maps',
        Retry: 'Retry',
        'No maps found': 'No maps found',
        'No downloaded maps yet': 'No downloaded maps yet',
        'Update available': 'Update available',
        'No longer shared': 'No longer shared',
        Plays: 'Plays',
        Downloads: 'Downloads',
        'View on Map Share': 'View on Map Share',
        'Make a map': 'Make a map'
    },
    ko: {
        'Enter names below': "\uC774\uB984\uB4E4\uC744 \uC785\uB825\uD558\uC138\uC694",
        Shuffle: "\uC11E\uAE30",
        Start: "\uC2DC\uC791",
        Map: "\uB9F5",
        Recording: "\uB179\uD654",
        'The winner is': "\uB2F9\uCCA8 \uC21C\uC704",
        'Using skills': "\uC2A4\uD0AC \uD65C\uC131\uD654",
        'Buy me a coffee': "\uAC1C\uBC1C\uC790\uC5D0\uAC8C \uCEE4\uD53C \uC0AC\uC8FC\uAE30",
        First: "\uCCAB\uBC88\uC9F8",
        Last: "\uB9C8\uC9C0\uB9C9",
        Multiple: "\uC5EC\uB7EC\uBA85",
        'Wheel of fortune': "\uC6B4\uBA85\uC758 \uC218\uB808\uBC14\uD034",
        BubblePop: "\uBC84\uBE14\uD31D",
        'Pot of greed': "\uC695\uB9DD\uC758 \uD56D\uC544\uB9AC",
        'Yoru ni Kakeru': "\uBC24\uC744 \uB2EC\uB9AC\uB2E4 (by item4)",
        'Shake!': "\uD754\uB4E4\uAE30!",
        'Input names separated by commas or line feed here': "\uC774\uB984\uB4E4\uC744 \uC27C\uD45C\uB098 \uC5D4\uD130\uB85C \uAD6C\uBD84\uD574\uC11C \uB123\uC5B4\uC8FC\uC138\uC694",
        'This program is freeware and may be used freely anywhere, including in broadcasts and videos.': "\uC774 \uD504\uB85C\uADF8\uB7A8\uC740 \uD504\uB9AC\uC6E8\uC5B4\uC774\uBA70 \uBC29\uC1A1\uC774\uB098 \uC601\uC0C1 \uB4F1\uC744 \uD3EC\uD568\uD55C \uC5B4\uB5A4 \uC6A9\uB3C4\uB85C\uB4E0 \uC790\uC720\uB86D\uAC8C \uC0AC\uC6A9\uD558\uB294 \uAC83\uC774 \uD5C8\uC6A9\uB418\uC5B4\uC788\uC2B5\uB2C8\uB2E4.",
        Close: "\uB2EB\uAE30",
        'The result has been copied': "\uACB0\uACFC\uAC00 \uBCF5\uC0AC\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
        'Default maps': "\uAE30\uBCF8 \uB9F5",
        'Downloaded maps': "\uB2E4\uC6B4\uB85C\uB4DC\uD55C \uB9F5",
        'Get more maps': "\uB9F5 \uB354 \uBC1B\uAE30",
        'Remove this map': "\uC774 \uB9F5 \uC0AD\uC81C",
        'Remove this downloaded map?': "\uB2E4\uC6B4\uB85C\uB4DC\uD55C \uC774 \uB9F5\uC744 \uC0AD\uC81C\uD560\uAE4C\uC694?",
        'Map installed': "\uB9F5\uC744 \uC124\uCE58\uD588\uC2B5\uB2C8\uB2E4",
        'Map updated': "\uB9F5\uC744 \uC5C5\uB370\uC774\uD2B8\uD588\uC2B5\uB2C8\uB2E4",
        'This map is already installed': "\uC774\uBBF8 \uC124\uCE58\uB41C \uB9F5\uC785\uB2C8\uB2E4",
        'Failed to install the map': "\uB9F5\uC744 \uC124\uCE58\uD558\uC9C0 \uBABB\uD588\uC2B5\uB2C8\uB2E4",
        'You can keep up to 30 downloaded maps. Remove some maps first.': "\uB2E4\uC6B4\uB85C\uB4DC\uD55C \uB9F5\uC740 30\uAC1C\uAE4C\uC9C0 \uB458 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uBA3C\uC800 \uC4F0\uC9C0 \uC54A\uB294 \uB9F5\uC744 \uC0AD\uC81C\uD574 \uC8FC\uC138\uC694.",
        'Not enough storage. Remove some downloaded maps first.': "\uC800\uC7A5 \uACF5\uAC04\uC774 \uBD80\uC871\uD569\uB2C8\uB2E4. \uC4F0\uC9C0 \uC54A\uB294 \uB9F5\uC744 \uC0AD\uC81C\uD574 \uC8FC\uC138\uC694.",
        'Cannot save maps in this browser': "\uC774 \uBE0C\uB77C\uC6B0\uC800\uC5D0\uC11C\uB294 \uB9F5\uC744 \uC800\uC7A5\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4",
        'Map Share': "\uB9F5 \uACF5\uC720\uB9C8\uB2F9",
        Popular: "\uC778\uAE30",
        Latest: "\uCD5C\uC2E0",
        'Most downloaded': "\uB2E4\uC6B4\uB85C\uB4DC\uC21C",
        'My maps': "\uBC1B\uC740 \uB9F5",
        'Search by title or author': "\uC81C\uBAA9\uC774\uB098 \uB9CC\uB4E0 \uC0AC\uB78C\uC73C\uB85C \uAC80\uC0C9",
        Install: "\uC124\uCE58",
        'Installing...': "\uBC1B\uB294 \uC911...",
        Update: "\uC5C5\uB370\uC774\uD2B8",
        Use: "\uC0AC\uC6A9\uD558\uAE30",
        'In use': "\uC0AC\uC6A9 \uC911",
        Remove: "\uC0AD\uC81C",
        'Load more': "\uB354 \uBCF4\uAE30",
        'Loading...': "\uBD88\uB7EC\uC624\uB294 \uC911...",
        'Failed to load maps': "\uB9F5 \uBAA9\uB85D\uC744 \uBD88\uB7EC\uC624\uC9C0 \uBABB\uD588\uC2B5\uB2C8\uB2E4",
        Retry: "\uB2E4\uC2DC \uC2DC\uB3C4",
        'No maps found': "\uB9F5\uC774 \uC5C6\uC2B5\uB2C8\uB2E4",
        'No downloaded maps yet': "\uC544\uC9C1 \uBC1B\uC740 \uB9F5\uC774 \uC5C6\uC2B5\uB2C8\uB2E4",
        'Update available': "\uC5C5\uB370\uC774\uD2B8 \uC788\uC74C",
        'No longer shared': "\uACF5\uC720 \uC911\uB2E8\uB428",
        Plays: "\uD50C\uB808\uC774",
        Downloads: "\uB2E4\uC6B4\uB85C\uB4DC",
        'View on Map Share': "\uACF5\uC720\uB9C8\uB2F9\uC5D0\uC11C \uBCF4\uAE30",
        'Make a map': "\uB9F5 \uB9CC\uB4E4\uAE30"
    }
};


const $f38b96567aa47566$var$defaultLocale = 'en';
let $f38b96567aa47566$var$locale;
function $f38b96567aa47566$var$getBrowserLocale() {
    return navigator.language.split('-')[0];
}
function $f38b96567aa47566$var$translateElement(element) {
    if (!(element instanceof HTMLElement) || !$f38b96567aa47566$var$locale) return;
    const prop = element.getAttribute('data-trans');
    if (prop) {
        const key = (element.getAttribute(prop) || '').trim();
        if (key && key in (0, $c9407a767cd80aee$export$1f12680e68c5100d)[$f38b96567aa47566$var$locale]) element.setAttribute(prop, (0, $c9407a767cd80aee$export$1f12680e68c5100d)[$f38b96567aa47566$var$locale][key]);
    } else {
        const key = element.innerText.trim();
        if (key && key in (0, $c9407a767cd80aee$export$1f12680e68c5100d)[$f38b96567aa47566$var$locale]) element.innerText = (0, $c9407a767cd80aee$export$1f12680e68c5100d)[$f38b96567aa47566$var$locale][key];
    }
}
function $f38b96567aa47566$var$translatePage() {
    document.querySelectorAll('[data-trans]').forEach($f38b96567aa47566$var$translateElement);
}
function $f38b96567aa47566$var$setLocale(newLocale) {
    if (newLocale === $f38b96567aa47566$var$locale) return;
    document.documentElement.lang = newLocale;
    const newLocaleLower = newLocale.toLocaleLowerCase();
    $f38b96567aa47566$var$locale = newLocaleLower in (0, $c9407a767cd80aee$export$1f12680e68c5100d) ? newLocaleLower : $f38b96567aa47566$var$defaultLocale;
    $f38b96567aa47566$var$translatePage();
}
document.addEventListener('DOMContentLoaded', ()=>{
    console.log('localization loaded');
    const browserLocale = $f38b96567aa47566$var$getBrowserLocale();
    console.log('detected locale: ', browserLocale);
    $f38b96567aa47566$var$setLocale(browserLocale);
});
function $f38b96567aa47566$export$d73ee8ef04f5226a(key) {
    const table = (0, $c9407a767cd80aee$export$1f12680e68c5100d)[$f38b96567aa47566$var$locale ?? $f38b96567aa47566$var$defaultLocale];
    return table[key] ?? key;
}
window.translateElement = $f38b96567aa47566$var$translateElement;


const $48ba836f20a6b5e8$var$REFRESH_INTERVAL = 60000; // 60 seconds
const $48ba836f20a6b5e8$var$randomStart = ()=>Math.floor(Math.random() * 1000000);
class $48ba836f20a6b5e8$export$32c78522a0310c00 {
    constructor(apiBase){
        this._ads = [];
        this._current = null;
        this._cursor = $48ba836f20a6b5e8$var$randomStart();
        this._creativeCursors = new Map();
        this._intervalId = null;
        this._apiBase = apiBase.replace(/\/$/, '');
    }
    get current() {
        return this._current;
    }
    async init() {
        await this.fetchAds();
        this._startPeriodicRefresh();
    }
    destroy() {
        if (this._intervalId !== null) {
            clearInterval(this._intervalId);
            this._intervalId = null;
        }
    }
    _startPeriodicRefresh() {
        this._intervalId = window.setInterval(()=>{
            if (document.visibilityState === 'visible') this.fetchAds();
        }, $48ba836f20a6b5e8$var$REFRESH_INTERVAL);
    }
    async fetchAds() {
        try {
            const res = await fetch(`${this._apiBase}/api/ads/active`);
            if (!res.ok) return;
            const data = await res.json();
            const ads = Array.isArray(data.ads) ? data.ads : [];
            this._ads = ads.map((ad)=>{
                // 소재를 슬롯별로 나누기 전의 서버는 정사각 한 장을 프리롤과 결과가 함께 썼다
                const raw = ad.creatives ?? {
                    goal: ad.wide,
                    preroll: ad.square,
                    result: ad.square
                };
                const creatives = {};
                for (const [slot, list] of Object.entries(raw))if (list?.length) creatives[slot] = list.map((p)=>this.resolve(p));
                return {
                    ...ad,
                    creatives: creatives,
                    qrImage: ad.qrImage ? this.resolve(ad.qrImage) : undefined
                };
            });
        } catch  {
            this._ads = [];
        }
        this.onUpdate?.();
    }
    resolve(path) {
        return path.startsWith('/') ? `${this._apiBase}${path}` : path;
    }
    /**
   * 다음 `pickForRound()`가 고를 광고의 소재 URL 전부. 커서는 건드리지 않는다.
   * 어느 장이 뽑힐지는 슬롯별 커서에 달려 있어, 그 광고 것은 다 받아둔다.
   */ nextUrls() {
        if (this._ads.length === 0) return [];
        const ad = this._ads[this._cursor % this._ads.length];
        const urls = [];
        for (const list of Object.values(ad.creatives))if (list) urls.push(...list);
        if (ad.qrImage) urls.push(ad.qrImage);
        return urls;
    }
    pickForRound() {
        if (this._ads.length === 0) {
            this._current = null;
            return null;
        }
        const ad = this._ads[this._cursor % this._ads.length];
        this._cursor++;
        const creativeCursor = this._creativeCursors.get(ad.id) ?? $48ba836f20a6b5e8$var$randomStart();
        this._creativeCursors.set(ad.id, creativeCursor + 1);
        // 슬롯마다 장수가 달라 같은 커서라도 각자의 주기로 돈다 (프리롤은 1장이라 늘 같다)
        const creatives = {};
        for (const [slot, list] of Object.entries(ad.creatives))if (list?.length) creatives[slot] = list[creativeCursor % list.length];
        this._current = {
            id: ad.id,
            slots: ad.slots,
            advertiser: ad.advertiser,
            tagline: ad.tagline,
            qrImage: ad.qrImage,
            linkUrl: ad.linkUrl,
            house: ad.house,
            creatives: creatives
        };
        return this._current;
    }
    trackImpression() {
        const ad = this._current;
        if (!ad || ad.house) return;
        fetch(`${this._apiBase}/api/ads/${ad.id}/impression`, {
            method: 'POST',
            credentials: 'omit',
            keepalive: true
        }).catch(()=>{});
    }
}


// 맵 공유마당(marblerouletteshop.com/maps) 에서 받은 맵을 localStorage 에 보관한다.
//
// 샵(커스텀 룰렛 설치) 도 같은 키와 스키마를 쓴다. 바꿀 때는 샵의
// packages/common/src/map/downloadedMap.type.ts 와 함께 바꾸고 schemaVersion 을 올려야 한다.
//
// 서버가 검증한 승인 맵만 받지만, localStorage 는 사용자가 손댈 수 있으므로 읽을 때마다 형태를 다시 확인한다.
const $bc803f7cdb25c6b1$export$33724af291cef4f8 = 'mbr_downloaded_maps';
const $bc803f7cdb25c6b1$export$4868d44bd7e664c2 = 'mbr_selected_map';
const $bc803f7cdb25c6b1$export$f29b1a144ffef4b2 = 1;
const $bc803f7cdb25c6b1$export$1c0caa4db6150825 = 30;
/** 형태 확인에서 쓰는 상한. 서버 상한(500) 보다 넉넉히 둔다. 게임이 멈추지 않을 정도만 막으면 된다 */ const $bc803f7cdb25c6b1$var$MAX_ENTITIES = 1000;
const $bc803f7cdb25c6b1$var$MAX_POINTS = 1000;
const $bc803f7cdb25c6b1$export$e6f5a94bd4b1cb2d = /^[0-9a-f]{8}$/;
const $bc803f7cdb25c6b1$var$isNum = (v)=>typeof v === 'number' && Number.isFinite(v);
const $bc803f7cdb25c6b1$var$isObj = (v)=>typeof v === 'object' && v !== null && !Array.isArray(v);
function $bc803f7cdb25c6b1$var$isEntity(v) {
    if (!$bc803f7cdb25c6b1$var$isObj(v) || v.type !== 'static' && v.type !== 'kinematic') return false;
    const { position: position, shape: shape, props: props } = v;
    if (!$bc803f7cdb25c6b1$var$isObj(position) || !$bc803f7cdb25c6b1$var$isNum(position.x) || !$bc803f7cdb25c6b1$var$isNum(position.y)) return false;
    if (!$bc803f7cdb25c6b1$var$isObj(props) || !$bc803f7cdb25c6b1$var$isNum(props.density) || !$bc803f7cdb25c6b1$var$isNum(props.restitution) || !$bc803f7cdb25c6b1$var$isNum(props.angularVelocity)) return false;
    if (props.life !== undefined && !$bc803f7cdb25c6b1$var$isNum(props.life)) return false;
    if (!$bc803f7cdb25c6b1$var$isObj(shape)) return false;
    switch(shape.type){
        case 'box':
            return $bc803f7cdb25c6b1$var$isNum(shape.width) && $bc803f7cdb25c6b1$var$isNum(shape.height) && $bc803f7cdb25c6b1$var$isNum(shape.rotation);
        case 'circle':
            return $bc803f7cdb25c6b1$var$isNum(shape.radius) && shape.radius > 0;
        case 'polyline':
            return Array.isArray(shape.points) && shape.points.length >= 2 && shape.points.length <= $bc803f7cdb25c6b1$var$MAX_POINTS && shape.points.every((p)=>Array.isArray(p) && p.length === 2 && $bc803f7cdb25c6b1$var$isNum(p[0]) && $bc803f7cdb25c6b1$var$isNum(p[1]));
        default:
            return false;
    }
}
function $bc803f7cdb25c6b1$export$7906c8b4209ccc3d(v) {
    if (!$bc803f7cdb25c6b1$var$isObj(v) || typeof v.title !== 'string' || !$bc803f7cdb25c6b1$var$isNum(v.goalY) || !$bc803f7cdb25c6b1$var$isNum(v.zoomY)) return false;
    if (!Array.isArray(v.entities) || v.entities.length === 0 || v.entities.length > $bc803f7cdb25c6b1$var$MAX_ENTITIES) return false;
    if (!v.entities.every($bc803f7cdb25c6b1$var$isEntity)) return false;
    if (v.adBoards !== undefined) {
        if (!Array.isArray(v.adBoards) || !v.adBoards.every((b)=>$bc803f7cdb25c6b1$var$isObj(b) && $bc803f7cdb25c6b1$var$isNum(b.x) && $bc803f7cdb25c6b1$var$isNum(b.y))) return false;
    }
    if (v.progress !== undefined) {
        if (!$bc803f7cdb25c6b1$var$isObj(v.progress)) return false;
        const oneWays = v.progress.oneWays;
        if (oneWays !== undefined && (!Array.isArray(oneWays) || !oneWays.every((l)=>$bc803f7cdb25c6b1$var$isObj(l) && $bc803f7cdb25c6b1$var$isPoint(l.from) && $bc803f7cdb25c6b1$var$isPoint(l.to)))) return false;
    }
    if (v.zoomZones !== undefined && !$bc803f7cdb25c6b1$var$isZoneList(v.zoomZones)) return false;
    if (v.cameraZones !== undefined && !$bc803f7cdb25c6b1$var$isZoneList(v.cameraZones)) return false;
    return true;
}
function $bc803f7cdb25c6b1$var$isZoneList(v) {
    return Array.isArray(v) && v.every((z)=>$bc803f7cdb25c6b1$var$isObj(z) && $bc803f7cdb25c6b1$var$isNum(z.x) && $bc803f7cdb25c6b1$var$isNum(z.y) && $bc803f7cdb25c6b1$var$isNum(z.w) && $bc803f7cdb25c6b1$var$isNum(z.h) && z.w > 0 && z.h > 0);
}
function $bc803f7cdb25c6b1$var$isPoint(v) {
    return Array.isArray(v) && v.length === 2 && $bc803f7cdb25c6b1$var$isNum(v[0]) && $bc803f7cdb25c6b1$var$isNum(v[1]);
}
function $bc803f7cdb25c6b1$var$isDownloadedMap(v) {
    return $bc803f7cdb25c6b1$var$isObj(v) && typeof v.id === 'string' && $bc803f7cdb25c6b1$export$e6f5a94bd4b1cb2d.test(v.id) && $bc803f7cdb25c6b1$var$isNum(v.version) && typeof v.title === 'string' && typeof v.author === 'string' && $bc803f7cdb25c6b1$export$7906c8b4209ccc3d(v.stage);
}
function $bc803f7cdb25c6b1$var$readStore() {
    let raw;
    try {
        raw = localStorage.getItem($bc803f7cdb25c6b1$export$33724af291cef4f8);
    } catch  {
        return {
            ok: false,
            reason: 'unavailable'
        };
    }
    if (raw === null) return {
        ok: true,
        store: {
            schemaVersion: $bc803f7cdb25c6b1$export$f29b1a144ffef4b2,
            maps: []
        }
    };
    try {
        const parsed = JSON.parse(raw);
        if (!$bc803f7cdb25c6b1$var$isObj(parsed) || parsed.schemaVersion !== $bc803f7cdb25c6b1$export$f29b1a144ffef4b2 || !Array.isArray(parsed.maps)) return {
            ok: false,
            reason: 'corrupt'
        };
        return {
            ok: true,
            store: parsed
        };
    } catch  {
        return {
            ok: false,
            reason: 'corrupt'
        };
    }
}
function $bc803f7cdb25c6b1$var$writeStore(store) {
    try {
        localStorage.setItem($bc803f7cdb25c6b1$export$33724af291cef4f8, JSON.stringify(store));
        return 'ok';
    } catch (e) {
        return e instanceof DOMException && (e.name === 'QuotaExceededError' || e.code === 22) ? 'quota' : 'unavailable';
    }
}
function $bc803f7cdb25c6b1$export$d6a64179aa36abc6() {
    const read = $bc803f7cdb25c6b1$var$readStore();
    if (!read.ok) return [];
    return read.store.maps.filter($bc803f7cdb25c6b1$var$isDownloadedMap);
}
function $bc803f7cdb25c6b1$export$e82a75c9a926cf33(pkg, now = Date.now()) {
    const read = $bc803f7cdb25c6b1$var$readStore();
    // 깨진 데이터를 덮어쓰면 사용자가 받아둔 다른 맵까지 사라진다
    if (!read.ok) return {
        result: read.reason
    };
    const { store: store } = read;
    const index = store.maps.findIndex((m)=>$bc803f7cdb25c6b1$var$isObj(m) && m.id === pkg.id);
    const existing = index >= 0 && $bc803f7cdb25c6b1$var$isDownloadedMap(store.maps[index]) ? store.maps[index] : undefined;
    if (existing && existing.version >= pkg.version) return {
        result: 'already',
        map: existing
    };
    let map;
    if (index >= 0) {
        map = {
            ...pkg,
            installedAt: existing?.installedAt ?? now,
            updatedAt: now
        };
        store.maps[index] = map;
    } else {
        if (store.maps.length >= $bc803f7cdb25c6b1$export$1c0caa4db6150825) return {
            result: 'limit'
        };
        map = {
            ...pkg,
            installedAt: now,
            updatedAt: now
        };
        store.maps.push(map);
    }
    const written = $bc803f7cdb25c6b1$var$writeStore(store);
    if (written !== 'ok') return {
        result: written
    };
    return {
        result: existing ? 'updated' : 'installed',
        map: map
    };
}
function $bc803f7cdb25c6b1$export$db1dcd4e76d0fe8b(id) {
    const read = $bc803f7cdb25c6b1$var$readStore();
    if (!read.ok) return false;
    const maps = read.store.maps.filter((m)=>!($bc803f7cdb25c6b1$var$isObj(m) && m.id === id));
    if (maps.length === read.store.maps.length) return false;
    return $bc803f7cdb25c6b1$var$writeStore({
        ...read.store,
        maps: maps
    }) === 'ok';
}
function $bc803f7cdb25c6b1$export$af862b0702a42945() {
    try {
        return localStorage.getItem($bc803f7cdb25c6b1$export$4868d44bd7e664c2);
    } catch  {
        return null;
    }
}
function $bc803f7cdb25c6b1$export$683c1ca972341284(id) {
    try {
        localStorage.setItem($bc803f7cdb25c6b1$export$4868d44bd7e664c2, id);
    } catch  {
    // 저장하지 못하면 다음 방문에 첫 맵으로 돌아갈 뿐이다
    }
}
function $bc803f7cdb25c6b1$export$34d4b327ebc3ab(apiBase, mapId) {
    if (!mapId.startsWith('community:')) return;
    const id = mapId.slice(10);
    if (!$bc803f7cdb25c6b1$export$e6f5a94bd4b1cb2d.test(id)) return;
    fetch(`${apiBase}/api/external/maps/${id}/play`, {
        method: 'POST',
        credentials: 'omit',
        keepalive: true
    }).catch(()=>{});
}
async function $bc803f7cdb25c6b1$export$5ea46862415041fb(apiBase, id) {
    const res = await fetch(`${apiBase}/api/external/maps/${id}`);
    if (!res.ok) return null;
    const pkg = await res.json();
    if (!$bc803f7cdb25c6b1$var$isObj(pkg) || pkg.id !== id || !$bc803f7cdb25c6b1$var$isNum(pkg.version) || typeof pkg.title !== 'string') return null;
    if (typeof pkg.author !== 'string' || !$bc803f7cdb25c6b1$export$7906c8b4209ccc3d(pkg.stage)) return null;
    return pkg;
}
function $bc803f7cdb25c6b1$var$isListItem(v) {
    return $bc803f7cdb25c6b1$var$isObj(v) && typeof v.slug === 'string' && $bc803f7cdb25c6b1$export$e6f5a94bd4b1cb2d.test(v.slug) && typeof v.title === 'string' && typeof v.authorName === 'string' && $bc803f7cdb25c6b1$var$isNum(v.version) && $bc803f7cdb25c6b1$var$isNum(v.downloadCount) && $bc803f7cdb25c6b1$var$isNum(v.playCount) && $bc803f7cdb25c6b1$var$isNum(v.recentPlayCount);
}
async function $bc803f7cdb25c6b1$export$5b4a3eb572128219(apiBase, query, signal) {
    const params = new URLSearchParams({
        sort: query.sort,
        page: String(query.page),
        limit: String(query.limit)
    });
    if (query.q) params.set('q', query.q);
    const res = await fetch(`${apiBase}/api/external/maps?${params}`, {
        signal: signal
    });
    if (!res.ok) return null;
    const body = await res.json();
    if (!$bc803f7cdb25c6b1$var$isObj(body) || !Array.isArray(body.items) || !$bc803f7cdb25c6b1$var$isNum(body.total)) return null;
    return {
        items: body.items.filter($bc803f7cdb25c6b1$var$isListItem),
        total: body.total
    };
}
function $bc803f7cdb25c6b1$export$a6e79f144a86937d(apiBase, id) {
    return `${apiBase}/api/maps/${id}/thumbnail.svg`;
}
const $bc803f7cdb25c6b1$export$1676d593f4b89274 = 'mbr_map_updates';
const $bc803f7cdb25c6b1$var$UPDATE_CHECK_INTERVAL_MS = 86400000;
function $bc803f7cdb25c6b1$var$readUpdates() {
    try {
        const parsed = JSON.parse(localStorage.getItem($bc803f7cdb25c6b1$export$1676d593f4b89274) ?? 'null');
        if (!$bc803f7cdb25c6b1$var$isObj(parsed) || !$bc803f7cdb25c6b1$var$isNum(parsed.checkedAt) || !$bc803f7cdb25c6b1$var$isObj(parsed.maps)) return null;
        return parsed;
    } catch  {
        return null;
    }
}
function $bc803f7cdb25c6b1$export$641795282e8abbff() {
    return $bc803f7cdb25c6b1$var$readUpdates()?.maps ?? {};
}
function $bc803f7cdb25c6b1$export$97c7e4fb68b6824b(maps = $bc803f7cdb25c6b1$export$d6a64179aa36abc6()) {
    const states = $bc803f7cdb25c6b1$export$641795282e8abbff();
    return maps.filter((m)=>{
        const state = states[m.id];
        return state?.available === true && state.version !== null && state.version > m.version;
    }).map((m)=>m.id);
}
async function $bc803f7cdb25c6b1$export$d40f71d1d5e63b90(apiBase, now = Date.now()) {
    const ids = $bc803f7cdb25c6b1$export$d6a64179aa36abc6().map((m)=>m.id);
    if (ids.length === 0) return false;
    const last = $bc803f7cdb25c6b1$var$readUpdates();
    if (last && now - last.checkedAt >= 0 && now - last.checkedAt < $bc803f7cdb25c6b1$var$UPDATE_CHECK_INTERVAL_MS) return false;
    try {
        const res = await fetch(`${apiBase}/api/external/maps/versions?ids=${ids.join(',')}`);
        if (!res.ok) return false;
        const body = await res.json();
        if (!$bc803f7cdb25c6b1$var$isObj(body) || !Array.isArray(body.maps)) return false;
        const maps = {};
        for (const m of body.maps){
            if (!$bc803f7cdb25c6b1$var$isObj(m) || typeof m.id !== 'string' || !$bc803f7cdb25c6b1$export$e6f5a94bd4b1cb2d.test(m.id)) continue;
            maps[m.id] = {
                version: $bc803f7cdb25c6b1$var$isNum(m.version) ? m.version : null,
                available: m.available === true
            };
        }
        localStorage.setItem($bc803f7cdb25c6b1$export$1676d593f4b89274, JSON.stringify({
            checkedAt: now,
            maps: maps
        }));
        return true;
    } catch  {
        return false;
    }
}
function $bc803f7cdb25c6b1$export$8b02ff41fd78c74f(id, state) {
    const last = $bc803f7cdb25c6b1$var$readUpdates();
    if (!last) return;
    try {
        localStorage.setItem($bc803f7cdb25c6b1$export$1676d593f4b89274, JSON.stringify({
            ...last,
            maps: {
                ...last.maps,
                [id]: state
            }
        }));
    } catch  {
    // 다음 확인 때 맞춰진다
    }
}


// 설정창의 맵 선택. 기본 맵과 맵 공유마당에서 받은 맵을 함께 보여준다.
//
// - 선택한 맵은 localStorage 에 기억해서 다음 방문에도 유지한다.
// - ?installMap={id} 로 들어오면 맵을 받아 설치하고 바로 선택한다 (맵 공유마당의 "마블룰렛에 설치" 버튼).
// - "맵 더 받기"(+) 버튼은 게임 안의 맵 브라우저를 연다 (mapBrowser.ts). 받은 맵에 업데이트가 있으면 버튼에 점을 찍는다.
// - 받은 맵의 제목과 저작자는 사용자가 입력한 문자열이라 innerHTML 에 넣지 않는다.

const $b2abafc93d11a512$export$1bfcff8d7c4bf05 = [
    {
        title: 'Wheel of fortune',
        goalY: 111,
        zoomY: 106.75,
        adBoards: [
            {
                x: 15.92,
                y: 104.3,
                w: 5,
                h: 1.25
            }
        ],
        entities: [
            // polyline
            {
                position: {
                    x: 0,
                    y: 0
                },
                shape: {
                    type: 'polyline',
                    points: [
                        [
                            16.5,
                            -300
                        ],
                        [
                            9.25,
                            -300
                        ],
                        [
                            9.25,
                            8.5
                        ],
                        [
                            2,
                            19.25
                        ],
                        [
                            2,
                            26
                        ],
                        [
                            9.75,
                            30
                        ],
                        [
                            9.75,
                            33.5
                        ],
                        [
                            1.25,
                            41
                        ],
                        [
                            1.25,
                            53.75
                        ],
                        [
                            8.25,
                            58.75
                        ],
                        [
                            8.25,
                            63
                        ],
                        [
                            9.25,
                            64
                        ],
                        [
                            8.25,
                            65
                        ],
                        [
                            8.25,
                            99.25
                        ],
                        [
                            15.1,
                            106.75
                        ],
                        [
                            15.1,
                            111.75
                        ]
                    ],
                    rotation: 0
                },
                type: 'static',
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                type: 'static',
                position: {
                    x: 0,
                    y: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                },
                shape: {
                    type: 'polyline',
                    rotation: 0,
                    points: [
                        [
                            16.5,
                            -300
                        ],
                        [
                            16.5,
                            9.25
                        ],
                        [
                            9.5,
                            20
                        ],
                        [
                            9.5,
                            22.5
                        ],
                        [
                            17.5,
                            26
                        ],
                        [
                            17.5,
                            33.5
                        ],
                        [
                            24,
                            38.5
                        ],
                        [
                            19,
                            45.5
                        ],
                        [
                            19,
                            55.5
                        ],
                        [
                            24,
                            59.25
                        ],
                        [
                            24,
                            63
                        ],
                        [
                            23,
                            64
                        ],
                        [
                            24,
                            65
                        ],
                        [
                            24,
                            100.5
                        ],
                        [
                            16,
                            106.75
                        ],
                        [
                            16,
                            111.75
                        ]
                    ]
                }
            },
            {
                type: 'static',
                position: {
                    x: 0,
                    y: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                },
                shape: {
                    type: 'polyline',
                    rotation: 0,
                    points: [
                        [
                            12.75,
                            37.5
                        ],
                        [
                            7,
                            43.5
                        ],
                        [
                            7,
                            49.75
                        ],
                        [
                            12.75,
                            53.75
                        ],
                        [
                            12.75,
                            37.5
                        ]
                    ]
                }
            },
            {
                type: 'static',
                position: {
                    x: 0,
                    y: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                },
                shape: {
                    type: 'polyline',
                    rotation: 0,
                    points: [
                        [
                            14.75,
                            37.5
                        ],
                        [
                            14.75,
                            43
                        ],
                        [
                            17.5,
                            40.25
                        ],
                        [
                            14.75,
                            37.5
                        ]
                    ]
                }
            },
            // boxes
            {
                position: {
                    x: 15.5,
                    y: 30.0
                },
                shape: {
                    type: 'box',
                    width: 0.2,
                    height: 0.2,
                    rotation: -45
                },
                type: 'static',
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 1
                }
            },
            {
                position: {
                    x: 15.5,
                    y: 32
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.2,
                    height: 0.2,
                    rotation: -45
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 15.5,
                    y: 28
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.2,
                    height: 0.2,
                    rotation: -45
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 12.5,
                    y: 30
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.2,
                    height: 0.2,
                    rotation: -45
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 12.5,
                    y: 32
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.2,
                    height: 0.2,
                    rotation: -45
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 12.5,
                    y: 28
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.2,
                    height: 0.2,
                    rotation: -45
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 9.4,
                    y: 66.6
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.6,
                    height: 0.1,
                    rotation: 45
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 11.3,
                    y: 66.6
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.6,
                    height: 0.1,
                    rotation: 45
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 13.2,
                    y: 66.6
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.6,
                    height: 0.1,
                    rotation: 45
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 15.1,
                    y: 66.6
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.6,
                    height: 0.1,
                    rotation: 45
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 17,
                    y: 66.6
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.6,
                    height: 0.1,
                    rotation: 45
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 18.9,
                    y: 66.6
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.6,
                    height: 0.1,
                    rotation: 45
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 20.699999999999996,
                    y: 66.6
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.6,
                    height: 0.1,
                    rotation: 45
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 22.7,
                    y: 66.6
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.6,
                    height: 0.1,
                    rotation: 45
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 9.4,
                    y: 69.1
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.6,
                    height: 0.1,
                    rotation: -45
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 11.3,
                    y: 69.1
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.6,
                    height: 0.1,
                    rotation: -45
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 13.2,
                    y: 69.1
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.6,
                    height: 0.1,
                    rotation: -45
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 15.1,
                    y: 69.1
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.6,
                    height: 0.1,
                    rotation: -45
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 17,
                    y: 69.1
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.6,
                    height: 0.1,
                    rotation: -45
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 18.9,
                    y: 69.1
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.6,
                    height: 0.1,
                    rotation: -45
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 20.699999999999996,
                    y: 69.1
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.6,
                    height: 0.1,
                    rotation: -45
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 22.7,
                    y: 69.1
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.6,
                    height: 0.1,
                    rotation: -45
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 9.5,
                    y: 92
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.25,
                    height: 0.25,
                    rotation: 0.7853981633974483
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 12.75,
                    y: 92
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.25,
                    height: 0.25,
                    rotation: 0.7853981633974483
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 16,
                    y: 92
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.25,
                    height: 0.25,
                    rotation: 0.7853981633974483
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 19.25,
                    y: 92
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.25,
                    height: 0.25,
                    rotation: 0.7853981633974483
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 22.5,
                    y: 92
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.25,
                    height: 0.25,
                    rotation: 0.7853981633974483
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 11,
                    y: 95
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.25,
                    height: 0.25,
                    rotation: 0.7853981633974483
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 14.25,
                    y: 95
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.25,
                    height: 0.25,
                    rotation: 0.7853981633974483
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 17.5,
                    y: 95
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.25,
                    height: 0.25,
                    rotation: 0.7853981633974483
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 20.75,
                    y: 95
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.25,
                    height: 0.25,
                    rotation: 0.7853981633974483
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 9.5,
                    y: 98
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.25,
                    height: 0.25,
                    rotation: 0.7853981633974483
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 12.75,
                    y: 98
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.25,
                    height: 0.25,
                    rotation: 0.7853981633974483
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 16,
                    y: 98
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.25,
                    height: 0.25,
                    rotation: 0.7853981633974483
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 19.25,
                    y: 98
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.25,
                    height: 0.25,
                    rotation: 0.7853981633974483
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 22.5,
                    y: 98
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.25,
                    height: 0.25,
                    rotation: 0.7853981633974483
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            // wheels
            {
                position: {
                    x: 8,
                    y: 75
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 3.5,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 12,
                    y: 75
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: -3.5,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 16,
                    y: 75
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 3.5,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 20,
                    y: 75
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: -3.5,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 24,
                    y: 75
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 3.5,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 14,
                    y: 106.75
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: -1.2,
                    restitution: 0
                }
            }
        ]
    },
    {
        title: 'BubblePop',
        goalY: 83,
        zoomY: 78,
        adBoards: [
            {
                y: 80.5,
                x: 10
            },
            {
                y: 80.5,
                x: 15.05
            }
        ],
        entities: [
            {
                type: 'static',
                position: {
                    x: 10.375,
                    y: -108.5
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 0
                },
                shape: {
                    type: 'polyline',
                    rotation: 0,
                    points: [
                        [
                            6.125,
                            -191.5
                        ],
                        [
                            -1.125,
                            -191.5
                        ],
                        [
                            -1.125,
                            108.5
                        ],
                        [
                            -1.125,
                            151.5
                        ],
                        [
                            -6.125,
                            158.5
                        ],
                        [
                            -1.125,
                            161.5
                        ],
                        [
                            -1.125,
                            179.5
                        ],
                        [
                            -0.9128679656440362,
                            179.7498817789222
                        ],
                        [
                            -1.125,
                            179.9997635578444
                        ],
                        [
                            -1.125,
                            183.5
                        ],
                        [
                            1.625,
                            188.5
                        ],
                        [
                            1.625,
                            191.5
                        ]
                    ]
                }
            },
            {
                type: 'static',
                position: {
                    x: 16.25,
                    y: -108.5
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 0
                },
                shape: {
                    type: 'polyline',
                    rotation: 0,
                    points: [
                        [
                            0.25,
                            -191.5
                        ],
                        [
                            0.25,
                            158.5
                        ],
                        [
                            3.25,
                            162.5
                        ],
                        [
                            2.25,
                            164.5
                        ],
                        [
                            3.25,
                            166.5
                        ],
                        [
                            0.25,
                            169.5
                        ],
                        [
                            0.25,
                            179.5
                        ],
                        [
                            0.03786796564403616,
                            179.75925677892224
                        ],
                        [
                            0.25,
                            179.9997635578444
                        ],
                        [
                            0.25,
                            183.5
                        ],
                        [
                            -3.25,
                            188.5
                        ],
                        [
                            -3.25,
                            191.5
                        ]
                    ]
                }
            },
            {
                type: 'static',
                position: {
                    x: 16.5,
                    y: 55.75
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 0
                },
                shape: {
                    type: 'polyline',
                    rotation: 0,
                    points: [
                        [
                            0,
                            -3.25
                        ],
                        [
                            1,
                            -1.75
                        ],
                        [
                            0,
                            0.25
                        ],
                        [
                            1,
                            2.25
                        ],
                        [
                            0,
                            3.25
                        ],
                        [
                            -1,
                            0.25
                        ],
                        [
                            0,
                            -3.25
                        ]
                    ]
                }
            },
            {
                type: 'static',
                position: {
                    x: 10.375,
                    y: 48.25
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 0
                },
                shape: {
                    type: 'polyline',
                    rotation: 0,
                    points: [
                        [
                            -1.125,
                            -2.75
                        ],
                        [
                            -4.125,
                            1.25
                        ],
                        [
                            -1.125,
                            2.75
                        ],
                        [
                            4.125,
                            2.25
                        ],
                        [
                            -1.125,
                            -2.75
                        ]
                    ]
                }
            },
            {
                type: 'static',
                position: {
                    x: 10.15625,
                    y: 26.75
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 0
                },
                shape: {
                    type: 'polyline',
                    rotation: 0,
                    points: [
                        [
                            -0.90625,
                            -0.75
                        ],
                        [
                            0.90625,
                            0.75
                        ]
                    ]
                }
            },
            {
                type: 'static',
                position: {
                    x: 15.59375,
                    y: 26.75
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 0
                },
                shape: {
                    type: 'polyline',
                    rotation: 0,
                    points: [
                        [
                            0.90625,
                            -0.75
                        ],
                        [
                            -0.90625,
                            0.75
                        ]
                    ]
                }
            },
            {
                type: 'static',
                position: {
                    x: 12.875,
                    y: 29.25
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 0
                },
                shape: {
                    type: 'polyline',
                    rotation: 0,
                    points: [
                        [
                            -1.8125,
                            0.75
                        ],
                        [
                            0,
                            -0.75
                        ],
                        [
                            1.8125,
                            0.75
                        ]
                    ]
                }
            },
            {
                type: 'static',
                position: {
                    x: 10.15625,
                    y: 31.75
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 0
                },
                shape: {
                    type: 'polyline',
                    rotation: 0,
                    points: [
                        [
                            -0.90625,
                            -0.75
                        ],
                        [
                            0.90625,
                            0.75
                        ]
                    ]
                }
            },
            {
                type: 'static',
                position: {
                    x: 15.59375,
                    y: 31.75
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 0
                },
                shape: {
                    type: 'polyline',
                    rotation: 0,
                    points: [
                        [
                            0.90625,
                            -0.75
                        ],
                        [
                            -0.90625,
                            0.75
                        ]
                    ]
                }
            },
            {
                type: 'static',
                position: {
                    x: 12.875,
                    y: 34.25
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 0
                },
                shape: {
                    type: 'polyline',
                    rotation: 0,
                    points: [
                        [
                            -1.8125,
                            0.75
                        ],
                        [
                            0,
                            -0.75
                        ],
                        [
                            1.8125,
                            0.75
                        ]
                    ]
                }
            },
            {
                type: 'static',
                position: {
                    x: 9.25,
                    y: 18
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 0
                },
                shape: {
                    type: 'box',
                    rotation: 0.7853981633974483,
                    width: 0.15,
                    height: 0.15
                }
            },
            {
                type: 'static',
                position: {
                    x: 11.25,
                    y: 18
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 0
                },
                shape: {
                    type: 'box',
                    rotation: 0.7853981633974483,
                    width: 0.15,
                    height: 0.15
                }
            },
            {
                type: 'static',
                position: {
                    x: 13.25,
                    y: 18
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 0
                },
                shape: {
                    type: 'box',
                    rotation: 0.7853981633974483,
                    width: 0.15,
                    height: 0.15
                }
            },
            {
                type: 'static',
                position: {
                    x: 15.25,
                    y: 18
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 0
                },
                shape: {
                    type: 'box',
                    rotation: 0.7853981633974483,
                    width: 0.15,
                    height: 0.15
                }
            },
            {
                type: 'static',
                position: {
                    x: 10.5,
                    y: 19
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 0
                },
                shape: {
                    type: 'box',
                    rotation: 0.7853981633974483,
                    width: 0.15,
                    height: 0.15
                }
            },
            {
                type: 'static',
                position: {
                    x: 12.5,
                    y: 19
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 0
                },
                shape: {
                    type: 'box',
                    rotation: 0.7853981633974483,
                    width: 0.15,
                    height: 0.15
                }
            },
            {
                type: 'static',
                position: {
                    x: 14.5,
                    y: 19
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 0
                },
                shape: {
                    type: 'box',
                    rotation: 0.7853981633974483,
                    width: 0.15,
                    height: 0.15
                }
            },
            {
                type: 'static',
                position: {
                    x: 16.5,
                    y: 19
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 0
                },
                shape: {
                    type: 'box',
                    rotation: 0.7853981633974483,
                    width: 0.15,
                    height: 0.15
                }
            },
            {
                type: 'static',
                position: {
                    x: 9.25,
                    y: 20
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 0
                },
                shape: {
                    type: 'box',
                    rotation: 0.7853981633974483,
                    width: 0.15,
                    height: 0.15
                }
            },
            {
                type: 'static',
                position: {
                    x: 11.25,
                    y: 20
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 0
                },
                shape: {
                    type: 'box',
                    rotation: 0.7853981633974483,
                    width: 0.15,
                    height: 0.15
                }
            },
            {
                type: 'static',
                position: {
                    x: 13.25,
                    y: 20
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 0
                },
                shape: {
                    type: 'box',
                    rotation: 0.7853981633974483,
                    width: 0.15,
                    height: 0.15
                }
            },
            {
                type: 'static',
                position: {
                    x: 15.25,
                    y: 20
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 0
                },
                shape: {
                    type: 'box',
                    rotation: 0.7853981633974483,
                    width: 0.15,
                    height: 0.15
                }
            },
            {
                type: 'static',
                position: {
                    x: 10.5,
                    y: 21
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 0
                },
                shape: {
                    type: 'box',
                    rotation: 0.7853981633974483,
                    width: 0.15,
                    height: 0.15
                }
            },
            {
                type: 'static',
                position: {
                    x: 12.5,
                    y: 21
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 0
                },
                shape: {
                    type: 'box',
                    rotation: 0.7853981633974483,
                    width: 0.15,
                    height: 0.15
                }
            },
            {
                type: 'static',
                position: {
                    x: 14.5,
                    y: 21
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 0
                },
                shape: {
                    type: 'box',
                    rotation: 0.7853981633974483,
                    width: 0.15,
                    height: 0.15
                }
            },
            {
                type: 'static',
                position: {
                    x: 16.5,
                    y: 21
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 0
                },
                shape: {
                    type: 'box',
                    rotation: 0.7853981633974483,
                    width: 0.15,
                    height: 0.15
                }
            },
            {
                type: 'static',
                position: {
                    x: 9.25,
                    y: 22
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 0
                },
                shape: {
                    type: 'box',
                    rotation: 0.7853981633974483,
                    width: 0.15,
                    height: 0.15
                }
            },
            {
                type: 'static',
                position: {
                    x: 11.25,
                    y: 22
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 0
                },
                shape: {
                    type: 'box',
                    rotation: 0.7853981633974483,
                    width: 0.15,
                    height: 0.15
                }
            },
            {
                type: 'static',
                position: {
                    x: 13.25,
                    y: 22
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 0
                },
                shape: {
                    type: 'box',
                    rotation: 0.7853981633974483,
                    width: 0.15,
                    height: 0.15
                }
            },
            {
                type: 'static',
                position: {
                    x: 15.25,
                    y: 22
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 0
                },
                shape: {
                    type: 'box',
                    rotation: 0.7853981633974483,
                    width: 0.15,
                    height: 0.15
                }
            },
            {
                type: 'static',
                position: {
                    x: 10.5,
                    y: 23
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 0
                },
                shape: {
                    type: 'box',
                    rotation: 0.7853981633974483,
                    width: 0.15,
                    height: 0.15
                }
            },
            {
                type: 'static',
                position: {
                    x: 12.5,
                    y: 23
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 0
                },
                shape: {
                    type: 'box',
                    rotation: 0.7853981633974483,
                    width: 0.15,
                    height: 0.15
                }
            },
            {
                type: 'static',
                position: {
                    x: 14.5,
                    y: 23
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 0
                },
                shape: {
                    type: 'box',
                    rotation: 0.7853981633974483,
                    width: 0.15,
                    height: 0.15
                }
            },
            {
                type: 'static',
                position: {
                    x: 16.5,
                    y: 23
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 0
                },
                shape: {
                    type: 'box',
                    rotation: 0.7853981633974483,
                    width: 0.15,
                    height: 0.15
                }
            },
            {
                type: 'static',
                position: {
                    x: 9.400000000000002,
                    y: 39
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 0
                },
                shape: {
                    type: 'box',
                    rotation: 0.7853981633974483,
                    width: 3,
                    height: 3
                }
            },
            {
                type: 'static',
                position: {
                    x: 16.5,
                    y: 43
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 0
                },
                shape: {
                    type: 'box',
                    rotation: 0.7853981633974483,
                    width: 3,
                    height: 3
                }
            },
            {
                type: 'kinematic',
                position: {
                    x: 10.7,
                    y: 10
                },
                props: {
                    angularVelocity: 10,
                    density: 1,
                    restitution: 0
                },
                shape: {
                    type: 'box',
                    rotation: 0,
                    width: 0.5,
                    height: 0.1
                }
            },
            {
                type: 'kinematic',
                position: {
                    x: 14.7,
                    y: 10
                },
                props: {
                    angularVelocity: -10,
                    density: 1,
                    restitution: 0
                },
                shape: {
                    type: 'box',
                    rotation: 0,
                    width: 0.5,
                    height: 0.1
                }
            },
            {
                type: 'kinematic',
                position: {
                    x: 12.7,
                    y: 10
                },
                props: {
                    angularVelocity: 10,
                    density: 1,
                    restitution: 0
                },
                shape: {
                    type: 'box',
                    rotation: 0,
                    width: 0.5,
                    height: 0.1
                }
            },
            {
                type: 'kinematic',
                position: {
                    x: 10.7,
                    y: 14
                },
                props: {
                    angularVelocity: -3,
                    density: 1,
                    restitution: 0
                },
                shape: {
                    type: 'box',
                    rotation: 0,
                    width: 2,
                    height: 0.1
                }
            },
            {
                type: 'kinematic',
                position: {
                    x: 14.7,
                    y: 14
                },
                props: {
                    angularVelocity: 3,
                    density: 1,
                    restitution: 0
                },
                shape: {
                    type: 'box',
                    rotation: 0,
                    width: 2,
                    height: 0.1
                }
            },
            {
                type: 'kinematic',
                position: {
                    x: 11.2,
                    y: 44
                },
                props: {
                    angularVelocity: -5,
                    density: 1,
                    restitution: 0
                },
                shape: {
                    type: 'box',
                    rotation: 0,
                    width: 0.5,
                    height: 0.1
                }
            },
            {
                type: 'kinematic',
                position: {
                    x: 10.3,
                    y: 75
                },
                props: {
                    angularVelocity: 8,
                    density: 1,
                    restitution: 0
                },
                shape: {
                    type: 'box',
                    rotation: 0,
                    width: 1,
                    height: 0.1
                }
            },
            {
                type: 'kinematic',
                position: {
                    x: 15.462132034355964,
                    y: 75
                },
                props: {
                    angularVelocity: -8,
                    density: 1,
                    restitution: 0
                },
                shape: {
                    type: 'box',
                    rotation: 0,
                    width: 1,
                    height: 0.1
                }
            },
            {
                type: 'static',
                position: {
                    x: 11,
                    y: 65
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                },
                shape: {
                    type: 'circle',
                    radius: 0.5
                }
            },
            {
                type: 'static',
                position: {
                    x: 13,
                    y: 65
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                },
                shape: {
                    type: 'circle',
                    radius: 0.5
                }
            },
            {
                type: 'static',
                position: {
                    x: 15,
                    y: 65
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                },
                shape: {
                    type: 'circle',
                    radius: 0.5
                }
            },
            {
                type: 'static',
                position: {
                    x: 12,
                    y: 67.5
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                },
                shape: {
                    type: 'circle',
                    radius: 0.5
                }
            },
            {
                type: 'static',
                position: {
                    x: 14,
                    y: 67.5
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                },
                shape: {
                    type: 'circle',
                    radius: 0.5
                }
            },
            {
                type: 'static',
                position: {
                    x: 13,
                    y: 69.77058813837772
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                },
                shape: {
                    type: 'circle',
                    radius: 0.8
                }
            },
            {
                type: 'static',
                position: {
                    x: 10.7,
                    y: 77.5
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                },
                shape: {
                    type: 'circle',
                    radius: 0.8
                }
            },
            {
                type: 'static',
                position: {
                    x: 14.7,
                    y: 77.5
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                },
                shape: {
                    type: 'circle',
                    radius: 0.8
                }
            },
            {
                type: 'static',
                position: {
                    x: 12.625,
                    y: 80
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                },
                shape: {
                    type: 'circle',
                    radius: 1.5
                }
            },
            {
                type: 'static',
                position: {
                    x: 12.625,
                    y: 80
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                },
                shape: {
                    type: 'circle',
                    radius: 1.2
                }
            },
            {
                type: 'kinematic',
                position: {
                    x: 12.625,
                    y: 56.00000000000001
                },
                props: {
                    angularVelocity: -8,
                    density: 1,
                    restitution: 0
                },
                shape: {
                    type: 'box',
                    rotation: 0,
                    width: 1,
                    height: 0.1
                }
            },
            {
                type: 'static',
                position: {
                    x: 9.947604593262161,
                    y: 62.59581680393866
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                },
                shape: {
                    type: 'circle',
                    radius: 0.5
                }
            },
            {
                type: 'static',
                position: {
                    x: 11.947604593262161,
                    y: 62.59581680393866
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                },
                shape: {
                    type: 'circle',
                    radius: 0.5
                }
            },
            {
                type: 'static',
                position: {
                    x: 13.947604593262161,
                    y: 62.59581680393866
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                },
                shape: {
                    type: 'circle',
                    radius: 0.5
                }
            },
            {
                type: 'static',
                position: {
                    x: 15.828283102570442,
                    y: 62.59581680393866
                },
                props: {
                    angularVelocity: 0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                },
                shape: {
                    type: 'circle',
                    radius: 0.5
                }
            }
        ]
    },
    {
        title: 'Pot of greed',
        goalY: 91,
        zoomY: 92.5,
        adBoards: [
            {
                x: 13.0,
                y: 75.5,
                w: 9.5,
                h: 2.375
            }
        ],
        // 바닥에 빠졌다 양옆으로 올라오는 구슬을 따라가면 화면 아래 빈 곳만 보이니 항아리 전체를 보여 준다
        cameraZones: [
            {
                x: 13,
                y: 74,
                w: 24,
                h: 28
            }
        ],
        zoomZones: [
            {
                x: 13,
                y: 77,
                w: 8,
                h: 10
            }
        ],
        entities: [
            {
                type: 'static',
                position: {
                    x: 0,
                    y: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                },
                shape: {
                    type: 'polyline',
                    rotation: 0,
                    points: [
                        [
                            17,
                            -300
                        ],
                        [
                            9,
                            -300
                        ],
                        [
                            9,
                            8.5
                        ],
                        [
                            2,
                            15
                        ],
                        [
                            6,
                            61.5
                        ]
                    ]
                }
            },
            {
                type: 'static',
                position: {
                    x: 0,
                    y: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                },
                shape: {
                    type: 'polyline',
                    rotation: 0,
                    points: [
                        [
                            7,
                            67.2
                        ],
                        [
                            9,
                            85.2
                        ],
                        [
                            8,
                            84.9
                        ],
                        [
                            6,
                            84.6
                        ],
                        [
                            5,
                            78.6
                        ],
                        [
                            4,
                            66.6
                        ],
                        [
                            7,
                            67.2
                        ]
                    ]
                }
            },
            {
                type: 'static',
                position: {
                    x: 0,
                    y: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                },
                shape: {
                    type: 'polyline',
                    rotation: 0,
                    points: [
                        [
                            17,
                            -300
                        ],
                        [
                            17,
                            8.5
                        ],
                        [
                            24,
                            15
                        ],
                        [
                            20,
                            61.5
                        ]
                    ]
                }
            },
            {
                type: 'static',
                position: {
                    x: 0,
                    y: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                },
                shape: {
                    type: 'polyline',
                    rotation: 0,
                    points: [
                        [
                            19,
                            67.2
                        ],
                        [
                            17,
                            85.2
                        ],
                        [
                            18,
                            84.9
                        ],
                        [
                            20,
                            84.6
                        ],
                        [
                            21,
                            78.6
                        ],
                        [
                            22,
                            66.6
                        ],
                        [
                            19,
                            67.2
                        ]
                    ]
                }
            },
            {
                type: 'static',
                position: {
                    x: 0,
                    y: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                },
                shape: {
                    type: 'polyline',
                    rotation: 0,
                    points: [
                        [
                            11,
                            77.4
                        ],
                        [
                            12,
                            78.6
                        ],
                        [
                            12,
                            91.8
                        ]
                    ]
                }
            },
            {
                type: 'static',
                position: {
                    x: 0,
                    y: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                },
                shape: {
                    type: 'polyline',
                    rotation: 0,
                    points: [
                        [
                            15,
                            77.4
                        ],
                        [
                            14,
                            78.6
                        ],
                        [
                            14,
                            91.8
                        ]
                    ]
                }
            },
            {
                type: 'static',
                position: {
                    x: 0,
                    y: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                },
                shape: {
                    type: 'polyline',
                    rotation: 0,
                    points: [
                        [
                            12,
                            85.8
                        ],
                        [
                            11,
                            86.4
                        ],
                        [
                            9,
                            87
                        ],
                        [
                            8,
                            87
                        ],
                        [
                            6,
                            86.4
                        ],
                        [
                            5,
                            85.8
                        ],
                        [
                            4,
                            84.6
                        ],
                        [
                            3,
                            78.6
                        ],
                        [
                            2,
                            66.6
                        ],
                        [
                            3,
                            63.6
                        ],
                        [
                            4,
                            62.4
                        ],
                        [
                            5,
                            61.8
                        ],
                        [
                            6,
                            61.5
                        ]
                    ]
                }
            },
            {
                type: 'static',
                position: {
                    x: 0,
                    y: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                },
                shape: {
                    type: 'polyline',
                    rotation: 0,
                    points: [
                        [
                            14,
                            85.8
                        ],
                        [
                            15,
                            86.4
                        ],
                        [
                            17,
                            87
                        ],
                        [
                            18,
                            87
                        ],
                        [
                            20,
                            86.4
                        ],
                        [
                            21,
                            85.8
                        ],
                        [
                            22,
                            84.6
                        ],
                        [
                            23,
                            78.6
                        ],
                        [
                            24,
                            66.6
                        ],
                        [
                            23,
                            63.6
                        ],
                        [
                            22,
                            62.4
                        ],
                        [
                            21,
                            61.8
                        ],
                        [
                            20,
                            61.5
                        ]
                    ]
                }
            },
            {
                position: {
                    x: 13,
                    y: 20
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 3,
                    height: 3,
                    rotation: 0.7853981633974483
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 13,
                    y: 55
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 3,
                    height: 3,
                    rotation: 0.7853981633974483
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 8,
                    y: 37
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 2,
                    rotation: 0.7853981633974483
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 18,
                    y: 37
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 2,
                    rotation: 0.7853981633974483
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 11,
                    y: 12
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: -3,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 15,
                    y: 12
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 3,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 8,
                    y: 87
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 1,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: -10,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 6,
                    y: 86.4
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 1.5,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: -10,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 4,
                    y: 84.6
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 1.5,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: -10,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 3.5,
                    y: 81.6
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: -10,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 3,
                    y: 78.6
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: -10,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 2.75,
                    y: 75.6
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: -10,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 2.5,
                    y: 72.6
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: -10,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 2.25,
                    y: 69.6
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: -10,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 2,
                    y: 66.6
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: -10,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 18,
                    y: 87
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 1,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 10,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 20,
                    y: 86.4
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 1.5,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 10,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 22,
                    y: 84.6
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 1.5,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 10,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 22.5,
                    y: 81.6
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 10,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 23,
                    y: 78.6
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 10,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 23.25,
                    y: 75.6
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 10,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 23.5,
                    y: 72.6
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 10,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 23.75,
                    y: 69.6
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 10,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 24,
                    y: 66.6
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0
                },
                props: {
                    density: 1,
                    angularVelocity: 10,
                    restitution: 0
                }
            }
        ]
    },
    {
        title: 'Yoru ni Kakeru',
        goalY: 248,
        zoomY: 234.5,
        adBoards: [
            {
                x: 11.5,
                y: 12,
                w: 16,
                h: 4
            },
            {
                x: 11.5,
                y: 155,
                w: 16,
                h: 4
            }
        ],
        entities: [
            {
                position: {
                    x: 2,
                    y: 0
                },
                shape: {
                    type: 'box',
                    width: 1,
                    height: 800,
                    rotation: 0,
                    color: '#222',
                    bloomColor: '#777'
                },
                type: 'static',
                props: {
                    density: 500,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                type: 'static',
                position: {
                    x: 21,
                    y: 0
                },
                props: {
                    density: 500,
                    angularVelocity: 0,
                    restitution: 0
                },
                shape: {
                    type: 'box',
                    rotation: 0,
                    width: 1,
                    height: 800,
                    color: '#222',
                    bloomColor: '#777'
                }
            },
            {
                position: {
                    x: 4.0,
                    y: 25.0
                },
                shape: {
                    type: 'box',
                    width: 0.2,
                    height: 0.2,
                    rotation: -45,
                    color: '#818fb4'
                },
                type: 'static',
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 1
                }
            },
            {
                position: {
                    x: 4.0,
                    y: 30.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.2,
                    height: 0.2,
                    rotation: -45,
                    color: '#818fb4'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 4.0,
                    y: 35.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.2,
                    height: 0.2,
                    rotation: -45,
                    color: '#818fb4'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 4.0,
                    y: 40.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.2,
                    height: 0.2,
                    rotation: -45,
                    color: '#818fb4'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 9.0,
                    y: 25.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.2,
                    height: 0.2,
                    rotation: -45,
                    color: '#818fb4'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 9.0,
                    y: 30.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.2,
                    height: 0.2,
                    rotation: -45,
                    color: '#818fb4'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 9.0,
                    y: 35.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.2,
                    height: 0.2,
                    rotation: -45,
                    color: '#818fb4'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 9.0,
                    y: 40.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.2,
                    height: 0.2,
                    rotation: -45,
                    color: '#818fb4'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 14.0,
                    y: 25.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.2,
                    height: 0.2,
                    rotation: -45,
                    color: '#818fb4'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 14.0,
                    y: 30.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.2,
                    height: 0.2,
                    rotation: -45,
                    color: '#818fb4'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 14.0,
                    y: 35.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.2,
                    height: 0.2,
                    rotation: -45,
                    color: '#818fb4'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 14.0,
                    y: 40.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.2,
                    height: 0.2,
                    rotation: -45,
                    color: '#818fb4'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 19.0,
                    y: 25.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.2,
                    height: 0.2,
                    rotation: -45,
                    color: '#818fb4'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 19.0,
                    y: 30.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.2,
                    height: 0.2,
                    rotation: -45,
                    color: '#818fb4'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 19.0,
                    y: 35.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.2,
                    height: 0.2,
                    rotation: -45,
                    color: '#818fb4'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 19.0,
                    y: 40.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.2,
                    height: 0.2,
                    rotation: -45,
                    color: '#818fb4'
                },
                props: {
                    density: 1,
                    angularVelocity: 0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 6.5,
                    y: 27.5
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0,
                    color: '#9bec00'
                },
                props: {
                    density: 1,
                    angularVelocity: 2.0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 6.5,
                    y: 37.5
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0,
                    color: '#ff6868'
                },
                props: {
                    density: 1,
                    angularVelocity: 2.0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 11.5,
                    y: 32.5
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0,
                    color: '#80b3ff'
                },
                props: {
                    density: 2,
                    angularVelocity: 4.0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 16.5,
                    y: 27.5
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0,
                    color: '#ff6868'
                },
                props: {
                    density: 1,
                    angularVelocity: -2,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 16.5,
                    y: 37.5
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 2,
                    height: 0.1,
                    rotation: 0,
                    color: '#9bec00'
                },
                props: {
                    density: 1,
                    angularVelocity: -2,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 10.0,
                    y: 26.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 11.5,
                    y: 26.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 13.0,
                    y: 26.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 10.0,
                    y: 27.5
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 11.5,
                    y: 27.5
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 13.0,
                    y: 27.5
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 10.0,
                    y: 29.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 11.5,
                    y: 29.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 13.0,
                    y: 29.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 5.0,
                    y: 31.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 6.5,
                    y: 31.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 8.0,
                    y: 31.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 5.0,
                    y: 32.5
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 6.5,
                    y: 32.5
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 8.0,
                    y: 32.5
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 5.0,
                    y: 34.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 6.5,
                    y: 34.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 8.0,
                    y: 34.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 15.0,
                    y: 31.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 16.5,
                    y: 31.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 18.0,
                    y: 31.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 15.0,
                    y: 32.5
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 16.5,
                    y: 32.5
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 18.0,
                    y: 32.5
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 15.0,
                    y: 34.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 16.5,
                    y: 34.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 18.0,
                    y: 34.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 10.0,
                    y: 36.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 11.5,
                    y: 36.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 13.0,
                    y: 36.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 10.0,
                    y: 37.5
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 11.5,
                    y: 37.5
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 13.0,
                    y: 37.5
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 10.0,
                    y: 39.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 11.5,
                    y: 39.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 13.0,
                    y: 39.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 11.5,
                    y: 50.0
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 6.5,
                    height: 0.1,
                    rotation: 0,
                    color: '#5c5470'
                },
                props: {
                    density: 1,
                    angularVelocity: -2,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 3.5,
                    y: 60.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 5.0,
                    y: 60.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 6.5,
                    y: 60.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 8.0,
                    y: 60.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 9.5,
                    y: 60.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 11.0,
                    y: 60.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 12.5,
                    y: 60.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 14.0,
                    y: 60.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 15.5,
                    y: 60.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 17.0,
                    y: 60.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 18.5,
                    y: 60.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 20.0,
                    y: 60.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 3.0,
                    y: 63.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ffe227'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 4.5,
                    y: 63.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ffe227'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 6.0,
                    y: 63.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ffe227'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 7.5,
                    y: 63.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ffe227'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 9.0,
                    y: 63.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ffe227'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 10.5,
                    y: 63.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ffe227'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 12.0,
                    y: 63.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ffe227'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 13.5,
                    y: 63.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ffe227'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 15.0,
                    y: 63.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ffe227'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 16.5,
                    y: 63.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ffe227'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 18.0,
                    y: 63.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ffe227'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 19.5,
                    y: 63.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ffe227'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 3.5,
                    y: 66.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 5.0,
                    y: 66.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 6.5,
                    y: 66.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 8.0,
                    y: 66.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 9.5,
                    y: 66.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 11.0,
                    y: 66.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 12.5,
                    y: 66.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 14.0,
                    y: 66.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 15.5,
                    y: 66.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 17.0,
                    y: 66.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 18.5,
                    y: 66.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 20.0,
                    y: 66.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#fff4b7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 4.5,
                    y: 75.0
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 4.0,
                    height: 0.1,
                    rotation: 0,
                    color: '#ff577f'
                },
                props: {
                    density: 1,
                    angularVelocity: -4,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 18.5,
                    y: 75.0
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 4.0,
                    height: 0.1,
                    rotation: 0,
                    color: '#ff577f'
                },
                props: {
                    density: 1,
                    angularVelocity: 4.0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 3.8,
                    y: 90.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#c7ffd8'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 19.2,
                    y: 90.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#c7ffd8'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 5.8,
                    y: 92.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#c7ffd8'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.2,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 17.2,
                    y: 92.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#c7ffd8'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.2,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 7.8,
                    y: 94.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#c7ffd8'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.4,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 15.2,
                    y: 94.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#c7ffd8'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.4,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 9.8,
                    y: 96.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#c7ffd8'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.6,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 13.2,
                    y: 96.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#c7ffd8'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.6,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 3.8,
                    y: 94.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#98ded9'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.2,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 19.2,
                    y: 94.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#98ded9'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.2,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 5.8,
                    y: 96.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#98ded9'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.4,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 17.2,
                    y: 96.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#98ded9'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.4,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 7.8,
                    y: 98.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#98ded9'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.6,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 15.2,
                    y: 98.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#98ded9'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.6,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 9.8,
                    y: 100.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#98ded9'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.8,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 13.2,
                    y: 100.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#98ded9'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.8,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 10.0,
                    y: 90.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ffe3fe'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 12.0,
                    y: 90.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ffe3fe'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 8.0,
                    y: 92.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ffe3fe'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 14.0,
                    y: 92.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ffe3fe'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 6.0,
                    y: 94.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ffe3fe'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 16.0,
                    y: 94.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ffe3fe'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 4.0,
                    y: 96.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ffe3fe'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 18.0,
                    y: 96.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ffe3fe'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 10.0,
                    y: 94.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ff94cc'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 12.0,
                    y: 94.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ff94cc'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 8.0,
                    y: 96.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ff94cc'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 14.0,
                    y: 96.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ff94cc'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 6.0,
                    y: 98.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ff94cc'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 16.0,
                    y: 98.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ff94cc'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 4.0,
                    y: 100.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ff94cc'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 18.0,
                    y: 100.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#ff94cc'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 4.5,
                    y: 100.0
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 5.0,
                    height: 0.1,
                    rotation: 0,
                    color: '#5c8374'
                },
                props: {
                    density: 1,
                    angularVelocity: -2.5,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 18.5,
                    y: 100.0
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 5.0,
                    height: 0.1,
                    rotation: 0,
                    color: '#5c8374'
                },
                props: {
                    density: 1,
                    angularVelocity: 2.5,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 3.8,
                    y: 104.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#c7ffd8'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.4,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 19.2,
                    y: 104.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#c7ffd8'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.4,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 5.8,
                    y: 106.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#c7ffd8'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.6,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 17.2,
                    y: 106.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#c7ffd8'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.6,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 7.8,
                    y: 108.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#c7ffd8'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.8,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 15.2,
                    y: 108.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#c7ffd8'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.8,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 9.8,
                    y: 110.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#c7ffd8'
                },
                props: {
                    density: 1,
                    angularVelocity: 2.0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 13.2,
                    y: 110.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#c7ffd8'
                },
                props: {
                    density: 1,
                    angularVelocity: 2.0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 3.8,
                    y: 108.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#98ded9'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.6,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 19.2,
                    y: 108.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#98ded9'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.6,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 5.8,
                    y: 110.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#98ded9'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.8,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 17.2,
                    y: 110.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#98ded9'
                },
                props: {
                    density: 1,
                    angularVelocity: 1.8,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 7.8,
                    y: 112.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#98ded9'
                },
                props: {
                    density: 1,
                    angularVelocity: 2.0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 15.2,
                    y: 112.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#98ded9'
                },
                props: {
                    density: 1,
                    angularVelocity: 2.0,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 9.8,
                    y: 114.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#98ded9'
                },
                props: {
                    density: 1,
                    angularVelocity: 2.2,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 13.2,
                    y: 114.0
                },
                type: 'static',
                shape: {
                    type: 'box',
                    width: 0.1,
                    height: 0.1,
                    rotation: -90,
                    color: '#98ded9'
                },
                props: {
                    density: 1,
                    angularVelocity: 2.2,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 3.5,
                    y: 105.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#edeef7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 19.5,
                    y: 105.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#edeef7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 3.5,
                    y: 107.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#edeef7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 19.5,
                    y: 107.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#edeef7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 5.5,
                    y: 107.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#edeef7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 17.5,
                    y: 107.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#edeef7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 3.5,
                    y: 109.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#edeef7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 19.5,
                    y: 109.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#edeef7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 5.5,
                    y: 109.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#edeef7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 17.5,
                    y: 109.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#edeef7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 7.5,
                    y: 109.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#edeef7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 15.5,
                    y: 109.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.5,
                    color: '#edeef7'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 5.5,
                    y: 115.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#e6176d'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 5
                }
            },
            {
                position: {
                    x: 17.5,
                    y: 115.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#e6176d'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 5
                }
            },
            {
                position: {
                    x: 5.5,
                    y: 115.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 1.2,
                    color: '#e64588'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 4
                }
            },
            {
                position: {
                    x: 17.5,
                    y: 115.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 1.2,
                    color: '#e64588'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 4
                }
            },
            {
                position: {
                    x: 5.5,
                    y: 115.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 2.0,
                    color: '#e673a3'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 3
                }
            },
            {
                position: {
                    x: 17.5,
                    y: 115.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 2.0,
                    color: '#e673a3'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 3
                }
            },
            {
                position: {
                    x: 5.5,
                    y: 115.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 2.8,
                    color: '#e6a1bd'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 2
                }
            },
            {
                position: {
                    x: 17.5,
                    y: 115.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 2.8,
                    color: '#e6a1bd'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 2
                }
            },
            {
                position: {
                    x: 5.5,
                    y: 115.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 3.8,
                    color: '#e6cfd8'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 17.5,
                    y: 115.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 3.8,
                    color: '#e6cfd8'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 11.5,
                    y: 120.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.4,
                    color: '#e6176d'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 5
                }
            },
            {
                position: {
                    x: 11.5,
                    y: 120.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 1.2,
                    color: '#e64588'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 4
                }
            },
            {
                position: {
                    x: 11.5,
                    y: 120.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 2.0,
                    color: '#e673a3'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 3
                }
            },
            {
                position: {
                    x: 11.5,
                    y: 120.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 2.8,
                    color: '#e6a1bd'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 2
                }
            },
            {
                position: {
                    x: 11.5,
                    y: 120.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 3.8,
                    color: '#e6cfd8'
                },
                props: {
                    angularVelocity: 0.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 4.5,
                    y: 130.0
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 5.0,
                    height: 0.1,
                    rotation: 0,
                    color: '#435585'
                },
                props: {
                    density: 1,
                    angularVelocity: 0.25,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 18.5,
                    y: 130.0
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 5.0,
                    height: 0.1,
                    rotation: 0,
                    color: '#5c8374'
                },
                props: {
                    density: 1,
                    angularVelocity: -0.32,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 4.5,
                    y: 140.0
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 4.0,
                    height: 0.1,
                    rotation: 30,
                    color: '#610c9f'
                },
                props: {
                    density: 1,
                    angularVelocity: 0.32,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 18.5,
                    y: 140.0
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 4.0,
                    height: 0.1,
                    rotation: -30,
                    color: '#872341'
                },
                props: {
                    density: 1,
                    angularVelocity: -0.32,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 4.5,
                    y: 150.0
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 5.0,
                    height: 0.1,
                    rotation: 60,
                    color: '#503c3c'
                },
                props: {
                    density: 1,
                    angularVelocity: 0.32,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 18.5,
                    y: 150.0
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 5.0,
                    height: 0.1,
                    rotation: -60,
                    color: '#5c5470'
                },
                props: {
                    density: 1,
                    angularVelocity: -0.32,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 4.5,
                    y: 160.0
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 4.0,
                    height: 0.1,
                    rotation: 90,
                    color: '#1a3636'
                },
                props: {
                    density: 1,
                    angularVelocity: 0.32,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 18.5,
                    y: 160.0
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 4.0,
                    height: 0.1,
                    rotation: -90,
                    color: '#522258'
                },
                props: {
                    density: 1,
                    angularVelocity: -0.32,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 3.5,
                    y: 135.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 4.5,
                    y: 135.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 5.5,
                    y: 135.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 6.5,
                    y: 135.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 7.5,
                    y: 135.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 8.5,
                    y: 135.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 9.5,
                    y: 135.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 10.5,
                    y: 135.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 11.5,
                    y: 135.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 12.5,
                    y: 135.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 13.5,
                    y: 135.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 14.5,
                    y: 135.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 15.5,
                    y: 135.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 16.5,
                    y: 135.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 17.5,
                    y: 135.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 18.5,
                    y: 135.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 19.5,
                    y: 135.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 3.5,
                    y: 140.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 4.5,
                    y: 140.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 5.5,
                    y: 140.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 6.5,
                    y: 140.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 7.5,
                    y: 140.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 8.5,
                    y: 140.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 9.5,
                    y: 140.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 10.5,
                    y: 140.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 11.5,
                    y: 140.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 12.5,
                    y: 140.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 13.5,
                    y: 140.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 14.5,
                    y: 140.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 15.5,
                    y: 140.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 16.5,
                    y: 140.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 17.5,
                    y: 140.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 18.5,
                    y: 140.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 19.5,
                    y: 140.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 3.5,
                    y: 144.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 4.5,
                    y: 144.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 5.5,
                    y: 144.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 6.5,
                    y: 144.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 7.5,
                    y: 144.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 8.5,
                    y: 144.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 9.5,
                    y: 144.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 10.5,
                    y: 144.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 11.5,
                    y: 144.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 12.5,
                    y: 144.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 13.5,
                    y: 144.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 14.5,
                    y: 144.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 15.5,
                    y: 144.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 16.5,
                    y: 144.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 17.5,
                    y: 144.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 18.5,
                    y: 144.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 19.5,
                    y: 144.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 3.5,
                    y: 147.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 4.5,
                    y: 147.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 5.5,
                    y: 147.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 6.5,
                    y: 147.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 7.5,
                    y: 147.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 8.5,
                    y: 147.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 9.5,
                    y: 147.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 10.5,
                    y: 147.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 11.5,
                    y: 147.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 12.5,
                    y: 147.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 13.5,
                    y: 147.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 14.5,
                    y: 147.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 15.5,
                    y: 147.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 16.5,
                    y: 147.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 17.5,
                    y: 147.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 18.5,
                    y: 147.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 19.5,
                    y: 147.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 3.5,
                    y: 149.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 4.5,
                    y: 149.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 5.5,
                    y: 149.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 6.5,
                    y: 149.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 7.5,
                    y: 149.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 8.5,
                    y: 149.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 9.5,
                    y: 149.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 10.5,
                    y: 149.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 11.5,
                    y: 149.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 12.5,
                    y: 149.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 13.5,
                    y: 149.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 14.5,
                    y: 149.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 15.5,
                    y: 149.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 16.5,
                    y: 149.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 17.5,
                    y: 149.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 18.5,
                    y: 149.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 19.5,
                    y: 149.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 3.5,
                    y: 150.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 4.5,
                    y: 150.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 5.5,
                    y: 150.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 6.5,
                    y: 150.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 7.5,
                    y: 150.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 8.5,
                    y: 150.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 9.5,
                    y: 150.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 10.5,
                    y: 150.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 11.5,
                    y: 150.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 12.5,
                    y: 150.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 13.5,
                    y: 150.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 14.5,
                    y: 150.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 15.5,
                    y: 150.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 16.5,
                    y: 150.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 17.5,
                    y: 150.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 18.5,
                    y: 150.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 19.5,
                    y: 150.0
                },
                type: 'static',
                shape: {
                    type: 'circle',
                    radius: 0.2,
                    color: '#e6e1ae'
                },
                props: {
                    angularVelocity: 1.0,
                    density: 1,
                    restitution: 1.5,
                    life: 1
                }
            },
            {
                position: {
                    x: 4.5,
                    y: 180.0
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 6.0,
                    height: 0.1,
                    rotation: 0,
                    color: '#ccb1b1'
                },
                props: {
                    density: 1,
                    angularVelocity: 4.6,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 18.5,
                    y: 180.0
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 7.0,
                    height: 0.1,
                    rotation: 0,
                    color: '#b1ccb1'
                },
                props: {
                    density: 1,
                    angularVelocity: -4,
                    restitution: 0
                }
            },
            {
                position: {
                    x: 11.5,
                    y: 195.0
                },
                type: 'kinematic',
                shape: {
                    type: 'box',
                    width: 8.0,
                    height: 0.1,
                    rotation: 0,
                    color: '#b3ccff'
                },
                props: {
                    density: 1,
                    angularVelocity: 5.5,
                    restitution: 0
                }
            }
        ]
    }
];



// 맵 공유마당 브라우저. 설정창의 "맵 더 받기"(+) 버튼으로 연다.
//
// - 공유마당 목록(인기/최신/다운로드순) 을 찾아보고 바로 설치한다. 넘김은 "더 보기" 버튼.
// - "받은 맵" 탭에서 업데이트/삭제한다. 업데이트 여부는 하루 한 번 확인한 결과(checkMapUpdates) 를 쓴다.
// - 맵 설명과 만들기는 샵으로 넘긴다.
// - 커스텀 룰렛 페이지(custom.html) 를 따로 고치지 않도록 대화상자는 여기서 만든다.
// - 맵 제목과 저작자는 사용자가 입력한 문자열이라 textContent 로만 넣는다.


const $d172b58dc9f0b2fa$var$PAGE_SIZE = 20;
const $d172b58dc9f0b2fa$var$SEARCH_DEBOUNCE_MS = 300;
const $d172b58dc9f0b2fa$var$TABS = [
    {
        tab: 'popular',
        label: 'Popular'
    },
    {
        tab: 'latest',
        label: 'Latest'
    },
    {
        tab: 'downloads',
        label: 'Most downloaded'
    },
    {
        tab: 'mine',
        label: 'My maps'
    }
];
function $d172b58dc9f0b2fa$var$el(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
}
function $d172b58dc9f0b2fa$var$formatCount(n) {
    return n >= 10000 ? `${Math.floor(n / 1000)}k` : n.toLocaleString();
}
function $d172b58dc9f0b2fa$export$5aa98c5c8fd508a9({ apiBase: apiBase, getSelectedId: getSelectedId, install: install, use: use, remove: remove }) {
    let dialog = null;
    let tabButtons = new Map();
    let searchInput;
    let list;
    let status;
    let moreButton;
    let tab = 'popular';
    let query = '';
    let page = 0;
    let total = 0;
    let items = [];
    let loading = false;
    let failed = false;
    let request = null;
    let searchTimer;
    /** 설치 중인 맵. 같은 버튼을 두 번 눌러 두 번 받지 않도록 */ const installing = new Set();
    function build() {
        const d = $d172b58dc9f0b2fa$var$el('dialog', 'map-browser');
        dialog = d;
        d.setAttribute('aria-label', (0, $f38b96567aa47566$export$d73ee8ef04f5226a)('Map Share'));
        const panel = $d172b58dc9f0b2fa$var$el('div', 'mb-panel');
        const header = $d172b58dc9f0b2fa$var$el('div', 'mb-header');
        const title = $d172b58dc9f0b2fa$var$el('h2', 'mb-title', (0, $f38b96567aa47566$export$d73ee8ef04f5226a)('Map Share'));
        const close = $d172b58dc9f0b2fa$var$el('button', 'mb-close', "\u2715");
        close.type = 'button';
        close.title = (0, $f38b96567aa47566$export$d73ee8ef04f5226a)('Close');
        close.addEventListener('click', ()=>d.close());
        header.append(title, close);
        const tabs = $d172b58dc9f0b2fa$var$el('div', 'mb-tabs');
        tabs.setAttribute('role', 'tablist');
        tabButtons = new Map();
        for (const t of $d172b58dc9f0b2fa$var$TABS){
            const button = $d172b58dc9f0b2fa$var$el('button', 'mb-tab');
            button.type = 'button';
            button.setAttribute('role', 'tab');
            button.addEventListener('click', ()=>selectTab(t.tab));
            tabButtons.set(t.tab, button);
            tabs.append(button);
        }
        searchInput = $d172b58dc9f0b2fa$var$el('input', 'mb-search');
        searchInput.type = 'search';
        searchInput.maxLength = 50;
        searchInput.placeholder = (0, $f38b96567aa47566$export$d73ee8ef04f5226a)('Search by title or author');
        searchInput.addEventListener('input', ()=>{
            clearTimeout(searchTimer);
            searchTimer = setTimeout(()=>{
                const next = searchInput.value.trim();
                if (next === query) return;
                query = next;
                reload();
            }, $d172b58dc9f0b2fa$var$SEARCH_DEBOUNCE_MS);
        });
        list = $d172b58dc9f0b2fa$var$el('div', 'mb-list');
        status = $d172b58dc9f0b2fa$var$el('div', 'mb-status');
        moreButton = $d172b58dc9f0b2fa$var$el('button', 'mb-more', (0, $f38b96567aa47566$export$d73ee8ef04f5226a)('Load more'));
        moreButton.type = 'button';
        moreButton.addEventListener('click', ()=>void loadPage(page + 1));
        const body = $d172b58dc9f0b2fa$var$el('div', 'mb-body');
        body.append(list, status, moreButton);
        const footer = $d172b58dc9f0b2fa$var$el('div', 'mb-footer');
        const shopLink = $d172b58dc9f0b2fa$var$el('a', undefined, (0, $f38b96567aa47566$export$d73ee8ef04f5226a)('View on Map Share'));
        shopLink.href = `${apiBase}/maps`;
        const editorLink = $d172b58dc9f0b2fa$var$el('a', undefined, (0, $f38b96567aa47566$export$d73ee8ef04f5226a)('Make a map'));
        editorLink.href = `${apiBase}/map-editor`;
        for (const a of [
            shopLink,
            editorLink
        ]){
            a.target = '_blank';
            a.rel = 'noopener';
        }
        footer.append(shopLink, editorLink);
        panel.append(header, tabs, searchInput, body, footer);
        d.append(panel);
        // 바깥(배경) 을 누르면 닫는다. 패널이 대화상자를 꽉 채우므로 target 이 dialog 면 배경이다
        d.addEventListener('click', (e)=>{
            if (e.target === d) d.close();
        });
        d.addEventListener('close', ()=>request?.abort());
        document.body.append(d);
    }
    function renderTabs() {
        const downloaded = (0, $bc803f7cdb25c6b1$export$d6a64179aa36abc6)();
        const hasUpdate = (0, $bc803f7cdb25c6b1$export$97c7e4fb68b6824b)(downloaded).length > 0;
        for (const t of $d172b58dc9f0b2fa$var$TABS){
            const button = tabButtons.get(t.tab);
            button.textContent = t.tab === 'mine' ? `${(0, $f38b96567aa47566$export$d73ee8ef04f5226a)(t.label)} ${downloaded.length}/${0, $bc803f7cdb25c6b1$export$1c0caa4db6150825}` : (0, $f38b96567aa47566$export$d73ee8ef04f5226a)(t.label);
            button.classList.toggle('active', t.tab === tab);
            button.classList.toggle('has-update', t.tab === 'mine' && hasUpdate);
            button.setAttribute('aria-selected', String(t.tab === tab));
        }
        searchInput.hidden = tab === 'mine';
    }
    function selectTab(next) {
        if (next === tab) return;
        tab = next;
        reload();
    }
    function reload() {
        request?.abort();
        items = [];
        total = 0;
        page = 0;
        failed = false;
        loading = false;
        list.scrollTop = 0;
        renderTabs();
        if (tab === 'mine') render();
        else loadPage(1);
    }
    async function loadPage(next) {
        if (tab === 'mine') return;
        request?.abort();
        const controller = new AbortController();
        request = controller;
        loading = true;
        failed = false;
        render();
        try {
            const result = await (0, $bc803f7cdb25c6b1$export$5b4a3eb572128219)(apiBase, {
                sort: tab,
                q: query,
                page: next,
                limit: $d172b58dc9f0b2fa$var$PAGE_SIZE
            }, controller.signal);
            if (controller.signal.aborted) return;
            if (!result) failed = true;
            else {
                // 넘기는 사이 새 맵이 올라와 같은 맵이 두 번 올 수 있다
                const seen = new Set(items.map((m)=>m.slug));
                items = items.concat(result.items.filter((m)=>!seen.has(m.slug)));
                total = result.total;
                page = next;
            }
        } catch (e) {
            if (controller.signal.aborted) return;
            console.error("[maps] \uB9F5 \uBAA9\uB85D\uC744 \uBC1B\uC9C0 \uBABB\uD588\uC2B5\uB2C8\uB2E4", e);
            failed = true;
        }
        loading = false;
        render();
    }
    function thumbnail(id) {
        const box = $d172b58dc9f0b2fa$var$el('div', 'mb-thumb');
        const img = $d172b58dc9f0b2fa$var$el('img');
        img.src = (0, $bc803f7cdb25c6b1$export$a6e79f144a86937d)(apiBase, id);
        img.alt = '';
        img.loading = 'lazy';
        // 공유가 중단된 맵은 썸네일이 없다
        img.addEventListener('error', ()=>img.remove());
        box.append(img);
        return box;
    }
    function titleLink(id, title) {
        const a = $d172b58dc9f0b2fa$var$el('a', 'mb-card-title', title);
        a.href = `${apiBase}/maps/${id}`;
        a.target = '_blank';
        a.rel = 'noopener';
        a.title = title;
        return a;
    }
    function actionButton(label, onClick, className = '') {
        const button = $d172b58dc9f0b2fa$var$el('button', `mb-action ${className}`.trim(), (0, $f38b96567aa47566$export$d73ee8ef04f5226a)(label));
        button.type = 'button';
        if (onClick) button.addEventListener('click', onClick);
        else button.disabled = true;
        return button;
    }
    async function runInstall(id) {
        if (installing.has(id)) return;
        installing.add(id);
        render();
        try {
            await install(id);
        } finally{
            installing.delete(id);
            renderTabs();
            render();
        }
    }
    /** 받은 맵과 서버 목록 항목을 함께 보고 버튼을 정한다 */ function primaryAction(id, local, latestVersion) {
        if (installing.has(id)) return actionButton('Installing...');
        if (local && latestVersion !== null && latestVersion > local.version) return actionButton('Update', ()=>void runInstall(id), 'mb-action-update');
        if (!local) return actionButton('Install', ()=>void runInstall(id), 'mb-action-install');
        if (getSelectedId() === `community:${id}`) return actionButton('In use');
        return actionButton('Use', ()=>{
            use(id);
            render();
        });
    }
    function remoteCard(item, local) {
        const card = $d172b58dc9f0b2fa$var$el('div', 'mb-card');
        const info = $d172b58dc9f0b2fa$var$el('div', 'mb-card-info');
        const stats = $d172b58dc9f0b2fa$var$el('div', 'mb-card-stats', `${(0, $f38b96567aa47566$export$d73ee8ef04f5226a)('Plays')} ${$d172b58dc9f0b2fa$var$formatCount(item.playCount)} \xb7 ${(0, $f38b96567aa47566$export$d73ee8ef04f5226a)('Downloads')} ${$d172b58dc9f0b2fa$var$formatCount(item.downloadCount)}`);
        info.append(titleLink(item.slug, item.title), $d172b58dc9f0b2fa$var$el('div', 'mb-card-author', `by ${item.authorName}`), stats);
        card.append(thumbnail(item.slug), info, primaryAction(item.slug, local, item.version));
        return card;
    }
    function localCard(map) {
        const remote = (0, $bc803f7cdb25c6b1$export$641795282e8abbff)()[map.id];
        const card = $d172b58dc9f0b2fa$var$el('div', 'mb-card');
        const info = $d172b58dc9f0b2fa$var$el('div', 'mb-card-info');
        info.append(titleLink(map.id, map.title), $d172b58dc9f0b2fa$var$el('div', 'mb-card-author', `by ${map.author}`));
        if (remote && !remote.available) info.append($d172b58dc9f0b2fa$var$el('div', 'mb-card-badge mb-badge-gone', (0, $f38b96567aa47566$export$d73ee8ef04f5226a)('No longer shared')));
        else if (remote?.version != null && remote.version > map.version) info.append($d172b58dc9f0b2fa$var$el('div', 'mb-card-badge mb-badge-update', (0, $f38b96567aa47566$export$d73ee8ef04f5226a)('Update available')));
        const actions = $d172b58dc9f0b2fa$var$el('div', 'mb-card-actions');
        actions.append(primaryAction(map.id, map, remote?.available ? remote.version : null), actionButton('Remove', ()=>{
            if (remove(map.id)) {
                renderTabs();
                render();
            }
        }, 'mb-action-remove'));
        card.append(thumbnail(map.id), info, actions);
        return card;
    }
    function render() {
        const downloaded = (0, $bc803f7cdb25c6b1$export$d6a64179aa36abc6)();
        const byId = new Map(downloaded.map((m)=>[
                m.id,
                m
            ]));
        status.replaceChildren();
        moreButton.hidden = true;
        if (tab === 'mine') {
            list.replaceChildren(...downloaded.map(localCard));
            if (downloaded.length === 0) status.textContent = (0, $f38b96567aa47566$export$d73ee8ef04f5226a)('No downloaded maps yet');
            return;
        }
        list.replaceChildren(...items.map((item)=>remoteCard(item, byId.get(item.slug))));
        if (loading) status.textContent = (0, $f38b96567aa47566$export$d73ee8ef04f5226a)('Loading...');
        else if (failed) {
            status.append($d172b58dc9f0b2fa$var$el('span', undefined, (0, $f38b96567aa47566$export$d73ee8ef04f5226a)('Failed to load maps')));
            const retry = actionButton('Retry', ()=>void loadPage(page + 1));
            status.append(retry);
        } else if (items.length === 0) status.textContent = (0, $f38b96567aa47566$export$d73ee8ef04f5226a)('No maps found');
        else moreButton.hidden = items.length >= total;
    }
    return {
        open () {
            if (!dialog) build();
            // 업데이트할 맵이 있으면 받은 맵부터 보여준다
            const next = (0, $bc803f7cdb25c6b1$export$97c7e4fb68b6824b)().length > 0 ? 'mine' : tab;
            tab = next;
            if (tab === 'mine' || items.length === 0 || failed) reload();
            else {
                // 다른 곳(맵 선택 상자) 에서 바뀐 선택과 받은 맵을 반영한다
                renderTabs();
                render();
            }
            dialog.showModal();
        },
        /** 받은 맵이 바뀌었을 때 (설정창에서 삭제 등). 열려 있을 때만 다시 그린다 */ refresh () {
            if (!dialog?.open) return;
            renderTabs();
            render();
        }
    };
}


const $5c130f6cdf6e8890$var$DEFAULT_MAP_ID = 'builtin:0';
const $5c130f6cdf6e8890$var$INSTALL_MESSAGES = {
    installed: 'Map installed',
    updated: 'Map updated',
    already: 'This map is already installed',
    limit: 'You can keep up to 30 downloaded maps. Remove some maps first.',
    quota: 'Not enough storage. Remove some downloaded maps first.',
    corrupt: 'Failed to install the map',
    unavailable: 'Cannot save maps in this browser'
};
function $5c130f6cdf6e8890$export$5e49f212e4e2b5d5({ roulette: roulette, apiBase: apiBase, onMapChange: onMapChange, toast: toast, mapBrowser: mapBrowser = true }) {
    const select = document.querySelector('#sltMap');
    if (!select) return;
    const removeButton = document.querySelector('#btnRemoveMap');
    const moreButton = document.querySelector('#lnkMoreMaps');
    function option(value, text) {
        const el = document.createElement('option');
        el.value = value;
        el.textContent = text;
        return el;
    }
    function group(label, options) {
        const el = document.createElement('optgroup');
        el.label = (0, $f38b96567aa47566$export$d73ee8ef04f5226a)(label);
        el.append(...options);
        return el;
    }
    function hasOption(id) {
        return Array.from(select.options).some((o)=>o.value === id);
    }
    function render() {
        const builtin = (0, $b2abafc93d11a512$export$1bfcff8d7c4bf05).map((stage, index)=>option(`builtin:${index}`, (0, $f38b96567aa47566$export$d73ee8ef04f5226a)(stage.title)));
        const downloaded = (0, $bc803f7cdb25c6b1$export$d6a64179aa36abc6)().map((map)=>option(`community:${map.id}`, `${map.title} (by ${map.author})`));
        select.replaceChildren();
        if (downloaded.length === 0) select.append(...builtin);
        else select.append(group('Default maps', builtin), group('Downloaded maps', downloaded));
    }
    function syncControls(id) {
        select.value = id;
        if (removeButton) removeButton.hidden = !id.startsWith('community:');
    }
    /** 맵을 바꾼다. 없는 맵이면 false */ function apply(id) {
        if (id.startsWith('builtin:')) {
            const index = Number(id.slice(8));
            if (!Number.isInteger(index) || index < 0 || index >= (0, $b2abafc93d11a512$export$1bfcff8d7c4bf05).length) return false;
            roulette.setMap(index);
        } else if (id.startsWith('community:')) {
            const map = (0, $bc803f7cdb25c6b1$export$d6a64179aa36abc6)().find((m)=>`community:${m.id}` === id);
            if (!map) return false;
            roulette.setStage(map.stage, id);
        } else return false;
        (0, $bc803f7cdb25c6b1$export$683c1ca972341284)(id);
        syncControls(id);
        onMapChange();
        return true;
    }
    select.addEventListener('change', ()=>{
        if (!apply(select.value)) {
            // 다른 탭에서 지운 맵일 수 있다. 목록을 새로 그리고 기본 맵으로
            render();
            apply($5c130f6cdf6e8890$var$DEFAULT_MAP_ID);
        }
        browser?.refresh();
    });
    /** 받은 맵을 지운다. 지금 쓰는 맵이면 기본 맵으로 돌아간다. 사용자가 취소하면 false */ function removeMap(id) {
        if (!window.confirm((0, $f38b96567aa47566$export$d73ee8ef04f5226a)('Remove this downloaded map?'))) return false;
        (0, $bc803f7cdb25c6b1$export$db1dcd4e76d0fe8b)(id);
        // render 가 옵션을 새로 만들면 선택값이 첫 맵으로 돌아가므로 미리 기억한다
        const current = select.value;
        render();
        if (current === `community:${id}` || !hasOption(current)) apply($5c130f6cdf6e8890$var$DEFAULT_MAP_ID);
        else syncControls(current);
        updateBadge();
        return true;
    }
    removeButton?.addEventListener('click', ()=>{
        const id = select.value;
        if (!id.startsWith('community:')) return;
        if (removeMap(id.slice('community:'.length))) browser?.refresh();
    });
    /**
   * 받아서 설치하고 선택한다. 맵 브라우저와 ?installMap= 이 함께 쓴다.
   * keepSelection 이면 (맵 브라우저의 업데이트) 선택은 그대로 두고, 지금 쓰는 맵이면 새 버전으로 다시 불러온다
   */ async function installMap(id, keepSelection = false) {
        let pkg = null;
        try {
            pkg = await (0, $bc803f7cdb25c6b1$export$5ea46862415041fb)(apiBase, id);
        } catch (e) {
            console.error("[maps] \uB9F5\uC744 \uBC1B\uC9C0 \uBABB\uD588\uC2B5\uB2C8\uB2E4", e);
        }
        if (!pkg) {
            toast('Failed to install the map');
            return false;
        }
        const result = (0, $bc803f7cdb25c6b1$export$e82a75c9a926cf33)(pkg);
        toast($5c130f6cdf6e8890$var$INSTALL_MESSAGES[result.result]);
        if (result.result !== 'installed' && result.result !== 'updated' && result.result !== 'already') return false;
        (0, $bc803f7cdb25c6b1$export$8b02ff41fd78c74f)(pkg.id, {
            version: pkg.version,
            available: true
        });
        // render 가 옵션을 새로 만들면 선택값이 첫 맵으로 돌아가므로 미리 기억한다
        const current = select.value;
        render();
        if (!keepSelection || current === `community:${pkg.id}`) apply(`community:${pkg.id}`);
        else syncControls(current);
        updateBadge();
        return true;
    }
    function updateBadge() {
        moreButton?.classList.toggle('has-update', mapBrowser && (0, $bc803f7cdb25c6b1$export$97c7e4fb68b6824b)().length > 0);
    }
    const browser = mapBrowser ? (0, $d172b58dc9f0b2fa$export$5aa98c5c8fd508a9)({
        apiBase: apiBase,
        getSelectedId: ()=>select.value,
        // 처음 받는 맵은 바로 쓰고, 이미 받은 맵의 업데이트는 선택을 건드리지 않는다
        install: (id)=>installMap(id, (0, $bc803f7cdb25c6b1$export$d6a64179aa36abc6)().some((m)=>m.id === id)),
        use: (id)=>{
            if (!apply(`community:${id}`)) {
                render();
                apply($5c130f6cdf6e8890$var$DEFAULT_MAP_ID);
            }
        },
        remove: removeMap
    }) : null;
    if (moreButton) {
        if (browser) // 링크는 스크립트가 늦게 뜰 때를 위한 대비. 브라우저가 있으면 샵으로 넘기지 않고 연다
        moreButton.addEventListener('click', (e)=>{
            e.preventDefault();
            browser.open();
        });
        else moreButton.hidden = true;
    }
    // 처음 그리기: 기억해 둔 맵이 있으면 그 맵으로
    render();
    const saved = (0, $bc803f7cdb25c6b1$export$af862b0702a42945)();
    if (saved && saved !== $5c130f6cdf6e8890$var$DEFAULT_MAP_ID && hasOption(saved) && apply(saved)) ;
    else syncControls(roulette.getCurrentMap()?.id ?? $5c130f6cdf6e8890$var$DEFAULT_MAP_ID);
    // 맵 공유마당의 "마블룰렛에 설치"
    const params = new URLSearchParams(location.search);
    const installId = params.get('installMap');
    if (installId !== null) {
        // 새로고침할 때마다 다시 설치하지 않도록 주소에서 뺀다
        params.delete('installMap');
        const query = params.toString();
        history.replaceState(null, '', `${location.pathname}${query ? `?${query}` : ''}${location.hash}`);
        if ((0, $bc803f7cdb25c6b1$export$e6f5a94bd4b1cb2d).test(installId)) installMap(installId);
        else toast('Failed to install the map');
    }
    updateBadge();
    if (mapBrowser) (0, $bc803f7cdb25c6b1$export$d40f71d1d5e63b90)(apiBase).then((checked)=>{
        if (checked) updateBadge();
    });
}


class $2573268c577c952d$var$Options {
    constructor(){
        this.useSkills = true;
        /** 0-based, 양끝 포함. 1명 추첨은 start === end */ this.winnerRange = {
            start: 0,
            end: 0
        };
        this.autoRecording = true;
    }
}
const $2573268c577c952d$var$options = new $2573268c577c952d$var$Options();
var $2573268c577c952d$export$2e2bcd8739ae039 = $2573268c577c952d$var$options;


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $5c96a02c592fcff1$var$ownKeys = function(o) {
    $5c96a02c592fcff1$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $5c96a02c592fcff1$var$ownKeys(o);
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $5c96a02c592fcff1$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $5c96a02c592fcff1$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __esDecorate: $5c96a02c592fcff1$export$3a84e1ae4e97e9b0,
    __runInitializers: $5c96a02c592fcff1$export$d831c04e792af3d,
    __propKey: $5c96a02c592fcff1$export$6a2a36740a146cb8,
    __setFunctionName: $5c96a02c592fcff1$export$d1a06452d3489bc7,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $5c96a02c592fcff1$export$889dfb5d17574b0b
};


const $1d1927fc5b91d8b6$export$c2cc40734f29867c = 30;
const $1d1927fc5b91d8b6$export$1cd840e6ecaab774 = 1600;
const $1d1927fc5b91d8b6$export$3d795bc15e02aca = 900;
const $1d1927fc5b91d8b6$export$677ef9a3ce6796cf = 5;
const $1d1927fc5b91d8b6$export$2708cc8cc9b2d975 = 5000;
const $1d1927fc5b91d8b6$export$3b636dc9ab9d92c7 = 168;
var $1d1927fc5b91d8b6$export$bc572fe44976cfbc = /*#__PURE__*/ function(Skills) {
    Skills[Skills["None"] = 0] = "None";
    Skills[Skills["Impact"] = 1] = "Impact";
    return Skills;
}({});
const $1d1927fc5b91d8b6$export$7f71f94d90ccd8fd = {
    box: 'cyan',
    circle: 'yellow',
    polyline: 'white'
};
const $1d1927fc5b91d8b6$export$452bc121f02cf9e8 = {
    box: 'cyan',
    circle: 'yellow',
    polyline: 'cyan'
};
const $1d1927fc5b91d8b6$export$1d8e462b9ec86de2 = {
    light: {
        background: '#eee',
        marbleLightness: 50,
        marbleWinningBorder: 'black',
        skillColor: '#69c',
        coolTimeIndicator: '#999',
        entity: {
            box: {
                fill: '#226f92',
                outline: 'black',
                bloom: 'cyan',
                bloomRadius: 0
            },
            circle: {
                fill: 'yellow',
                outline: '#ed7e11',
                bloom: 'yellow',
                bloomRadius: 0
            },
            polyline: {
                fill: 'white',
                outline: 'black',
                bloom: 'cyan',
                bloomRadius: 0
            }
        },
        rankStroke: 'black',
        minimapBackground: '#fefefe',
        minimapViewport: '#6699cc',
        winnerBackground: 'rgba(255, 255, 255, 0.5)',
        winnerOutline: 'black',
        winnerText: '#cccccc'
    },
    dark: {
        background: 'black',
        marbleLightness: 75,
        marbleWinningBorder: 'white',
        skillColor: 'white',
        coolTimeIndicator: 'red',
        entity: {
            box: {
                fill: 'cyan',
                outline: 'cyan',
                bloom: 'cyan',
                bloomRadius: 15
            },
            circle: {
                fill: 'yellow',
                outline: 'yellow',
                bloom: 'yellow',
                bloomRadius: 15
            },
            polyline: {
                fill: 'white',
                outline: 'white',
                bloom: 'cyan',
                bloomRadius: 15
            }
        },
        rankStroke: '',
        minimapBackground: '#333333',
        minimapViewport: 'white',
        winnerBackground: 'rgba(0, 0, 0, 0.5)',
        winnerOutline: 'black',
        winnerText: 'white'
    }
};


/**
 * 경쟁 구슬을 같이 잡을 때 화면 가장자리에 남기는 여유 (화면 크기에 대한 한쪽 비율).
 * 줌과 상관없이 화면에서 같은 크기라 가장자리 UI(미니맵, 순위표 등) 에 구슬이 가리지 않는다
 */ const $238457a12dbae9c5$var$FRAME_PADDING_RATIO = 0.15;
/** 구슬 크기만큼 더 남기는 여유 (월드 단위) */ const $238457a12dbae9c5$var$FRAME_MARBLE_MARGIN = 0.5;
/** 경쟁 구슬을 같이 잡으려고 줌아웃할 수 있는 한계 */ const $238457a12dbae9c5$var$MIN_FRAME_ZOOM = 0.6;
/**
 * 두 구슬을 다 담는 데 이 배율이 필요할 만큼 멀어지면 대상 구슬만 따라간다.
 * MIN_FRAME_ZOOM 과 이 값 사이에서는 멀어질수록 대상 구슬 쪽으로 서서히 넘어간다
 */ const $238457a12dbae9c5$var$FRAME_RELEASE_ZOOM = 0.35;
/** 연출이 경쟁 구슬 때문에 걸리거나 풀릴 때 화면의 주인공이 넘어가는 데 걸리는 프레임 수 */ const $238457a12dbae9c5$var$FOCUS_BLEND_FRAMES = 40;
/** 카메라 구역에 들어가거나 나올 때 화면이 넘어가는 데 걸리는 프레임 수 */ const $238457a12dbae9c5$var$ZONE_BLEND_FRAMES = 60;
/** 순위가 바뀌어 담을 구슬이 바뀌어도 새 구슬이 이 프레임 수만큼 자리를 지켜야 카메라를 바꾼다 */ const $238457a12dbae9c5$var$SWITCH_DELAY_FRAMES = 20;
/** 담을 구슬이 바뀔 때 화면이 넘어가는 데 걸리는 프레임 수 */ const $238457a12dbae9c5$var$SWITCH_BLEND_FRAMES = 36;
class $238457a12dbae9c5$export$79f141de891a5fed {
    get zoom() {
        return this._zoom;
    }
    set zoom(v) {
        this._targetZoom = v;
    }
    get x() {
        return this._position.x;
    }
    set x(v) {
        this._targetPosition.x = v;
    }
    get y() {
        return this._position.y;
    }
    set y(v) {
        this._targetPosition.y = v;
    }
    get position() {
        return this._position;
    }
    setPosition(v, force = false) {
        if (force) return this._position = {
            x: v.x,
            y: v.y
        };
        return this._targetPosition = {
            x: v.x,
            y: v.y
        };
    }
    lock(v) {
        this._locked = v;
    }
    startFollowingMarbles() {
        this._shouldFollowMarbles = true;
    }
    initializePosition(center, zoom) {
        const x = center?.x ?? 12.95;
        const y = center?.y ?? 2;
        const z = zoom ?? 1;
        this._position = {
            x: x,
            y: y
        };
        this._targetPosition = {
            x: x,
            y: y
        };
        this._zoom = z;
        this._targetZoom = z;
        this._shouldFollowMarbles = false;
        this._zoneWeight = 0;
        this._zone = null;
        this._focusWeight = 0;
        this._shown = null;
        this._pending = null;
        this._pendingFrames = 0;
        this._switchFrom = null;
        this._switchProgress = 1;
    }
    update({ marbles: marbles, stage: stage, intensity: intensity, targetIndex: targetIndex, focusOnRival: focusOnRival, viewSize: viewSize }) {
        // set target position
        if (!this._locked) this._calcTargetPositionAndZoom(marbles, stage, intensity, targetIndex, focusOnRival, viewSize);
        // interpolate position
        this._position.x = this._interpolation(this.x, this._targetPosition.x);
        this._position.y = this._interpolation(this.y, this._targetPosition.y);
        // interpolate zoom
        this._zoom = this._interpolation(this._zoom, this._targetZoom);
    }
    _calcTargetPositionAndZoom(marbles, stage, intensity, targetIndex, focusOnRival, viewSize) {
        if (!this._shouldFollowMarbles) return;
        if (marbles.length > 0) {
            const index = marbles[targetIndex] ? targetIndex : 0;
            // 커트라인을 두고 다투는 구슬(바로 뒤, 없으면 바로 앞) 을 같이 화면에 담는다
            const current = {
                target: marbles[index],
                rival: marbles[index + 1] ?? marbles[index - 1]
            };
            const { target: targetMarble, rival: rival } = this._pickPair(current, marbles);
            // focusOnRival 은 지금 순위의 짝 기준이라 카메라가 아직 옛 짝을 담고 있으면 쓰지 않는다
            const isCurrent = targetMarble === current.target && rival === current.rival;
            // 두 구슬이 화면 가장자리 여유 안쪽에 들어오는 배율
            const fitZoom = rival ? Math.min(viewSize.x * (0.5 - $238457a12dbae9c5$var$FRAME_PADDING_RATIO) / (Math.abs(rival.x - targetMarble.x) / 2 + $238457a12dbae9c5$var$FRAME_MARBLE_MARGIN), viewSize.y * (0.5 - $238457a12dbae9c5$var$FRAME_PADDING_RATIO) / (Math.abs(rival.y - targetMarble.y) / 2 + $238457a12dbae9c5$var$FRAME_MARBLE_MARGIN)) : 0;
            // 연출이 경쟁 구슬 때문에 걸리면 화면의 주인공을 경쟁 구슬로 서서히 바꾼다.
            // 둘이 가까우면 어느 쪽이 주인공이든 화면이 거의 같고, 멀면 FOCUS_BLEND_FRAMES 에 걸쳐 넘어간다
            const focusStep = 1 / $238457a12dbae9c5$var$FOCUS_BLEND_FRAMES;
            this._focusWeight = focusOnRival && isCurrent && rival ? Math.min(1, this._focusWeight + focusStep) : Math.max(0, this._focusWeight - focusStep);
            let { position: position, zoom: zoom } = this._frameView(targetMarble, rival, fitZoom, intensity, viewSize);
            if (rival && this._focusWeight > 0) {
                const w = $238457a12dbae9c5$var$smoothstep(this._focusWeight);
                const view = this._frameView(rival, targetMarble, fitZoom, intensity, viewSize);
                position = {
                    x: position.x + (view.position.x - position.x) * w,
                    y: position.y + (view.position.y - position.y) * w
                };
                zoom = zoom + (view.zoom - zoom) * w;
            }
            // 카메라 구역: 구역 전체를 보여 준다. 줌인 연출과 겹치면 연출 강도만큼 구슬 쪽 화면으로 넘어간다.
            // 드나들 때는 ZONE_BLEND_FRAMES 에 걸쳐 서서히 넘어간다
            const zone = stage.cameraZones?.find((z)=>Math.abs(targetMarble.x - z.x) <= z.w / 2 && Math.abs(targetMarble.y - z.y) <= z.h / 2);
            if (zone) this._zone = zone;
            const step = 1 / $238457a12dbae9c5$var$ZONE_BLEND_FRAMES;
            this._zoneWeight = zone ? Math.min(1, this._zoneWeight + step) : Math.max(0, this._zoneWeight - step);
            if (this._zone && this._zoneWeight > 0) {
                const z = this._zone;
                const zoneZoom = Math.min(viewSize.x / z.w, viewSize.y / z.h);
                const t = $238457a12dbae9c5$var$smoothstep(this._zoneWeight) * (1 - intensity);
                position = {
                    x: position.x + (z.x - position.x) * t,
                    y: position.y + (z.y - position.y) * t
                };
                zoom = zoom + (zoneZoom - zoom) * t;
            } else this._zone = null;
            // 담을 구슬이 바뀐 직후면 그 순간의 화면에서 서서히 넘어간다
            if (this._switchFrom && this._switchProgress < 1) {
                this._switchProgress = Math.min(1, this._switchProgress + 1 / $238457a12dbae9c5$var$SWITCH_BLEND_FRAMES);
                const from = this._switchFrom;
                const w = $238457a12dbae9c5$var$smoothstep(this._switchProgress);
                position = {
                    x: from.position.x + (position.x - from.position.x) * w,
                    y: from.position.y + (position.y - from.position.y) * w
                };
                zoom = from.zoom + (zoom - from.zoom) * w;
            }
            this.setPosition(position);
            this.zoom = zoom;
        } else this.zoom = 1;
    }
    /**
   * 카메라가 담을 짝을 정한다. 순위로 정해진 짝(current) 이 SWITCH_DELAY_FRAMES 동안 유지돼야 바꾼다.
   * 잠깐 뒤집혔다 돌아오는 순위에는 반응하지 않는다. 담던 구슬이 골인해서 빠졌으면 바로 바꾼다
   */ _pickPair(current, marbles) {
        const shown = this._shown;
        if (shown && shown.target === current.target && shown.rival === current.rival) {
            this._pending = null;
            return shown;
        }
        if (this._pending && this._pending.target === current.target && this._pending.rival === current.rival) this._pendingFrames++;
        else {
            this._pending = current;
            this._pendingFrames = 1;
        }
        const gone = !shown || !marbles.includes(shown.target) || shown.rival !== undefined && !marbles.includes(shown.rival);
        if (gone || this._pendingFrames >= $238457a12dbae9c5$var$SWITCH_DELAY_FRAMES) {
            if (shown) {
                this._switchFrom = {
                    position: {
                        ...this._targetPosition
                    },
                    zoom: this._targetZoom
                };
                this._switchProgress = 0;
            }
            this._shown = current;
            this._pending = null;
            return current;
        }
        return shown;
    }
    /**
   * subject 를 주인공으로 other 와 함께 담는 화면.
   * 두 구슬을 같이 담는 정도는 줌아웃 한계를 넘어 멀어질수록 줄어 subject 만 따라가는 쪽으로 넘어간다
   */ _frameView(subject, other, fitZoom, intensity, viewSize) {
        let position = subject.position;
        let zoom = 1;
        if (other) {
            const frame = $238457a12dbae9c5$var$smoothstep((fitZoom - $238457a12dbae9c5$var$FRAME_RELEASE_ZOOM) / ($238457a12dbae9c5$var$MIN_FRAME_ZOOM - $238457a12dbae9c5$var$FRAME_RELEASE_ZOOM));
            position = {
                x: subject.x + (other.x - subject.x) / 2 * frame,
                y: subject.y + (other.y - subject.y) / 2 * frame
            };
            zoom = 1 + (Math.max($238457a12dbae9c5$var$MIN_FRAME_ZOOM, Math.min(1, fitZoom)) - 1) * frame;
        }
        // 연출이 없으면 둘이 들어오게 줌아웃만 하고, 연출이 세지면 둘이 다 안 들어오더라도 줌인한다
        zoom = Math.max(zoom, intensity * 4);
        // 줌인하느라 둘이 한 화면에 안 들어가면 subject 가 화면 안에 남도록 그쪽으로 당긴다.
        // 연출 강도 0.25 까지 서서히 당겨 연출이 시작될 때 화면이 튀지 않게 한다
        if (intensity > 0) {
            const hx = Math.max(0, viewSize.x * (0.5 - $238457a12dbae9c5$var$FRAME_PADDING_RATIO) / zoom - $238457a12dbae9c5$var$FRAME_MARBLE_MARGIN);
            const hy = Math.max(0, viewSize.y * (0.5 - $238457a12dbae9c5$var$FRAME_PADDING_RATIO) / zoom - $238457a12dbae9c5$var$FRAME_MARBLE_MARGIN);
            const cx = Math.min(subject.x + hx, Math.max(subject.x - hx, position.x));
            const cy = Math.min(subject.y + hy, Math.max(subject.y - hy, position.y));
            const pull = Math.min(1, intensity * 4);
            position = {
                x: position.x + (cx - position.x) * pull,
                y: position.y + (cy - position.y) * pull
            };
        }
        return {
            position: position,
            zoom: zoom
        };
    }
    _interpolation(current, target, delta = 10) {
        const d = target - current;
        if (Math.abs(d) < 1 / (0, $1d1927fc5b91d8b6$export$c2cc40734f29867c)) return target;
        return current + d / delta;
    }
    renderScene(ctx, callback) {
        const zoomFactor = (0, $1d1927fc5b91d8b6$export$c2cc40734f29867c) * 2 * this._zoom;
        ctx.save();
        ctx.translate(-this.x * this._zoom, -this.y * this._zoom);
        ctx.scale(this.zoom, this.zoom);
        ctx.translate(ctx.canvas.width / zoomFactor, ctx.canvas.height / zoomFactor);
        callback(ctx);
        ctx.restore();
    }
    constructor(){
        this._position = {
            x: 0,
            y: 0
        };
        this._targetPosition = {
            x: 0,
            y: 0
        };
        this._zoom = 1;
        this._targetZoom = 1;
        this._locked = false;
        this._shouldFollowMarbles = false;
        /** 카메라 구역 화면이 섞이는 정도 (0 ~ 1). 구역을 드나들 때 서서히 바뀐다 */ this._zoneWeight = 0;
        /** 마지막으로 들어갔던 카메라 구역. 나온 뒤에도 _zoneWeight 가 0 이 될 때까지 쓴다 */ this._zone = null;
        /** 카메라가 담고 있는 대상 구슬과 경쟁 구슬. 순위가 바뀌어도 SWITCH_DELAY_FRAMES 동안은 그대로 둔다 */ this._shown = null;
        /** 순위로는 바뀌었지만 아직 카메라가 따라가지 않은 짝과, 그 짝이 유지된 프레임 수 */ this._pending = null;
        this._pendingFrames = 0;
        /** 담을 구슬이 바뀐 순간의 화면. _switchProgress 가 1 이 될 때까지 여기서 새 화면으로 넘어간다 */ this._switchFrom = null;
        this._switchProgress = 1;
        /** 화면의 주인공이 경쟁 구슬인 정도 (0 ~ 1) */ this._focusWeight = 0;
    }
}
/** 0 ~ 1 로 자른 뒤 시작과 끝이 완만한 곡선으로 바꾼다 */ function $238457a12dbae9c5$var$smoothstep(t) {
    const x = Math.min(1, Math.max(0, t));
    return x * x * (3 - 2 * x);
}




var $fde943b0087de629$exports = {};
$fde943b0087de629$exports = import.meta.resolve("juMvj");


class $edfb0080e3205638$export$bdce5325d183ff94 {
    constructor(){
        this.bound = {
            x: 0,
            y: 0,
            w: 0,
            h: 0
        };
        this.isEnabled = false;
        this.icon = new Image();
        this.icon.src = new URL($fde943b0087de629$exports).toString();
    }
    get speed() {
        return this.isEnabled ? 2 : 1;
    }
    update(_deltaTime) {}
    render(ctx, _params, width, height) {
        this.bound.w = width / 2;
        this.bound.h = height / 2;
        this.bound.x = this.bound.w / 2;
        this.bound.y = this.bound.h / 2;
        const centerX = this.bound.x + this.bound.w / 2;
        const centerY = this.bound.y + this.bound.h / 2;
        if (this.isEnabled) {
            ctx.save();
            ctx.strokeStyle = 'white';
            ctx.globalAlpha = 0.5;
            ctx.drawImage(this.icon, centerX - 100, centerY - 100, 200, 200);
            ctx.restore();
        }
    }
    getBoundingBox() {
        return this.bound;
    }
    // 캔버스 어디를 눌러도 2배속이 된다 (영역 밖에서 누르면 mouseHandler 가 undefined 를 넘기지만 그때도 켠다).
    // 누른 채로 미니맵 위로 움직이며 화면을 옮길 수 있도록 일부러 가운데 영역으로 제한하지 않는다
    onMouseDown(_e) {
        this.isEnabled = true;
    }
    onMouseUp(_e) {
        this.isEnabled = false;
    }
}




function $925f553a3559c299$export$b1ef7103be47635(ctx, func) {
    const originalTransform = ctx.getTransform();
    func(ctx);
    ctx.setTransform(originalTransform);
}


function $28770b279d7ab5b1$export$29e4e862bebba87f(degree) {
    return Math.PI * degree / 180;
}
function $28770b279d7ab5b1$var$getRegexValue(regex, str) {
    const result = regex.exec(str);
    return result ? result[1] : '';
}
function $28770b279d7ab5b1$export$5d945868514965a9(nameStr) {
    const weightRegex = /\/(\d+)/;
    const countRegex = /\*(\d+)/;
    const hasWeight = weightRegex.test(nameStr);
    const hasCount = countRegex.test(nameStr);
    const name = $28770b279d7ab5b1$var$getRegexValue(/^\s*([^/*]+)?/, nameStr);
    if (!name) return null;
    const weight = hasWeight ? parseInt($28770b279d7ab5b1$var$getRegexValue(weightRegex, nameStr), 10) : 1;
    const count = hasCount ? parseInt($28770b279d7ab5b1$var$getRegexValue(countRegex, nameStr), 10) : 1;
    return {
        name: name,
        weight: weight,
        count: count
    };
}
function $28770b279d7ab5b1$export$5d04458e2a6c373e(v) {
    return v.toString().padStart(2, '0');
}
function $28770b279d7ab5b1$export$448332262467e042(originalArray) {
    const array = originalArray.slice();
    let currentIndex = array.length;
    let randomIndex;
    // While there remain elements to shuffle.
    while(currentIndex !== 0){
        // Pick a remaining element.
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;
        // And swap it with the current element.
        [array[currentIndex], array[randomIndex]] = [
            array[randomIndex],
            array[currentIndex]
        ];
    }
    return array;
}


class $5aa23f633f590d4c$export$9b781de7bf37bf48 {
    static sub(v1, v2) {
        return {
            x: v2.x - v1.x,
            y: v2.y - v1.y
        };
    }
    static lenSq(v) {
        return v.x * v.x + v.y * v.y;
    }
    static len(v) {
        return Math.sqrt($5aa23f633f590d4c$export$9b781de7bf37bf48.lenSq(v));
    }
    static mul(v, scalar) {
        return {
            x: v.x * scalar,
            y: v.y * scalar
        };
    }
    static add(v1, v2) {
        return {
            x: v1.x + v2.x,
            y: v1.y + v2.y
        };
    }
}


class $e7b6517817360fee$export$e91dba6fa3f67f68 {
    get position() {
        return this.physics.getMarblePosition(this.id) || {
            x: 0,
            y: 0,
            angle: 0
        };
    }
    get x() {
        return this.position.x;
    }
    set x(v) {
        this.position.x = v;
    }
    get y() {
        return this.position.y;
    }
    set y(v) {
        this.position.y = v;
    }
    get angle() {
        return this.position.angle;
    }
    constructor(physics, order, max, name, weight = 1){
        this.type = 'marble';
        this.name = '';
        this.size = 0.5;
        this.color = 'red';
        this.hue = 0;
        this.impact = 0;
        this.weight = 1;
        this.skill = (0, $1d1927fc5b91d8b6$export$bc572fe44976cfbc).None;
        this.isActive = false;
        this._skillRate = 0.0005;
        this._coolTime = 5000;
        this._maxCoolTime = 5000;
        this._stuckTime = 0;
        this.lastPosition = {
            x: 0,
            y: 0
        };
        this.theme = (0, $1d1927fc5b91d8b6$export$1d8e462b9ec86de2).dark;
        this.name = name || `M${order}`;
        this.weight = weight;
        this.physics = physics;
        this._maxCoolTime = 1000 + (1 - this.weight) * 4000;
        this._coolTime = this._maxCoolTime * Math.random();
        this._skillRate = 0.2 * this.weight;
        const maxLine = Math.ceil(max / 10);
        const line = Math.floor(order / 10);
        const lineDelta = -Math.max(0, Math.ceil(maxLine - 5));
        this.hue = 360 / max * order;
        this.color = `hsl(${this.hue} 100% 70%)`;
        this.id = order;
        physics.createMarble(order, 10.25 + order % 10 * 0.6, maxLine - line + lineDelta);
    }
    /**
   * @param deltaTime 벽시계 기준 경과(ms). 스킬 쿨타임 등 연출 시간에 쓴다
   * @param timeScale 이 틱에서 물리가 실제로 진행된 비율(슬로모션이면 1 미만).
   *   정지 판정은 이동 거리로 하므로 물리 시간에 맞춰 문턱을 줄여야 한다. 안 그러면 슬로모션 중
   *   천천히 구르는 구슬이 멈춘 것으로 오판되어 골인 직전에 랜덤으로 튕겨진다
   */ update(deltaTime, timeScale = 1) {
        const stuckThreshold = 0.00001 * timeScale * timeScale;
        if (this.isActive && (0, $5aa23f633f590d4c$export$9b781de7bf37bf48).lenSq((0, $5aa23f633f590d4c$export$9b781de7bf37bf48).sub(this.lastPosition, this.position)) < stuckThreshold) {
            // 누적에는 timeScale 을 곱하지 않는다. 이건 화면이 굳는 걸 막는 워치독이라 관객 체감 시간이 기준이다.
            // 물리 시간으로 바꾸면 슬로모션이 깊을수록 발동이 늦어지는데, 타겟 구슬이 멈추면 _goalDist 가 고정되어
            // 슬로모션이 풀리지 않으므로 교착을 깨야 할 상황에서 워치독이 오히려 무뎌진다
            this._stuckTime += deltaTime;
            if (this._stuckTime > (0, $1d1927fc5b91d8b6$export$2708cc8cc9b2d975)) {
                this.physics.shakeMarble(this.id);
                this._stuckTime = 0;
            }
        } else this._stuckTime = 0;
        this.lastPosition = {
            x: this.position.x,
            y: this.position.y
        };
        this.skill = (0, $1d1927fc5b91d8b6$export$bc572fe44976cfbc).None;
        if (this.impact) this.impact = Math.max(0, this.impact - deltaTime);
        if (!this.isActive) return;
        if ((0, $2573268c577c952d$export$2e2bcd8739ae039).useSkills) this._updateSkillInformation(deltaTime);
    }
    _updateSkillInformation(deltaTime) {
        if (this._coolTime > 0) this._coolTime -= deltaTime;
        if (this._coolTime <= 0) {
            this.skill = Math.random() < this._skillRate ? (0, $1d1927fc5b91d8b6$export$bc572fe44976cfbc).Impact : (0, $1d1927fc5b91d8b6$export$bc572fe44976cfbc).None;
            this._coolTime = this._maxCoolTime;
        }
    }
    render(ctx, zoom, outline, isMinimap = false, skin, viewPort, theme) {
        this.theme = theme;
        const viewPortHw = viewPort.w / viewPort.zoom / 2;
        const viewPortHh = viewPort.h / viewPort.zoom / 2;
        const viewPortLeft = viewPort.x - viewPortHw;
        const viewPortRight = viewPort.x + viewPortHw;
        const viewPortTop = viewPort.y - viewPortHh;
        const viewPortBottom = viewPort.y + viewPortHh;
        const halfSize = this.size / 2;
        const isOutsideView = this.x + halfSize < viewPortLeft || this.x - halfSize > viewPortRight || this.y + halfSize < viewPortTop || this.y - halfSize > viewPortBottom;
        if (!isMinimap && isOutsideView) return;
        const transform = ctx.getTransform();
        if (isMinimap) this._renderMinimap(ctx);
        else this._renderNormal(ctx, zoom, outline, skin);
        ctx.setTransform(transform);
    }
    _renderMinimap(ctx) {
        ctx.fillStyle = this.color;
        this._drawMarbleBody(ctx, true);
    }
    _drawMarbleBody(ctx, isMinimap) {
        ctx.beginPath();
        ctx.arc(this.x, this.y, isMinimap ? this.size : this.size / 2, 0, Math.PI * 2);
        ctx.fill();
    }
    _renderNormal(ctx, zoom, outline, skin) {
        const hs = this.size / 2;
        ctx.fillStyle = `hsl(${this.hue} 100% ${this.theme.marbleLightness + 25 * Math.min(1, this.impact / 500)}%`;
        // ctx.shadowColor = this.color;
        // ctx.shadowBlur = zoom / 2;
        if (skin) (0, $925f553a3559c299$export$b1ef7103be47635)(ctx, ()=>{
            ctx.translate(this.x, this.y);
            ctx.rotate(this.angle);
            ctx.drawImage(skin, -hs, -hs, hs * 2, hs * 2);
        });
        else this._drawMarbleBody(ctx, false);
        ctx.shadowColor = '';
        ctx.shadowBlur = 0;
        this._drawName(ctx, zoom);
        if (outline) this._drawOutline(ctx, 2 / zoom);
        if ((0, $2573268c577c952d$export$2e2bcd8739ae039).useSkills) this._renderCoolTime(ctx, zoom);
    }
    _drawName(ctx, zoom) {
        (0, $925f553a3559c299$export$b1ef7103be47635)(ctx, ()=>{
            ctx.font = `12pt sans-serif`;
            ctx.strokeStyle = 'black';
            ctx.lineWidth = 2;
            ctx.fillStyle = this.color;
            ctx.shadowBlur = 0;
            ctx.translate(this.x, this.y + 0.25);
            ctx.scale(1 / zoom, 1 / zoom);
            ctx.strokeText(this.name, 0, 0);
            ctx.fillText(this.name, 0, 0);
        });
    }
    _drawOutline(ctx, lineWidth) {
        ctx.beginPath();
        ctx.strokeStyle = this.theme.marbleWinningBorder;
        ctx.lineWidth = lineWidth;
        ctx.arc(this.x, this.y, this.size / 2, 0, Math.PI * 2);
        ctx.stroke();
    }
    _renderCoolTime(ctx, zoom) {
        ctx.strokeStyle = this.theme.coolTimeIndicator;
        ctx.lineWidth = 1 / zoom;
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.size / 2 + 2 / zoom, (0, $28770b279d7ab5b1$export$29e4e862bebba87f)(270), (0, $28770b279d7ab5b1$export$29e4e862bebba87f)(270 + 360 * this._coolTime / this._maxCoolTime));
        ctx.stroke();
    }
}




function $5d9d2ddcc4e90c63$export$adf7c0fe6059d774(_target, propertyKey, descriptor) {
    return {
        configurable: true,
        get () {
            const boundMethod = descriptor.value?.bind(this);
            Object.defineProperty(this, propertyKey, {
                value: boundMethod,
                configurable: true,
                writable: true
            });
            return boundMethod;
        }
    };
}


/** 미니맵 최대 배율. 맵이 길거나 넓으면 이보다 작아진다 */ const $c2ea39beabe51779$var$MINIMAP_SCALE = 4;
/** 기본으로 보여주는 가로 범위 (공식 맵 크기). 맵 공유마당의 넓은 맵은 장애물이 있는 만큼 넓혀 보여준다 */ const $c2ea39beabe51779$var$MINIMAP_MIN_X = 0;
const $c2ea39beabe51779$var$MINIMAP_UNITS = 26;
const $c2ea39beabe51779$export$786d88d79d18d08b = 10;
const $c2ea39beabe51779$export$cc97458872192ab6 = $c2ea39beabe51779$var$MINIMAP_UNITS * $c2ea39beabe51779$var$MINIMAP_SCALE;
class $c2ea39beabe51779$export$a8b4308ba35ee473 {
    constructor(){
        this.lastParams = null;
        this._onViewportChangeHandler = null;
        this.mousePosition = null;
        this.scale = $c2ea39beabe51779$var$MINIMAP_SCALE;
        /** 지금 맵의 가로 범위. 맵이 바뀔 때만 다시 계산한다 */ this.rangeStage = null;
        this.range = {
            minX: $c2ea39beabe51779$var$MINIMAP_MIN_X,
            maxX: $c2ea39beabe51779$var$MINIMAP_MIN_X + $c2ea39beabe51779$var$MINIMAP_UNITS
        };
        this.boundingBox = {
            x: $c2ea39beabe51779$export$786d88d79d18d08b,
            y: $c2ea39beabe51779$export$786d88d79d18d08b,
            w: $c2ea39beabe51779$export$cc97458872192ab6,
            h: 0
        };
    }
    getBoundingBox() {
        return this.boundingBox;
    }
    onViewportChange(callback) {
        this._onViewportChangeHandler = callback;
    }
    update() {
    // nothing to do
    }
    onMouseMove(e) {
        if (!e) {
            this.mousePosition = null;
            if (this._onViewportChangeHandler) this._onViewportChangeHandler();
            return;
        }
        if (!this.lastParams) return;
        this.mousePosition = {
            x: e.x,
            y: e.y
        };
        if (this._onViewportChangeHandler) this._onViewportChangeHandler({
            x: this.mousePosition.x / this.scale + this.range.minX,
            y: this.mousePosition.y / this.scale
        });
    }
    /** 맵의 가로 범위. 기본 범위(0 ~ 26) 와 장애물이 있는 범위를 합친다. 공식 맵은 기본 범위 그대로다 */ updateRange(stage) {
        if (stage === this.rangeStage) return;
        this.rangeStage = stage;
        let minX = $c2ea39beabe51779$var$MINIMAP_MIN_X;
        let maxX = $c2ea39beabe51779$var$MINIMAP_MIN_X + $c2ea39beabe51779$var$MINIMAP_UNITS;
        for (const entity of stage.entities ?? []){
            const { x: x } = entity.position;
            const shape = entity.shape;
            let xs;
            if (shape.type === 'polyline') xs = shape.points.map((p)=>x + p[0]);
            else if (shape.type === 'circle') xs = [
                x - shape.radius,
                x + shape.radius
            ];
            else {
                const reach = Math.hypot(shape.width, shape.height);
                xs = [
                    x - reach,
                    x + reach
                ];
            }
            for (const v of xs){
                if (!Number.isFinite(v)) continue;
                minX = Math.min(minX, v);
                maxX = Math.max(maxX, v);
            }
        }
        this.range = {
            minX: Math.floor(minX),
            maxX: Math.ceil(maxX)
        };
    }
    render(ctx, params, _width, height) {
        if (!ctx) return;
        const { stage: stage } = params;
        if (!stage) return;
        this.updateRange(stage);
        const units = this.range.maxX - this.range.minX;
        // 맵이 길어도 화면 세로 안에, 넓어도 원래 미니맵 폭 안에 전부 들어가도록 배율을 줄인다
        // (다른 HUD 가 MINIMAP_WIDTH 를 기준으로 자리를 잡으므로 폭은 넘지 않게 한다)
        const maxHeight = Math.max(0, height - $c2ea39beabe51779$export$786d88d79d18d08b * 2);
        this.scale = Math.min($c2ea39beabe51779$var$MINIMAP_SCALE, maxHeight / stage.goalY, $c2ea39beabe51779$export$cc97458872192ab6 / units);
        this.boundingBox.w = units * this.scale;
        this.boundingBox.h = stage.goalY * this.scale;
        this.lastParams = params;
        this.ctx = ctx;
        ctx.save();
        ctx.fillStyle = params.theme.minimapBackground;
        ctx.translate($c2ea39beabe51779$export$786d88d79d18d08b, $c2ea39beabe51779$export$786d88d79d18d08b);
        ctx.scale(this.scale, this.scale);
        ctx.translate(-this.range.minX, 0);
        ctx.fillRect(this.range.minX, 0, units, stage.goalY);
        this.ctx.lineWidth = 3 / (params.camera.zoom + (0, $1d1927fc5b91d8b6$export$c2cc40734f29867c));
        this.drawEntities(params.entities, params.theme);
        this.drawMarbles(params);
        this.drawViewport(params);
        ctx.restore();
        ctx.save();
        ctx.strokeStyle = 'green';
        ctx.lineWidth = 1;
        ctx.strokeRect(this.boundingBox.x, this.boundingBox.y, this.boundingBox.w, this.boundingBox.h);
        ctx.restore();
    }
    drawViewport(params) {
        this.ctx.save();
        const { camera: camera, size: size } = params;
        const zoom = camera.zoom * (0, $1d1927fc5b91d8b6$export$c2cc40734f29867c);
        const w = size.x / zoom;
        const h = size.y / zoom;
        this.ctx.strokeStyle = params.theme.minimapViewport;
        this.ctx.lineWidth = 1 / zoom;
        this.ctx.strokeRect(camera.x - w / 2, camera.y - h / 2, w, h);
        this.ctx.restore();
    }
    drawEntities(entities, theme) {
        this.ctx.save();
        entities.forEach((entity)=>{
            this.ctx.save();
            this.ctx.fillStyle = entity.shape.color ?? theme.entity[entity.shape.type].fill;
            this.ctx.strokeStyle = entity.shape.color ?? theme.entity[entity.shape.type].outline;
            this.ctx.translate(entity.x, entity.y);
            this.ctx.rotate(entity.angle);
            this.ctx.save();
            const shape = entity.shape;
            switch(shape.type){
                case 'box':
                    {
                        const w = shape.width * 2;
                        const h = shape.height * 2;
                        this.ctx.rotate(shape.rotation);
                        this.ctx.fillRect(-w / 2, -h / 2, w, h);
                        break;
                    }
                case 'circle':
                    this.ctx.beginPath();
                    this.ctx.arc(0, 0, shape.radius, 0, Math.PI * 2, false);
                    this.ctx.stroke();
                    break;
                case 'polyline':
                    if (shape.points.length > 0) {
                        this.ctx.beginPath();
                        this.ctx.moveTo(shape.points[0][0], shape.points[0][1]);
                        for(let i = 1; i < shape.points.length; i++)this.ctx.lineTo(shape.points[i][0], shape.points[i][1]);
                        this.ctx.stroke();
                    }
                    break;
            }
            this.ctx.restore();
            this.ctx.restore();
        });
        this.ctx.restore();
    }
    drawMarbles(params) {
        const { marbles: marbles } = params;
        const viewPort = {
            x: params.camera.x,
            y: params.camera.y,
            w: params.size.x,
            h: params.size.y,
            zoom: params.camera.zoom * (0, $1d1927fc5b91d8b6$export$c2cc40734f29867c)
        };
        marbles.forEach((marble)=>{
            marble.render(this.ctx, 1, false, true, undefined, viewPort, params.theme);
        });
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $5d9d2ddcc4e90c63$export$adf7c0fe6059d774)
], $c2ea39beabe51779$export$a8b4308ba35ee473.prototype, "onMouseMove", null);





const $2139b4f99d5088b5$var$lifetime = 3000;
class $2139b4f99d5088b5$export$c36c68baa13912a5 {
    constructor(x, y){
        this._elapsed = 0;
        this.position = {
            x: 0,
            y: 0
        };
        this.force = {
            x: 0,
            y: 0
        };
        this.color = '';
        this.isDestroy = false;
        this.position.x = x;
        this.position.y = y;
        const force = Math.random() * 250;
        const ang = (0, $28770b279d7ab5b1$export$29e4e862bebba87f)(90 * Math.random() - 180);
        const fx = Math.cos(ang) * force;
        const fy = Math.sin(ang) * force;
        this.color = `hsl(${Math.random() * 360} 50% 50%)`;
        this.force = {
            x: fx,
            y: fy
        };
    }
    update(deltaTime) {
        this._elapsed += deltaTime;
        const delta = (0, $5aa23f633f590d4c$export$9b781de7bf37bf48).mul(this.force, deltaTime / 100);
        this.position = (0, $5aa23f633f590d4c$export$9b781de7bf37bf48).add(this.position, delta);
        this.force.y += 10 * deltaTime / 100;
        if (this._elapsed > $2139b4f99d5088b5$var$lifetime) this.isDestroy = true;
    }
    render(ctx) {
        ctx.save();
        ctx.globalAlpha = 1 - (this._elapsed / $2139b4f99d5088b5$var$lifetime) ** 2;
        ctx.fillStyle = this.color;
        ctx.fillRect(this.position.x, this.position.y, 20, 20);
        ctx.restore();
    }
}


class $69fffa06e2cc8da9$export$6658904c50100579 {
    update(deltaTime) {
        this._particles.forEach((particle)=>{
            particle.update(deltaTime);
        });
        this._particles = this._particles.filter((particle)=>!particle.isDestroy);
    }
    render(ctx) {
        this._particles.forEach((particle)=>particle.render(ctx));
    }
    shot(x, y) {
        for(let i = 0; i < 200; i++)this._particles.push(new (0, $2139b4f99d5088b5$export$c36c68baa13912a5)(x, y));
    }
    constructor(){
        this._particles = [];
    }
}


/**
 * @param {Parameters<import('box2d-wasm')>} args
 * @return {ReturnType<import('box2d-wasm')>}
 */ 

var $e6be656c8b5afbd4$export$2e2bcd8739ae039 = async (...args)=>{
    /**
   * This validation expression comes from wasm-feature-detect:
   * https://github.com/GoogleChromeLabs/wasm-feature-detect
   * 
   * Copyright 2019 Google Inc. All Rights Reserved.
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *     http://www.apache.org/licenses/LICENSE-2.0
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */ const hasSIMD = WebAssembly.validate(new Uint8Array([
        0,
        97,
        115,
        109,
        1,
        0,
        0,
        0,
        1,
        5,
        1,
        96,
        0,
        1,
        123,
        3,
        2,
        1,
        0,
        10,
        10,
        1,
        8,
        0,
        65,
        0,
        253,
        15,
        253,
        98,
        11
    ]));
    /** @type {{ 'default': import('box2d-wasm') }} */ const Box2DModule = await (hasSIMD ? (parcelRequire("iyjrR")) : (parcelRequire("8ZFBQ")));
    const { 'default': Box2DFactory } = Box2DModule;
    // awaiting gives us a better stack trace (at the cost of an extra microtask)
    return await Box2DFactory(...args);
};


class $fafe2abfa7f98b9f$export$81ba3d9458692cc2 {
    async init() {
        this.Box2D = await (0, $e6be656c8b5afbd4$export$2e2bcd8739ae039)();
        this.gravity = new this.Box2D.b2Vec2(0, 10);
        this.world = new this.Box2D.b2World(this.gravity);
        console.log('box2d ready');
    }
    clear() {
        this.clearEntities();
    }
    clearMarbles() {
        Object.values(this.marbleMap).forEach((body)=>{
            this.world.DestroyBody(body);
        });
        this.marbleMap = {};
    }
    createStage(stage) {
        this.createEntities(stage.entities);
    }
    createEntities(entities) {
        if (!entities) return;
        const bodyTypes = {
            static: this.Box2D.b2_staticBody,
            kinematic: this.Box2D.b2_kinematicBody
        };
        entities.forEach((entity)=>{
            const bodyDef = new this.Box2D.b2BodyDef();
            bodyDef.set_type(bodyTypes[entity.type]);
            const body = this.world.CreateBody(bodyDef);
            const fixtureDef = new this.Box2D.b2FixtureDef();
            fixtureDef.set_density(entity.props.density);
            fixtureDef.set_restitution(entity.props.restitution);
            let shape;
            switch(entity.shape.type){
                case 'box':
                    shape = new this.Box2D.b2PolygonShape();
                    shape.SetAsBox(entity.shape.width, entity.shape.height, 0, entity.shape.rotation);
                    fixtureDef.set_shape(shape);
                    body.CreateFixture(fixtureDef);
                    break;
                case 'polyline':
                    shape = new this.Box2D.b2EdgeShape();
                    for(let i = 0; i < entity.shape.points.length - 1; i++){
                        const p1 = entity.shape.points[i];
                        const p2 = entity.shape.points[i + 1];
                        const v1 = new this.Box2D.b2Vec2(p1[0], p1[1]);
                        const v2 = new this.Box2D.b2Vec2(p2[0], p2[1]);
                        const edge = new this.Box2D.b2EdgeShape();
                        edge.SetTwoSided(v1, v2);
                        body.CreateFixture(edge, 1);
                    }
                    break;
                case 'circle':
                    shape = new this.Box2D.b2CircleShape();
                    shape.set_m_radius(entity.shape.radius);
                    fixtureDef.set_shape(shape);
                    body.CreateFixture(fixtureDef);
                    break;
            }
            body.SetAngularVelocity(entity.props.angularVelocity);
            body.SetTransform(new this.Box2D.b2Vec2(entity.position.x, entity.position.y), 0);
            this.entities.push({
                body: body,
                x: entity.position.x,
                y: entity.position.y,
                angle: 0,
                shape: entity.shape,
                life: entity.props.life ?? -1
            });
        });
    }
    clearEntities() {
        this.entities.forEach((entity)=>{
            this.world.DestroyBody(entity.body);
        });
        this.entities = [];
    }
    createMarble(id, x, y) {
        const circleShape = new this.Box2D.b2CircleShape();
        circleShape.set_m_radius(0.25);
        const bodyDef = new this.Box2D.b2BodyDef();
        bodyDef.set_type(this.Box2D.b2_dynamicBody);
        bodyDef.set_position(new this.Box2D.b2Vec2(x, y));
        const body = this.world.CreateBody(bodyDef);
        body.CreateFixture(circleShape, 1 + Math.random());
        body.SetAwake(false);
        body.SetEnabled(false);
        this.marbleMap[id] = body;
    }
    shakeMarble(id) {
        const body = this.marbleMap[id];
        if (body) body.ApplyLinearImpulseToCenter(new this.Box2D.b2Vec2(Math.random() * 10 - 5, Math.random() * 10 - 5), true);
    }
    removeMarble(id) {
        const marble = this.marbleMap[id];
        if (marble) {
            this.world.DestroyBody(marble);
            delete this.marbleMap[id];
        }
    }
    boostMarble(id, impulse) {
        const marble = this.marbleMap[id];
        if (marble) marble.ApplyLinearImpulseToCenter(new this.Box2D.b2Vec2(0, impulse), true);
    }
    /** 실험용: 현재 진행 방향을 유지한 채 속도 크기만 미세 조정한다. */ adjustMarbleSpeed(id, factor) {
        const marble = this.marbleMap[id];
        if (!marble) return;
        const velocity = marble.GetLinearVelocity();
        velocity.op_mul(factor);
        marble.SetLinearVelocity(velocity);
    }
    /** 실험 진단 전용: 구슬의 실제 Box2D 속도와 접촉 상태를 읽는다. 물리 상태를 변경하지 않는다. */ getMarbleTelemetry(id) {
        const marble = this.marbleMap[id];
        if (!marble) return null;
        const position = marble.GetPosition();
        const velocity = marble.GetLinearVelocity();
        let touching = false;
        for(let edge = marble.GetContactList(); this.Box2D.getPointer(edge) !== 0; edge = edge.next)if (edge.contact.IsTouching()) {
            touching = true;
            break;
        }
        return {
            x: position.x,
            y: position.y,
            vx: velocity.x,
            vy: velocity.y,
            speed: Math.hypot(velocity.x, velocity.y),
            touching: touching
        };
    }
    getMarblePosition(id) {
        const marble = this.marbleMap[id];
        if (marble) {
            const pos = marble.GetPosition();
            return {
                x: pos.x,
                y: pos.y,
                angle: marble.GetAngle()
            };
        } else return {
            x: 0,
            y: 0,
            angle: 0
        };
    }
    getEntities() {
        return this.entities.map((entity)=>{
            return {
                ...entity,
                angle: entity.body.GetAngle()
            };
        });
    }
    impact(id) {
        const src = this.marbleMap[id];
        if (!src) return;
        Object.values(this.marbleMap).forEach((body)=>{
            if (body === src) return;
            const distVector = new this.Box2D.b2Vec2(body.GetPosition().x, body.GetPosition().y);
            distVector.op_sub(src.GetPosition());
            const distSq = distVector.LengthSquared();
            if (distSq < 100) {
                distVector.Normalize();
                const power = 1 - distVector.Length() / 10;
                distVector.op_mul(power * power * 5);
                body.ApplyLinearImpulseToCenter(distVector, true);
            }
        });
    }
    start() {
        for(const key in this.marbleMap){
            const marble = this.marbleMap[key];
            marble.SetAwake(true);
            marble.SetEnabled(true);
        }
    }
    // contact 목록에는 AABB만 겹친 contact도 섞여 있고, 새 contact가 맨 앞에 붙으므로 전체를 순회해야 한다.
    isTouchingAny(body) {
        const { getPointer: getPointer } = this.Box2D;
        for(let edge = body.GetContactList(); getPointer(edge) !== 0; edge = edge.next){
            if (edge.contact.IsTouching()) return true;
        }
        return false;
    }
    step(deltaSeconds) {
        this.deleteCandidates.forEach((body)=>{
            this.world.DestroyBody(body);
        });
        this.deleteCandidates = [];
        this.world.Step(deltaSeconds, 6, 2);
        for(let i = this.entities.length - 1; i >= 0; i--){
            const entity = this.entities[i];
            if (entity.life > 0) {
                if (this.isTouchingAny(entity.body)) {
                    this.deleteCandidates.push(entity.body);
                    this.entities.splice(i, 1);
                }
            }
        }
    }
    constructor(){
        this.marbleMap = {};
        this.entities = [];
        this.deleteCandidates = [];
    }
}


// 진행도 지도: 순위 계산용. 맵의 각 위치에서 결승선까지 "벽을 피해 가는" 거리.
//
// y 좌표만으로 순위를 매기면 옆으로 돌아가거나 위로 올라갔다 내려오는 맵에서 순위가 틀어진다.
// 맵을 불러올 때 한 번 격자를 만들어 결승선에서부터 거리를 퍼뜨려 두고,
// 매 프레임에는 구슬 위치 주변 칸 몇 개만 읽어 남은 거리를 구한다.
//
// - 고정된 벽만 막힘으로 본다. 회전하는 장애물은 잠깐 막을 뿐 길을 정하지 않고,
//   부서지는 벽은 부서지면 지나갈 수 있으므로 둘 다 길로 본다.
// - 벽을 구슬 반지름만큼 두껍게 잡아 구슬이 못 지나가는 틈은 막힌 것으로 본다.
// - 중력: 위로 가는 이동은 회전 장애물이 쓸고 지나가는 곳이나 튕겨 내는 장애물 근처("올라가는 구역") 에서만
//   보통 비용이고, 그 밖에서는 UP_PENALTY 배 비용이다. 놓치면 돌아 올라와야 하는 바닥이 실제처럼 멀어진다.
// - 일방통행 선(stage.progress.oneWays): 맵 제작자가 지정한 선. 화살표 반대 방향으로는 넘을 수 없다고 본다.
const $4359542a512d968a$var$CELL = 0.25;
const $4359542a512d968a$var$MARBLE_RADIUS = 0.25;
/** 벽 판정 두께. 칸이 대각선으로 새지 않으려면 CELL * √2 / 2 이상이어야 한다 */ const $4359542a512d968a$var$INFLATE = Math.max($4359542a512d968a$var$MARBLE_RADIUS, $4359542a512d968a$var$CELL * Math.SQRT2 / 2 + 0.001);
/** 출발 통로 위쪽은 구슬이 쌓이는 곳까지만 본다. 그보다 위는 맨 윗줄 값에 거리를 더한다 */ const $4359542a512d968a$var$TOP_LIMIT = -30;
const $4359542a512d968a$var$MARGIN = 1;
/** 결승선과 이어지지 않은 곳(갇힌 공간) 의 거리. 이어진 곳보다 항상 뒤로 간다 */ const $4359542a512d968a$var$UNREACHABLE = 1e6;
const $4359542a512d968a$var$BLOCKED = -1;
/** 올라가는 구역 밖에서 위로 가는 이동의 비용 배수 */ const $4359542a512d968a$var$UP_PENALTY = 10;
/** 회전 장애물이 쓸고 지나가는 범위에 더하는 여유 */ const $4359542a512d968a$var$LIFT_MARGIN = $4359542a512d968a$var$MARBLE_RADIUS + 0.5;
/** 튕겨 내는 장애물(탄성 1 초과) 표면에서 이 거리 안은 올라갈 수 있다고 본다 */ const $4359542a512d968a$var$BOUNCE_RANGE = 1.5;
class $4359542a512d968a$export$c9027bf99da09021 {
    constructor(stage){
        const entities = (stage.entities ?? []).filter($4359542a512d968a$var$isBlocking);
        let minX = Infinity;
        let maxX = -Infinity;
        let minY = Infinity;
        for (const e of entities)for (const [x, y] of $4359542a512d968a$var$reachPoints(e)){
            minX = Math.min(minX, x);
            maxX = Math.max(maxX, x);
            minY = Math.min(minY, y);
        }
        if (!Number.isFinite(minX)) {
            minX = 0;
            maxX = 26;
            minY = 0;
        }
        this.minX = Math.floor(minX - $4359542a512d968a$var$MARGIN);
        this.minY = Math.floor(Math.max(minY, $4359542a512d968a$var$TOP_LIMIT) - $4359542a512d968a$var$MARGIN);
        const maxY = stage.goalY + $4359542a512d968a$var$MARGIN;
        this.cols = Math.ceil((maxX + $4359542a512d968a$var$MARGIN - this.minX) / $4359542a512d968a$var$CELL) + 1;
        this.rows = Math.ceil((maxY - this.minY) / $4359542a512d968a$var$CELL) + 1;
        this.dist = new Float32Array(this.cols * this.rows).fill(Infinity);
        for (const e of entities)this.rasterize(e);
        this.lift = this.findLiftCells(stage.entities ?? []);
        this.oneWays = (stage.progress?.oneWays ?? []).filter((l)=>l.from[0] !== l.to[0] || l.from[1] !== l.to[1]);
        this.nearOneWay = this.oneWays.length ? this.markOneWayCells() : null;
        this.maxDist = this.propagate(stage.goalY);
    }
    static{
        this.cache = new WeakMap();
    }
    /** 같은 맵 객체면 다시 만들지 않는다 */ static for(stage) {
        let map = $4359542a512d968a$export$c9027bf99da09021.cache.get(stage);
        if (!map) {
            map = new $4359542a512d968a$export$c9027bf99da09021(stage);
            $4359542a512d968a$export$c9027bf99da09021.cache.set(stage, map);
        }
        return map;
    }
    cellX(col) {
        return this.minX + col * $4359542a512d968a$var$CELL;
    }
    cellY(row) {
        return this.minY + row * $4359542a512d968a$var$CELL;
    }
    /**
   * 엔티티 표면에서 INFLATE 안쪽 칸을 막는다.
   * 선과 사각형은 선분마다 따로 표시한다 (사각형은 네 변. 안쪽 칸은 벽에 둘러싸여 어차피 닿을 수 없다).
   * 엔티티 전체의 경계 상자로 훑으면 맵을 가로지르는 긴 선에서 칸 수 × 선분 수만큼 계산하게 된다
   */ rasterize(e) {
        if (e.shape.type !== 'circle') {
            const pts = $4359542a512d968a$var$reachPoints(e);
            const closed = e.shape.type === 'box';
            for(let i = 0; i < pts.length - (closed ? 0 : 1); i++){
                const [ax, ay] = pts[i];
                const [bx, by] = pts[(i + 1) % pts.length];
                this.rasterizeSegment(ax, ay, bx, by);
            }
            return;
        }
        // 원은 크기 상한(반지름 10) 이 작아 경계 상자로 훑는다
        const { x: x, y: y } = e.position;
        const reach = e.shape.radius + $4359542a512d968a$var$INFLATE;
        const distanceTo = $4359542a512d968a$var$shapeDistance(e);
        const c0 = Math.max(0, Math.floor((x - reach - this.minX) / $4359542a512d968a$var$CELL));
        const c1 = Math.min(this.cols - 1, Math.ceil((x + reach - this.minX) / $4359542a512d968a$var$CELL));
        const r0 = Math.max(0, Math.floor((y - reach - this.minY) / $4359542a512d968a$var$CELL));
        const r1 = Math.min(this.rows - 1, Math.ceil((y + reach - this.minY) / $4359542a512d968a$var$CELL));
        for(let r = r0; r <= r1; r++){
            const cy = this.cellY(r);
            for(let c = c0; c <= c1; c++)if (distanceTo(this.cellX(c), cy) < $4359542a512d968a$var$INFLATE) this.dist[r * this.cols + c] = $4359542a512d968a$var$BLOCKED;
        }
    }
    /**
   * 선분에서 INFLATE 안쪽 칸을 막는다. 격자 밖 부분은 잘라 내고, 선분을 따라 반 칸씩 걸으며 주변 칸만 본다.
   * 비용은 격자 안 선분 길이에 비례한다
   */ rasterizeSegment(ax, ay, bx, by) {
        const minX = this.minX - $4359542a512d968a$var$INFLATE;
        const maxX = this.minX + (this.cols - 1) * $4359542a512d968a$var$CELL + $4359542a512d968a$var$INFLATE;
        const minY = this.minY - $4359542a512d968a$var$INFLATE;
        const maxY = this.minY + (this.rows - 1) * $4359542a512d968a$var$CELL + $4359542a512d968a$var$INFLATE;
        // Liang-Barsky 로 격자 범위에 자른다
        const dx = bx - ax;
        const dy = by - ay;
        let t0 = 0;
        let t1 = 1;
        for (const [p, q] of [
            [
                -dx,
                ax - minX
            ],
            [
                dx,
                maxX - ax
            ],
            [
                -dy,
                ay - minY
            ],
            [
                dy,
                maxY - ay
            ]
        ])if (p === 0) {
            if (q < 0) return;
        } else {
            const t = q / p;
            if (p < 0) t0 = Math.max(t0, t);
            else t1 = Math.min(t1, t);
        }
        if (t0 > t1) return;
        const sx = ax + dx * t0;
        const sy = ay + dy * t0;
        const len = Math.hypot(dx, dy) * (t1 - t0);
        const steps = Math.max(1, Math.ceil(len / ($4359542a512d968a$var$CELL / 2)));
        const span = Math.ceil($4359542a512d968a$var$INFLATE / $4359542a512d968a$var$CELL) + 1;
        for(let k = 0; k <= steps; k++){
            const t = k / steps;
            const c = Math.round((sx + dx * (t1 - t0) * t - this.minX) / $4359542a512d968a$var$CELL);
            const r = Math.round((sy + dy * (t1 - t0) * t - this.minY) / $4359542a512d968a$var$CELL);
            for(let rr = Math.max(0, r - span); rr <= Math.min(this.rows - 1, r + span); rr++)for(let cc = Math.max(0, c - span); cc <= Math.min(this.cols - 1, c + span); cc++){
                const i = rr * this.cols + cc;
                if (this.dist[i] === $4359542a512d968a$var$BLOCKED) continue;
                if ($4359542a512d968a$var$segmentDistance(this.cellX(cc), this.cellY(rr), ax, ay, bx, by) < $4359542a512d968a$var$INFLATE) this.dist[i] = $4359542a512d968a$var$BLOCKED;
            }
        }
    }
    /** 회전 장애물이 쓸고 지나가는 원, 튕겨 내는 장애물 주변을 올라가는 구역으로 표시한다 */ findLiftCells(all) {
        const lift = new Uint8Array(this.cols * this.rows);
        const mark = (x0, x1, y0, y1, inside)=>{
            const c0 = Math.max(0, Math.floor((x0 - this.minX) / $4359542a512d968a$var$CELL));
            const c1 = Math.min(this.cols - 1, Math.ceil((x1 - this.minX) / $4359542a512d968a$var$CELL));
            const r0 = Math.max(0, Math.floor((y0 - this.minY) / $4359542a512d968a$var$CELL));
            const r1 = Math.min(this.rows - 1, Math.ceil((y1 - this.minY) / $4359542a512d968a$var$CELL));
            for(let r = r0; r <= r1; r++){
                for(let c = c0; c <= c1; c++)if (inside(this.cellX(c), this.cellY(r))) lift[r * this.cols + c] = 1;
            }
        };
        for (const e of all){
            if (e.type === 'kinematic' && e.props.angularVelocity !== 0) {
                // 물리 몸체는 position 을 중심으로 돈다
                const { x: ox, y: oy } = e.position;
                const reach = Math.max(...$4359542a512d968a$var$reachPoints(e).map(([x, y])=>Math.hypot(x - ox, y - oy))) + $4359542a512d968a$var$LIFT_MARGIN;
                mark(ox - reach, ox + reach, oy - reach, oy + reach, (x, y)=>Math.hypot(x - ox, y - oy) <= reach);
            }
            if (e.props.restitution > 1) {
                const pts = $4359542a512d968a$var$reachPoints(e);
                const distanceTo = $4359542a512d968a$var$shapeDistance(e);
                mark(Math.min(...pts.map((p)=>p[0])) - $4359542a512d968a$var$BOUNCE_RANGE, Math.max(...pts.map((p)=>p[0])) + $4359542a512d968a$var$BOUNCE_RANGE, Math.min(...pts.map((p)=>p[1])) - $4359542a512d968a$var$BOUNCE_RANGE, Math.max(...pts.map((p)=>p[1])) + $4359542a512d968a$var$BOUNCE_RANGE, (x, y)=>distanceTo(x, y) <= $4359542a512d968a$var$BOUNCE_RANGE);
            }
        }
        return lift;
    }
    /** 일방통행 선에서 한 칸 반 안쪽 칸을 표시한다 (그보다 먼 칸끼리의 이동은 선과 만날 수 없다) */ markOneWayCells() {
        const near = new Uint8Array(this.cols * this.rows);
        const range = $4359542a512d968a$var$CELL * 1.5;
        for (const { from: from, to: to } of this.oneWays){
            const c0 = Math.max(0, Math.floor((Math.min(from[0], to[0]) - range - this.minX) / $4359542a512d968a$var$CELL));
            const c1 = Math.min(this.cols - 1, Math.ceil((Math.max(from[0], to[0]) + range - this.minX) / $4359542a512d968a$var$CELL));
            const r0 = Math.max(0, Math.floor((Math.min(from[1], to[1]) - range - this.minY) / $4359542a512d968a$var$CELL));
            const r1 = Math.min(this.rows - 1, Math.ceil((Math.max(from[1], to[1]) + range - this.minY) / $4359542a512d968a$var$CELL));
            for(let r = r0; r <= r1; r++){
                for(let c = c0; c <= c1; c++)if ($4359542a512d968a$var$segmentDistance(this.cellX(c), this.cellY(r), from[0], from[1], to[0], to[1]) <= range) near[r * this.cols + c] = 1;
            }
        }
        return near;
    }
    /** 칸 j 에서 칸 i 로 가는 이동이 일방통행 선을 거꾸로 넘는지 */ crossesOneWayBackward(j, i) {
        const ax = this.cellX(j % this.cols);
        const ay = this.cellY(j / this.cols | 0);
        const bx = this.cellX(i % this.cols);
        const by = this.cellY(i / this.cols | 0);
        for (const { from: from, to: to } of this.oneWays){
            if (!$4359542a512d968a$var$segmentsIntersect(ax, ay, bx, by, from[0], from[1], to[0], to[1])) continue;
            // 통과 방향 = 선 방향을 화면에서 시계 방향으로 90도 돌린 쪽 (y 가 아래로 커지므로 (-dy, dx))
            const nx = -(to[1] - from[1]);
            const ny = to[0] - from[0];
            if ((bx - ax) * nx + (by - ay) * ny < 0) return true;
        }
        return false;
    }
    /** 결승선 아래 칸에서 출발하는 Dijkstra (8방향, 대각선 √2). 가장 먼 거리를 돌려준다 */ propagate(goalY) {
        const { cols: cols, rows: rows, dist: dist } = this;
        const heap = new $4359542a512d968a$var$MinHeap(cols * rows);
        const goalRow = Math.max(0, Math.min(rows - 1, Math.ceil((goalY - this.minY) / $4359542a512d968a$var$CELL)));
        for(let r = goalRow; r < rows; r++)for(let c = 0; c < cols; c++){
            const i = r * cols + c;
            if (dist[i] === $4359542a512d968a$var$BLOCKED) continue;
            dist[i] = 0;
            heap.push(i, 0);
        }
        const D = $4359542a512d968a$var$CELL * Math.SQRT2;
        const steps = [
            [
                -1,
                0,
                $4359542a512d968a$var$CELL
            ],
            [
                1,
                0,
                $4359542a512d968a$var$CELL
            ],
            [
                0,
                -1,
                $4359542a512d968a$var$CELL
            ],
            [
                0,
                1,
                $4359542a512d968a$var$CELL
            ],
            [
                -1,
                -1,
                D
            ],
            [
                1,
                -1,
                D
            ],
            [
                -1,
                1,
                D
            ],
            [
                1,
                1,
                D
            ]
        ];
        let maxDist = 0;
        while(heap.size > 0){
            const d = heap.topKey();
            const i = heap.pop();
            if (d > dist[i]) continue;
            maxDist = d;
            const r = i / cols | 0;
            const c = i - r * cols;
            for (const [dc, dr, w] of steps){
                const nc = c + dc;
                const nr = r + dr;
                if (nc < 0 || nc >= cols || nr < 0 || nr >= rows) continue;
                const j = nr * cols + nc;
                const cur = dist[j];
                if (cur === $4359542a512d968a$var$BLOCKED) continue;
                // 대각선은 양옆 두 칸이 모두 열려 있어야 지나간다 (벽 모서리를 뚫지 않게)
                if (dc && dr && (dist[r * cols + nc] === $4359542a512d968a$var$BLOCKED || dist[nr * cols + c] === $4359542a512d968a$var$BLOCKED)) continue;
                // 구슬은 j → i 로 움직인다. 일방통행 선을 거꾸로 넘는 이동은 없다
                if (this.nearOneWay && (this.nearOneWay[i] || this.nearOneWay[j]) && this.crossesOneWayBackward(j, i)) continue;
                // i 가 위쪽이면 올라가는 이동
                const up = dr > 0 && !this.lift[i] && !this.lift[j];
                const nd = d + (up ? w * $4359542a512d968a$var$UP_PENALTY : w);
                if (nd < cur) {
                    dist[j] = nd;
                    heap.push(j, nd);
                }
            }
        }
        return maxDist;
    }
    /**
   * (x, y) 에서 결승까지 남은 거리. 작을수록 앞선다.
   * 주변 3x3 칸에서 "칸의 거리 + 칸 중심까지 직선거리" 의 최솟값이라 칸 안에서도 값이 연속으로 바뀐다
   */ distanceAt(x, y) {
        let extra = 0;
        let qy = y;
        const top = this.minY;
        if (qy < top) {
            extra = top - qy;
            qy = top;
        }
        const col = Math.round((x - this.minX) / $4359542a512d968a$var$CELL);
        const row = Math.round((qy - this.minY) / $4359542a512d968a$var$CELL);
        if (row >= this.rows) return 0;
        let best = Infinity;
        for(let radius = 1; radius <= 3 && best === Infinity; radius++)for(let dr = -radius; dr <= radius; dr++){
            const r = row + dr;
            if (r < 0 || r >= this.rows) continue;
            for(let dc = -radius; dc <= radius; dc++){
                const c = col + dc;
                if (c < 0 || c >= this.cols) continue;
                const d = this.dist[r * this.cols + c];
                if (d < 0 || d === Infinity) continue;
                const cand = d + Math.hypot(x - this.cellX(c), qy - this.cellY(r));
                if (cand < best) best = cand;
            }
        }
        // 이어지지 않은 곳: y 순서는 지키되 이어진 곳보다 뒤
        if (best === Infinity) return $4359542a512d968a$var$UNREACHABLE - y;
        return best + extra;
    }
    /** 진행도 지도 그림 (테스트 플레이에서 순위 계산을 확인할 때). 한 칸 = 한 픽셀, 흰색 = 올라가는 구역 */ toCanvas() {
        const canvas = document.createElement('canvas');
        canvas.width = this.cols;
        canvas.height = this.rows;
        const ctx = canvas.getContext('2d');
        const img = ctx.createImageData(this.cols, this.rows);
        for(let i = 0; i < this.dist.length; i++){
            const d = this.dist[i];
            const o = i * 4;
            if (d === $4359542a512d968a$var$BLOCKED) continue;
            if (d === Infinity) {
                img.data.set([
                    255,
                    0,
                    80,
                    150
                ], o);
                continue;
            }
            // 결승 가까이 = 파랑, 멀수록 빨강. 띠를 그려 등고선처럼 보이게 한다
            const t = this.maxDist > 0 ? d / this.maxDist : 0;
            const band = Math.floor(d / 2) % 2 === 0 ? 1 : 0.75;
            const [r, g, b] = $4359542a512d968a$var$hsl((1 - t) * 240, 0.9, 0.5 * band);
            img.data.set([
                r,
                g,
                b,
                110
            ], o);
            if (this.lift[i]) img.data.set([
                255,
                255,
                255,
                170
            ], o);
        }
        ctx.putImageData(img, 0, 0);
        return canvas;
    }
    /** 월드 좌표에 진행도 지도 그림과 일방통행 선(통과 방향 화살표) 을 그린다 */ drawDebug(ctx, image) {
        ctx.save();
        ctx.imageSmoothingEnabled = false;
        ctx.drawImage(image, this.minX - $4359542a512d968a$var$CELL / 2, this.minY - $4359542a512d968a$var$CELL / 2, this.cols * $4359542a512d968a$var$CELL, this.rows * $4359542a512d968a$var$CELL);
        ctx.strokeStyle = '#ff0';
        ctx.fillStyle = '#ff0';
        ctx.lineWidth = 0.1;
        for (const { from: from, to: to } of this.oneWays){
            ctx.beginPath();
            ctx.moveTo(from[0], from[1]);
            ctx.lineTo(to[0], to[1]);
            ctx.stroke();
            const len = Math.hypot(to[0] - from[0], to[1] - from[1]);
            const nx = -(to[1] - from[1]) / len;
            const ny = (to[0] - from[0]) / len;
            const mx = (from[0] + to[0]) / 2;
            const my = (from[1] + to[1]) / 2;
            ctx.beginPath();
            ctx.moveTo(mx + nx * 0.6, my + ny * 0.6);
            ctx.lineTo(mx - ny * 0.25, my + nx * 0.25);
            ctx.lineTo(mx + ny * 0.25, my - nx * 0.25);
            ctx.closePath();
            ctx.fill();
        }
        ctx.restore();
    }
}
function $4359542a512d968a$var$isBlocking(e) {
    if ((e.props.life ?? -1) > 0) return false;
    if (e.type === 'kinematic' && e.props.angularVelocity !== 0) return false;
    return true;
}
/** 엔티티 모양의 꼭짓점 (원은 외접 사각형) — 경계 상자 계산용 */ function $4359542a512d968a$var$reachPoints(e) {
    const { x: x, y: y } = e.position;
    const s = e.shape;
    switch(s.type){
        case 'polyline':
            return s.points.map(([px, py])=>[
                    x + px,
                    y + py
                ]);
        case 'circle':
            return [
                [
                    x - s.radius,
                    y - s.radius
                ],
                [
                    x + s.radius,
                    y + s.radius
                ]
            ];
        case 'box':
            {
                const cos = Math.cos(s.rotation);
                const sin = Math.sin(s.rotation);
                return [
                    [
                        -1,
                        -1
                    ],
                    [
                        1,
                        -1
                    ],
                    [
                        1,
                        1
                    ],
                    [
                        -1,
                        1
                    ]
                ].map(([sx, sy])=>{
                    const lx = sx * s.width;
                    const ly = sy * s.height;
                    return [
                        x + lx * cos - ly * sin,
                        y + lx * sin + ly * cos
                    ];
                });
            }
    }
}
/** 엔티티 표면까지 거리 함수 (안쪽은 0) */ function $4359542a512d968a$var$shapeDistance(e) {
    const { x: ox, y: oy } = e.position;
    const s = e.shape;
    switch(s.type){
        case 'circle':
            return (x, y)=>Math.max(0, Math.hypot(x - ox, y - oy) - s.radius);
        case 'box':
            {
                // SetAsBox(width, height) 는 반폭/반높이
                const cos = Math.cos(-s.rotation);
                const sin = Math.sin(-s.rotation);
                return (x, y)=>{
                    const dx = x - ox;
                    const dy = y - oy;
                    const lx = Math.abs(dx * cos - dy * sin) - s.width;
                    const ly = Math.abs(dx * sin + dy * cos) - s.height;
                    return Math.hypot(Math.max(lx, 0), Math.max(ly, 0));
                };
            }
        case 'polyline':
            {
                const pts = s.points.map(([px, py])=>[
                        ox + px,
                        oy + py
                    ]);
                return (x, y)=>{
                    let best = Infinity;
                    for(let i = 0; i < pts.length - 1; i++)best = Math.min(best, $4359542a512d968a$var$segmentDistance(x, y, pts[i][0], pts[i][1], pts[i + 1][0], pts[i + 1][1]));
                    return best;
                };
            }
    }
}
/** 두 선분이 만나는지 (끝점이 닿는 경우 포함) */ function $4359542a512d968a$var$segmentsIntersect(ax, ay, bx, by, cx, cy, dx, dy) {
    const cross = (px, py, qx, qy, rx, ry)=>(qx - px) * (ry - py) - (qy - py) * (rx - px);
    const d1 = cross(cx, cy, dx, dy, ax, ay);
    const d2 = cross(cx, cy, dx, dy, bx, by);
    const d3 = cross(ax, ay, bx, by, cx, cy);
    const d4 = cross(ax, ay, bx, by, dx, dy);
    return (d1 <= 0 && d2 >= 0 || d1 >= 0 && d2 <= 0) && (d3 <= 0 && d4 >= 0 || d3 >= 0 && d4 <= 0);
}
function $4359542a512d968a$var$segmentDistance(px, py, ax, ay, bx, by) {
    const vx = bx - ax;
    const vy = by - ay;
    const len = vx * vx + vy * vy;
    const t = len === 0 ? 0 : Math.max(0, Math.min(1, ((px - ax) * vx + (py - ay) * vy) / len));
    return Math.hypot(px - (ax + t * vx), py - (ay + t * vy));
}
function $4359542a512d968a$var$hsl(h, s, l) {
    const k = (n)=>(n + h / 30) % 12;
    const a = s * Math.min(l, 1 - l);
    const f = (n)=>l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    return [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
}
/** 칸 번호를 거리 순으로 꺼내는 이진 힙 (중복 push 허용, 꺼낼 때 낡은 값은 버린다) */ class $4359542a512d968a$var$MinHeap {
    constructor(capacity){
        this.size = 0;
        this.ids = new Int32Array(capacity);
        this.keys = new Float32Array(capacity);
    }
    push(id, key) {
        if (this.size === this.ids.length) this.grow();
        let i = this.size++;
        while(i > 0){
            const p = i - 1 >> 1;
            if (this.keys[p] <= key) break;
            this.ids[i] = this.ids[p];
            this.keys[i] = this.keys[p];
            i = p;
        }
        this.ids[i] = id;
        this.keys[i] = key;
    }
    topKey() {
        return this.keys[0];
    }
    pop() {
        const top = this.ids[0];
        const lastId = this.ids[--this.size];
        const lastKey = this.keys[this.size];
        let i = 0;
        for(;;){
            const l = 2 * i + 1;
            if (l >= this.size) break;
            const r = l + 1;
            const m = r < this.size && this.keys[r] < this.keys[l] ? r : l;
            if (this.keys[m] >= lastKey) break;
            this.ids[i] = this.ids[m];
            this.keys[i] = this.keys[m];
            i = m;
        }
        this.ids[i] = lastId;
        this.keys[i] = lastKey;
        return top;
    }
    grow() {
        const ids = new Int32Array(this.ids.length * 2);
        const keys = new Float32Array(this.keys.length * 2);
        ids.set(this.ids);
        keys.set(this.keys);
        this.ids = ids;
        this.keys = keys;
    }
}




class $e0350dec16bbe919$export$795f70ffe4ca76fc {
    onWheel(e) {
        this._targetY += e.deltaY;
        if (this._targetY > this.maxY) this._targetY = this.maxY;
        this._userMoved = 2000;
    }
    onDblClick(e) {
        if (e) {
            if (navigator.clipboard) {
                const tsv = [];
                let rank = 0;
                tsv.push(...[
                    ...this.winners,
                    ...this.marbles
                ].map((m)=>{
                    rank++;
                    return [
                        rank.toString(),
                        m.name,
                        this.isWinningRank(rank - 1) ? "\u2606" : ''
                    ].join('\t');
                }));
                tsv.unshift([
                    'Rank',
                    'Name',
                    'Winner'
                ].join('\t'));
                navigator.clipboard.writeText(tsv.join('\n')).then(()=>{
                    if (this.messageHandler) this.messageHandler('The result has been copied');
                });
            }
        }
    }
    isWinningRank(rank) {
        return rank >= this.winnerRange.start && rank <= this.winnerRange.end;
    }
    onMessage(func) {
        this.messageHandler = func;
    }
    render(ctx, { winners: winners, marbles: marbles, winnerRange: winnerRange, theme: theme }, width, height) {
        const startX = width - 5;
        const startY = Math.max(-this.fontHeight, this._currentY - height / 2);
        this.maxY = Math.max(0, (marbles.length + winners.length) * this.fontHeight + this.fontHeight);
        this._currentWinner = winners.length;
        this.winners = winners;
        this.marbles = marbles;
        this.winnerRange = winnerRange;
        ctx.save();
        ctx.textAlign = 'right';
        ctx.font = '10pt sans-serif';
        ctx.fillStyle = '#666';
        ctx.fillText(`${winners.length} / ${winners.length + marbles.length}`, width - 5, this.fontHeight);
        ctx.beginPath();
        ctx.rect(width - 150, this.fontHeight + 2, width, this.maxY);
        ctx.clip();
        ctx.translate(0, -startY);
        if (winnerRange.end > winnerRange.start) {
            ctx.fillStyle = 'rgba(255, 215, 0, 0.15)';
            const bandY = winnerRange.start * this.fontHeight + this.fontHeight / 2;
            const bandH = (winnerRange.end - winnerRange.start + 1) * this.fontHeight;
            ctx.fillRect(width - 150, bandY, 150, bandH);
            ctx.fillStyle = 'rgba(255, 215, 0, 0.8)';
            ctx.fillRect(width - 150, bandY, 3, bandH);
        }
        ctx.font = 'bold 11pt sans-serif';
        if (theme.rankStroke) {
            ctx.lineWidth = 2;
            ctx.strokeStyle = theme.rankStroke;
        }
        winners.forEach((marble, rank)=>{
            const y = rank * this.fontHeight;
            if (y >= startY && y <= startY + ctx.canvas.height) {
                ctx.fillStyle = `hsl(${marble.hue} 100% ${theme.marbleLightness}`;
                ctx.strokeText(`${this.isWinningRank(rank) ? "\u2606" : '\u2714'} ${marble.name} #${rank + 1}`, startX, 20 + y);
                ctx.fillText(`${this.isWinningRank(rank) ? "\u2606" : '\u2714'} ${marble.name} #${rank + 1}`, startX, 20 + y);
            }
        });
        ctx.font = '10pt sans-serif';
        marbles.forEach((marble, rank)=>{
            const y = (rank + winners.length) * this.fontHeight;
            if (y >= startY && y <= startY + ctx.canvas.height) {
                ctx.fillStyle = `hsl(${marble.hue} 100% ${theme.marbleLightness}`;
                ctx.strokeText(`${marble.name} #${rank + 1 + winners.length}`, startX, 20 + y);
                ctx.fillText(`${marble.name} #${rank + 1 + winners.length}`, startX, 20 + y);
            }
        });
        ctx.restore();
    }
    update(deltaTime) {
        if (this._currentWinner === -1) return;
        if (this._userMoved > 0) this._userMoved -= deltaTime;
        else this._targetY = this._currentWinner * this.fontHeight + this.fontHeight;
        if (this._currentY !== this._targetY) this._currentY += (this._targetY - this._currentY) * (deltaTime / 250);
        if (Math.abs(this._currentY - this._targetY) < 1) this._currentY = this._targetY;
    }
    getBoundingBox() {
        return null;
    }
    constructor(){
        this._currentY = 0;
        this._targetY = 0;
        this.fontHeight = 16;
        this._userMoved = 0;
        this._currentWinner = -1;
        this.maxY = 0;
        this.winners = [];
        this.marbles = [];
        this.winnerRange = {
            start: 0,
            end: 0
        };
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $5d9d2ddcc4e90c63$export$adf7c0fe6059d774)
], $e0350dec16bbe919$export$795f70ffe4ca76fc.prototype, "onWheel", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $5d9d2ddcc4e90c63$export$adf7c0fe6059d774)
], $e0350dec16bbe919$export$795f70ffe4ca76fc.prototype, "onDblClick", null);



const $f02253094c3bb7fd$var$RESULT_GAP = 16;
const $f02253094c3bb7fd$var$RESULT_NAME_RATIO = 0.13;
const $f02253094c3bb7fd$var$RESULT_TAGLINE_RATIO = 0.1;
const $f02253094c3bb7fd$var$RESULT_TAGLINE_GAP_EM = 0.8;
const $f02253094c3bb7fd$var$RESULT_BAND_PADDING = 12;
const $f02253094c3bb7fd$var$RESULT_BAND_COLOR = 'rgba(0, 0, 0, 0.75)';
const $f02253094c3bb7fd$var$RESULT_LABEL_INSET = 12;
/** 좌상단으로 붙었을 때 '광고' 라벨이 로고와 겹치지 않게 비워두는 왼쪽 여백 */ const $f02253094c3bb7fd$var$RESULT_LABEL_GUTTER = 34;
const $f02253094c3bb7fd$var$QR_TO_LOGO_RATIO = 0.5;
const $f02253094c3bb7fd$var$FADE_IN_MS = 250;
const $f02253094c3bb7fd$var$FADE_OUT_MS = 200;
/** 결과 광고는 한가운데 전체 폭으로 시작해, 이만큼 뒤에 좌상단으로 오므라든다 */ const $f02253094c3bb7fd$var$RESULT_MOVE_DELAY_MS = 2500;
const $f02253094c3bb7fd$var$RESULT_MOVE_MS = 600;
/** 결과 광고를 이만큼 보여준 뒤에 닫기 버튼을 내준다 */ const $f02253094c3bb7fd$var$CLOSE_DELAY_MS = 5000;
const $f02253094c3bb7fd$var$CLOSE_FADE_MS = 250;
const $f02253094c3bb7fd$var$CLOSE_INSET = 12;
const $f02253094c3bb7fd$var$CLOSE_HIT_PADDING = 8;
const $f02253094c3bb7fd$var$SERIF = `'Nanum Myeongjo', 'Noto Serif KR', AppleMyungjo, Batang, serif`;
const $f02253094c3bb7fd$var$SANS = `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif`;
function $f02253094c3bb7fd$var$ready(img) {
    return !!img?.complete && img.naturalWidth > 0;
}
function $f02253094c3bb7fd$export$51d687bd52a05fd9(ctx, w, h, state, images) {
    const now = performance.now();
    let alpha = Math.min(1, (now - state.since) / $f02253094c3bb7fd$var$FADE_IN_MS);
    if (state.endingSince !== undefined) {
        const out = 1 - (now - state.endingSince) / $f02253094c3bb7fd$var$FADE_OUT_MS;
        if (out <= 0) return false;
        alpha = Math.min(alpha, out);
    }
    if (alpha <= 0) return true;
    ctx.save();
    ctx.globalAlpha = alpha;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    if (state.mode === 'preroll') $f02253094c3bb7fd$var$drawPreroll(ctx, w, h, state.ad, images);
    else {
        const rects = $f02253094c3bb7fd$var$drawResult(ctx, w, h, state.ad, images, now - state.since);
        state.clickRect = rects?.click;
        state.closeRect = rects?.close;
    }
    ctx.restore();
    return true;
}
function $f02253094c3bb7fd$var$drawPreroll(ctx, w, h, ad, images) {
    ctx.fillStyle = 'rgba(0, 0, 0, 0.6)';
    ctx.fillRect(0, 0, w, h);
    const provideSize = $f02253094c3bb7fd$var$clamp(h * 0.04, 14, 52);
    const sponsorSize = $f02253094c3bb7fd$var$clamp(h * 0.026, 14, 30);
    const logoSize = Math.min(w * 0.3, h * 0.34, 360);
    const labelSize = $f02253094c3bb7fd$var$clamp(h * 0.013, 9, 14);
    const gap = h * 0.022;
    const logo = $f02253094c3bb7fd$var$ready(images.preroll) ? images.preroll : undefined;
    // 서버 소재가 없을 때도 원작처럼 중앙에 정사각 이미지형 광고를 표시한다.
    const cardSize = logo ? logoSize : Math.min(w * 0.34, h * 0.38, 300);
    const parts = [
        provideSize,
        sponsorSize,
        cardSize,
        labelSize
    ];
    const total = parts.reduce((a, b)=>a + b, 0) + gap * (parts.length - 1);
    let y = (h - total) / 2;
    const cx = w / 2;
    ctx.font = `700 ${provideSize}px ${$f02253094c3bb7fd$var$SERIF}`;
    ctx.fillStyle = '#ffffff';
    ctx.shadowColor = 'rgba(0, 0, 0, 0.75)';
    ctx.shadowBlur = provideSize * 0.18;
    $f02253094c3bb7fd$var$drawSpaced(ctx, "\uC81C\uACF5", cx, y + provideSize / 2, provideSize * 0.35);
    y += provideSize + gap;
    ctx.shadowBlur = sponsorSize * 0.3;
    ctx.font = `600 ${sponsorSize}px ${$f02253094c3bb7fd$var$SANS}`;
    ctx.fillText(ad.advertiser, cx, y + sponsorSize / 2);
    y += sponsorSize + gap;
    ctx.shadowBlur = 0;
    if (logo) ctx.drawImage(logo, cx - logoSize / 2, y, logoSize, logoSize);
    else {
        const x = cx - cardSize / 2;
        const top = y;
        const r = cardSize * 0.09;
        ctx.save();
        ctx.shadowColor = 'rgba(0,0,0,0.35)';
        ctx.shadowBlur = cardSize * 0.08;
        const bg = ctx.createLinearGradient(x, top, x + cardSize, top + cardSize);
        bg.addColorStop(0, '#172554');
        bg.addColorStop(0.55, '#2563eb');
        bg.addColorStop(1, '#7c3aed');
        ctx.fillStyle = bg;
        $f02253094c3bb7fd$var$roundedRect(ctx, x, top, cardSize, cardSize, r);
        ctx.fill();
        ctx.shadowBlur = 0;
        const mx = cx, my = top + cardSize * 0.39, mr = cardSize * 0.22;
        const marble = ctx.createRadialGradient(mx - mr * 0.35, my - mr * 0.4, mr * 0.08, mx, my, mr);
        marble.addColorStop(0, '#ffffff');
        marble.addColorStop(0.35, '#bfdbfe');
        marble.addColorStop(0.72, '#60a5fa');
        marble.addColorStop(1, '#1e40af');
        ctx.beginPath();
        ctx.arc(mx, my, mr, 0, Math.PI * 2);
        ctx.fillStyle = marble;
        ctx.fill();
        ctx.strokeStyle = 'rgba(255,255,255,0.8)';
        ctx.lineWidth = Math.max(1, cardSize * 0.008);
        ctx.stroke();
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillStyle = '#ffffff';
        ctx.font = '800 ' + cardSize * 0.105 + "px " + $f02253094c3bb7fd$var$SANS;
        ctx.fillText('MARBLE DASH', cx, top + cardSize * 0.76);
        ctx.font = '500 ' + cardSize * 0.045 + "px " + $f02253094c3bb7fd$var$SANS;
        ctx.fillStyle = 'rgba(255,255,255,0.86)';
        ctx.fillText('LET THE GAME BEGIN', cx, top + cardSize * 0.86);
        ctx.restore();
    }
    y += cardSize + gap;
    ctx.font = `${labelSize}px ${$f02253094c3bb7fd$var$SANS}`;
    ctx.fillStyle = 'rgba(255, 255, 255, 0.5)';
    ctx.fillText("\uAD11\uACE0", cx, y + labelSize / 2);
}
function $f02253094c3bb7fd$var$roundedRect(ctx, x, y, w, h, r) {
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + w, y, x + w, y + h, r);
    ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r);
    ctx.arcTo(x, y, x + w, y, r);
    ctx.closePath();
}
function $f02253094c3bb7fd$var$drawResult(ctx, w, h, ad, images, elapsed) {
    const logo = $f02253094c3bb7fd$var$ready(images.result) ? images.result : undefined;
    const qr = $f02253094c3bb7fd$var$ready(images.qr) ? images.qr : undefined;
    if (!logo && !qr) return undefined;
    const logoSize = (0, $1d1927fc5b91d8b6$export$3b636dc9ab9d92c7);
    const qrSize = (0, $1d1927fc5b91d8b6$export$3b636dc9ab9d92c7) * $f02253094c3bb7fd$var$QR_TO_LOGO_RATIO;
    const nameSize = logoSize * $f02253094c3bb7fd$var$RESULT_NAME_RATIO;
    const taglineSize = logoSize * $f02253094c3bb7fd$var$RESULT_TAGLINE_RATIO;
    const bandH = logoSize + $f02253094c3bb7fd$var$RESULT_BAND_PADDING * 2;
    // 오므라든 폭을 알아야 밴드를 먼저 깔 수 있어서, 글자 폭은 그리기 전에 재둔다
    ctx.font = `600 ${nameSize}px ${$f02253094c3bb7fd$var$SANS}`;
    const nameMetrics = ctx.measureText(ad.advertiser);
    let colWidth = nameMetrics.width;
    if (ad.tagline) {
        ctx.font = `${taglineSize}px ${$f02253094c3bb7fd$var$SANS}`;
        colWidth = Math.max(colWidth, ctx.measureText(ad.tagline).width);
    }
    if (qr) colWidth = Math.max(colWidth, qrSize);
    const t = $f02253094c3bb7fd$var$easeInOut($f02253094c3bb7fd$var$clamp((elapsed - $f02253094c3bb7fd$var$RESULT_MOVE_DELAY_MS) / $f02253094c3bb7fd$var$RESULT_MOVE_MS, 0, 1));
    // 오므라들면 오른쪽 위 구석이 광고주명 자리가 되므로, 닫기 버튼 자리를 따로 비워둔다
    const dockedW = $f02253094c3bb7fd$var$RESULT_LABEL_GUTTER + logoSize + $f02253094c3bb7fd$var$RESULT_GAP + colWidth + $f02253094c3bb7fd$var$RESULT_BAND_PADDING * 2 + $f02253094c3bb7fd$export$c24b81217f27d3fe(h) + $f02253094c3bb7fd$var$CLOSE_INSET;
    const bandY = $f02253094c3bb7fd$var$lerp((h - bandH) / 2, 0, t);
    const bandW = $f02253094c3bb7fd$var$lerp(w, Math.min(dockedW, w), t);
    const contentY = bandY + $f02253094c3bb7fd$var$RESULT_BAND_PADDING;
    const logoX = $f02253094c3bb7fd$var$lerp((w - logoSize) / 2, $f02253094c3bb7fd$var$RESULT_BAND_PADDING + $f02253094c3bb7fd$var$RESULT_LABEL_GUTTER, t);
    const colX = logoX + logoSize + $f02253094c3bb7fd$var$RESULT_GAP;
    ctx.fillStyle = $f02253094c3bb7fd$var$RESULT_BAND_COLOR;
    ctx.fillRect(0, bandY, bandW, bandH);
    if (logo) ctx.drawImage(logo, logoX, contentY, logoSize, logoSize);
    ctx.font = `600 ${nameSize}px ${$f02253094c3bb7fd$var$SANS}`;
    ctx.fillStyle = '#ffffff';
    ctx.textAlign = 'left';
    ctx.textBaseline = 'alphabetic';
    const ascent = nameMetrics.actualBoundingBoxAscent || nameSize * 0.8;
    ctx.fillText(ad.advertiser, colX, contentY + ascent);
    if (ad.tagline) {
        ctx.font = `${taglineSize}px ${$f02253094c3bb7fd$var$SANS}`;
        ctx.fillStyle = 'rgba(255, 255, 255, 0.85)';
        ctx.textBaseline = 'top';
        ctx.fillText(ad.tagline, colX, contentY + nameSize + taglineSize * $f02253094c3bb7fd$var$RESULT_TAGLINE_GAP_EM);
    }
    if (qr) ctx.drawImage(qr, colX, contentY + logoSize - qrSize, qrSize, qrSize);
    const clickLeft = logo ? logoX : colX;
    const clickRect = {
        x: clickLeft,
        y: contentY,
        w: colX + colWidth - clickLeft,
        h: logoSize
    };
    const labelSize = $f02253094c3bb7fd$var$clamp(h * 0.013, 9, 14);
    ctx.font = `${labelSize}px ${$f02253094c3bb7fd$var$SANS}`;
    ctx.fillStyle = 'rgba(255, 255, 255, 0.5)';
    ctx.textAlign = 'left';
    ctx.textBaseline = 'bottom';
    ctx.fillText("\uAD11\uACE0", $f02253094c3bb7fd$var$RESULT_LABEL_INSET, bandY + bandH - $f02253094c3bb7fd$var$RESULT_LABEL_INSET);
    return {
        click: clickRect,
        close: $f02253094c3bb7fd$var$drawCloseButton(ctx, bandW, bandY, h, elapsed)
    };
}
function $f02253094c3bb7fd$export$c24b81217f27d3fe(h) {
    return $f02253094c3bb7fd$var$clamp(h * 0.045, 20, 34);
}
function $f02253094c3bb7fd$var$lerp(from, to, t) {
    return from + (to - from) * t;
}
function $f02253094c3bb7fd$var$easeInOut(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - (-2 * t + 2) ** 3 / 2;
}
function $f02253094c3bb7fd$export$1417b54d9380f8a2(ctx, cx, cy, size, fill = 'rgba(0, 0, 0, 0.5)') {
    const arm = size * 0.22;
    ctx.save();
    ctx.beginPath();
    ctx.arc(cx, cy, size / 2, 0, Math.PI * 2);
    ctx.fillStyle = fill;
    ctx.fill();
    ctx.strokeStyle = 'rgba(255, 255, 255, 0.8)';
    ctx.lineWidth = Math.max(1.5, size * 0.07);
    ctx.stroke();
    ctx.beginPath();
    ctx.moveTo(cx - arm, cy - arm);
    ctx.lineTo(cx + arm, cy + arm);
    ctx.moveTo(cx + arm, cy - arm);
    ctx.lineTo(cx - arm, cy + arm);
    ctx.stroke();
    ctx.restore();
    return {
        x: cx - size / 2 - $f02253094c3bb7fd$var$CLOSE_HIT_PADDING,
        y: cy - size / 2 - $f02253094c3bb7fd$var$CLOSE_HIT_PADDING,
        w: size + $f02253094c3bb7fd$var$CLOSE_HIT_PADDING * 2,
        h: size + $f02253094c3bb7fd$var$CLOSE_HIT_PADDING * 2
    };
}
/** 밴드 오른쪽 위 구석의 닫기 버튼. 아직 나올 때가 아니면 그리지도, 누를 수도 없다 */ function $f02253094c3bb7fd$var$drawCloseButton(ctx, w, bandY, h, elapsed) {
    if (elapsed < $f02253094c3bb7fd$var$CLOSE_DELAY_MS) return undefined;
    const size = $f02253094c3bb7fd$export$c24b81217f27d3fe(h);
    ctx.save();
    ctx.globalAlpha *= Math.min(1, (elapsed - $f02253094c3bb7fd$var$CLOSE_DELAY_MS) / $f02253094c3bb7fd$var$CLOSE_FADE_MS);
    const rect = $f02253094c3bb7fd$export$1417b54d9380f8a2(ctx, w - $f02253094c3bb7fd$var$CLOSE_INSET - size / 2, bandY + $f02253094c3bb7fd$var$CLOSE_INSET + size / 2, size);
    ctx.restore();
    return rect;
}
function $f02253094c3bb7fd$var$clamp(v, min, max) {
    return Math.max(min, Math.min(max, v));
}
function $f02253094c3bb7fd$var$drawSpaced(ctx, text, cx, cy, spacing) {
    const chars = [
        ...text
    ];
    const widths = chars.map((c)=>ctx.measureText(c).width);
    const total = widths.reduce((a, b)=>a + b, 0) + spacing * (chars.length - 1);
    const prevAlign = ctx.textAlign;
    ctx.textAlign = 'left';
    let x = cx - total / 2;
    chars.forEach((c, i)=>{
        ctx.fillText(c, x, cy);
        x += widths[i] + spacing;
    });
    ctx.textAlign = prevAlign;
}



const $917e2e33c0ac0dc1$var$DEFAULT_KEYWORDS_URL = 'https://marblerouletteshop.com/api/external/keywords.json';
const $917e2e33c0ac0dc1$var$DEFAULT_SPRITE_BASE_URL = 'https://marblerouletteshop.com/api/external/sprites';
const $917e2e33c0ac0dc1$var$REFRESH_INTERVAL = 60000; // 60 seconds
class $917e2e33c0ac0dc1$export$ea2bb5c7a344080e {
    get _keywordsUrl() {
        return $917e2e33c0ac0dc1$var$DEFAULT_KEYWORDS_URL;
    }
    get _spriteBaseUrl() {
        return $917e2e33c0ac0dc1$var$DEFAULT_SPRITE_BASE_URL;
    }
    get _checkExpiry() {
        return true;
    }
    async init() {
        await this.fetchKeywords();
        this._startPeriodicRefresh();
    }
    destroy() {
        if (this._intervalId !== null) {
            clearInterval(this._intervalId);
            this._intervalId = null;
        }
    }
    _startPeriodicRefresh() {
        this._intervalId = window.setInterval(()=>{
            if (document.visibilityState === 'visible') this.fetchKeywords();
        }, $917e2e33c0ac0dc1$var$REFRESH_INTERVAL);
    }
    async fetchKeywords() {
        try {
            const response = await fetch(this._keywordsUrl);
            if (!response.ok) {
                console.warn(`[KeywordService] Failed to fetch keywords: ${response.status}`);
                return;
            }
            const newData = await response.json();
            console.log(`[KeywordService] Fetched ${Object.keys(newData.keywords ?? {}).length} keywords`);
            // Check if generated_at is newer than last load
            const isNewer = this._lastGeneratedAt === null || new Date(newData.generated_at) > new Date(this._lastGeneratedAt);
            if (isNewer) {
                // Clear sprite caches when data is updated
                this._spriteSheets.clear();
                this._extractedSprites.clear();
                this._loadingSprites.clear();
                console.log('[KeywordService] Data updated, clearing sprite caches');
            }
            this._keywordsData = newData;
            this._lastGeneratedAt = newData.generated_at;
            // Preload sprite sheets for all keywords
            const spriteIds = new Set();
            for (const entry of Object.values(this._keywordsData.keywords))spriteIds.add(entry.sprite);
            await Promise.all([
                ...spriteIds
            ].map((id)=>this._loadSpriteSheet(id)));
        } catch (error) {
            console.warn('[KeywordService] Error fetching keywords:', error);
        }
    }
    async _loadSpriteSheet(spriteId) {
        if (this._spriteSheets.has(spriteId)) return this._spriteSheets.get(spriteId);
        // Check if already loading
        if (this._loadingSprites.has(spriteId)) return this._loadingSprites.get(spriteId);
        const loadPromise = new Promise((resolve)=>{
            const img = new Image();
            img.crossOrigin = 'anonymous';
            img.onload = ()=>{
                this._spriteSheets.set(spriteId, img);
                console.log(`[KeywordService] Loaded sprite sheet ${spriteId}`);
                resolve(img);
            };
            img.onerror = ()=>{
                console.warn(`[KeywordService] Failed to load sprite sheet ${spriteId}`);
                resolve(null);
            };
            img.src = `${this._spriteBaseUrl}/${spriteId}.png?generated_at=${encodeURIComponent(this._lastGeneratedAt ?? '')}`;
        });
        this._loadingSprites.set(spriteId, loadPromise);
        const result = await loadPromise;
        this._loadingSprites.delete(spriteId);
        return result;
    }
    _extractSprite(spriteSheet, x, y, width, height) {
        const canvas = typeof OffscreenCanvas !== 'undefined' ? new OffscreenCanvas(width, height) : document.createElement('canvas');
        if (!(canvas instanceof OffscreenCanvas)) {
            canvas.width = width;
            canvas.height = height;
        }
        const ctx = canvas.getContext('2d');
        if (ctx) ctx.drawImage(spriteSheet, x, y, width, height, 0, 0, width, height);
        return canvas;
    }
    getSprite(marbleName) {
        if (!this._keywordsData) return undefined;
        const entry = this._keywordsData.keywords[marbleName];
        if (!entry) return undefined;
        // Check expiration
        if (this._checkExpiry && new Date(entry.expires_at) < new Date()) return undefined;
        // Check cache first
        const cacheKey = `${entry.sprite}_${entry.x}_${entry.y}_${entry.width}_${entry.height}`;
        if (this._extractedSprites.has(cacheKey)) return this._extractedSprites.get(cacheKey);
        // Get sprite sheet
        const spriteSheet = this._spriteSheets.get(entry.sprite);
        if (!spriteSheet) return undefined;
        // Extract and cache the sprite
        const sprite = this._extractSprite(spriteSheet, entry.x, entry.y, entry.width, entry.height);
        this._extractedSprites.set(cacheKey, sprite);
        return sprite;
    }
    constructor(){
        this._keywordsData = null;
        this._spriteSheets = new Map();
        this._extractedSprites = new Map();
        this._intervalId = null;
        this._loadingSprites = new Map();
        this._lastGeneratedAt = null;
    }
}



const $68facf3481e408fc$var$MAX_DISPLAY_WIDTH = 1920;
const $68facf3481e408fc$var$WINNER_TEXT_OFFSET = 30;
const $68facf3481e408fc$var$RESULT_PANEL_MAX_WIDTH_RATIO = 0.9;
const $68facf3481e408fc$var$RESULT_PANEL_MAX_HEIGHT_RATIO = 0.8;
const $68facf3481e408fc$var$RESULT_COLUMN_MAX_WIDTH = 280;
const $68facf3481e408fc$var$PROGRESS_MAX_WIDTH_RATIO = 0.3;
const $68facf3481e408fc$var$PROGRESS_ACCENT = 'rgba(255, 215, 0, 0.8)';
function $68facf3481e408fc$var$inRect(rect, x, y) {
    return !!rect && x >= rect.x && x <= rect.x + rect.w && y >= rect.y && y <= rect.y + rect.h;
}
var $c92bc92e6f43beb5$exports = {};
$c92bc92e6f43beb5$exports = import.meta.resolve("cdgIR");


var $bcc86b8ef80c3516$exports = {};
$bcc86b8ef80c3516$exports = import.meta.resolve("lfSvD");


var $55e581bc88574858$exports = {};
$55e581bc88574858$exports = import.meta.resolve("9DwmV");




var $d303c3abb963d51d$exports = {};
$d303c3abb963d51d$exports = import.meta.resolve("fkRhi");


var $7eec4f6a08db5144$exports = {};
$7eec4f6a08db5144$exports = import.meta.resolve("9YLvj");



class $68facf3481e408fc$export$a1ed140729fa937 {
    constructor(){
        this.sizeFactor = 1;
        this._images = {};
        this._theme = (0, $1d1927fc5b91d8b6$export$1d8e462b9ec86de2).dark;
        this._ad = null;
        this._adImageCache = new Map();
        this._adOverlay = null;
        this._resultCloseRect = null;
        this._resultPopupClosed = false;
        this._lastResult = null;
        /** 장애물 아래에 월드 좌표로 덧그리는 그림 (테스트 플레이의 진행도 지도) */ this.debugDraw = null;
        this._keywordService = this.createKeywordService();
    }
    createKeywordService() {
        return new (0, $917e2e33c0ac0dc1$export$ea2bb5c7a344080e)();
    }
    get width() {
        return this._sceneCanvas.width;
    }
    get height() {
        return this._sceneCanvas.height;
    }
    get canvas() {
        return this._canvas;
    }
    set theme(value) {
        this._theme = value;
    }
    async init() {
        await Promise.all([
            this._load(),
            this._keywordService.init()
        ]);
        this._canvas = document.createElement('canvas');
        this._canvas.width = (0, $1d1927fc5b91d8b6$export$1cd840e6ecaab774);
        this._canvas.height = (0, $1d1927fc5b91d8b6$export$3d795bc15e02aca);
        this._displayCtx = this._canvas.getContext('2d', {
            alpha: false
        });
        this._sceneCanvas = document.createElement('canvas');
        this._sceneCanvas.width = (0, $1d1927fc5b91d8b6$export$1cd840e6ecaab774);
        this._sceneCanvas.height = (0, $1d1927fc5b91d8b6$export$3d795bc15e02aca);
        this.ctx = this._sceneCanvas.getContext('2d', {
            alpha: false
        });
        document.body.appendChild(this._canvas);
        const resizing = (entries)=>{
            const realSize = entries ? entries[0].contentRect : this._canvas.getBoundingClientRect();
            if (realSize.width <= 0 || realSize.height <= 0) return;
            const width = Math.max(realSize.width / 2, 640);
            const height = width / realSize.width * realSize.height;
            this._sceneCanvas.width = width;
            this._sceneCanvas.height = height;
            this.sizeFactor = width / realSize.width;
            const displayWidth = Math.min(realSize.width, $68facf3481e408fc$var$MAX_DISPLAY_WIDTH);
            this._canvas.width = displayWidth;
            this._canvas.height = displayWidth / realSize.width * realSize.height;
        };
        const resizeObserver = new ResizeObserver(resizing);
        resizeObserver.observe(this._canvas);
        resizing();
    }
    async _loadImage(url) {
        return new Promise((rs)=>{
            const img = new Image();
            img.addEventListener('load', ()=>{
                rs(img);
            });
            img.src = url;
        });
    }
    async _load() {
        const loadPromises = [
            {
                name: "\uCC54\uB8E8",
                imgUrl: new URL($c92bc92e6f43beb5$exports)
            },
            {
                name: "\uCFE0\uBE48",
                imgUrl: new URL($bcc86b8ef80c3516$exports)
            },
            {
                name: "\uAF49\uBCC0",
                imgUrl: new URL($55e581bc88574858$exports)
            },
            {
                name: "\uAF49\uBCC0\uD638\uC0AC",
                imgUrl: new URL($55e581bc88574858$exports)
            },
            {
                name: "\uAF49 \uBCC0\uD638\uC0AC",
                imgUrl: new URL($55e581bc88574858$exports)
            },
            {
                name: "\uC8FC\uB204\uD53C",
                imgUrl: new URL($d303c3abb963d51d$exports)
            },
            {
                name: "\uC648\uB3C4\uCFE4",
                imgUrl: new URL($7eec4f6a08db5144$exports)
            }
        ].map(({ name: name, imgUrl: imgUrl })=>{
            return (async ()=>{
                this._images[name] = await this._loadImage(imgUrl.toString());
            })();
        });
        loadPromises.push((async ()=>{
            await this._loadImage(new URL($fde943b0087de629$exports).toString());
        })());
        await Promise.all(loadPromises);
    }
    getMarbleImage(name) {
        // Priority 1: Hardcoded images
        if (this._images[name]) return this._images[name];
        // Priority 2: Keyword sprites from API
        return this._keywordService.getSprite(name);
    }
    onBeforeEntities() {}
    onAfterScene() {}
    setAd(ad) {
        this._ad = ad;
        if (!ad) return;
        this.preloadAdImages([
            ...Object.values(ad.creatives),
            ad.qrImage
        ]);
    }
    /** 소재를 미리 받아둔다. 여기서 만든 엘리먼트를 나중에 그대로 그리므로 캐시 헤더와 무관하게 즉시 뜬다 */ preloadAdImages(srcs) {
        for (const src of srcs)if (src) this.cacheAdImage(src);
    }
    adImage(src) {
        return src ? this._adImageCache.get(src) : undefined;
    }
    cacheAdImage(src) {
        const cached = this._adImageCache.get(src);
        if (cached) return cached;
        const el = new Image();
        el.crossOrigin = 'anonymous';
        el.src = src;
        this._adImageCache.set(src, el);
        return el;
    }
    showAdOverlay(mode) {
        if (!this._ad || !this._ad.slots?.includes(mode)) return;
        this._adOverlay = {
            mode: mode,
            ad: this._ad,
            since: performance.now(),
            endingSince: undefined
        };
    }
    getAdHitAt(x, y) {
        const overlay = this._adOverlay;
        if (!overlay || overlay.endingSince !== undefined) return null;
        if ($68facf3481e408fc$var$inRect(overlay.closeRect, x, y)) return {
            type: 'close'
        };
        const link = overlay.ad.linkUrl;
        if (link && $68facf3481e408fc$var$inRect(overlay.clickRect, x, y)) return {
            type: 'link',
            url: link
        };
        return null;
    }
    hideAdOverlay() {
        if (this._adOverlay && this._adOverlay.endingSince === undefined) this._adOverlay.endingSince = performance.now();
    }
    renderAdOverlay(renderParameters) {
        const overlay = this._adOverlay;
        if (!overlay) return;
        if (overlay.mode === 'result' && !renderParameters.result) this.hideAdOverlay();
        const scale = this._canvas.width / this._sceneCanvas.width;
        try {
            this._displayCtx.save();
            this._displayCtx.scale(scale, scale);
            const alive = (0, $f02253094c3bb7fd$export$51d687bd52a05fd9)(this._displayCtx, this._sceneCanvas.width, this._sceneCanvas.height, overlay, {
                preroll: this.adImage(overlay.ad.creatives.preroll),
                result: this.adImage(overlay.ad.creatives.result),
                qr: this.adImage(overlay.ad.qrImage)
            });
            this._displayCtx.restore();
            if (!alive) this._adOverlay = null;
        } catch (e) {
            this._displayCtx.restore();
            console.error("[ads] \uC624\uBC84\uB808\uC774 \uB80C\uB354\uB9C1 \uC2E4\uD328, \uC774\uBC88 \uB178\uCD9C\uC740 \uAC74\uB108\uB701\uB2C8\uB2E4", e);
            this._adOverlay = null;
        }
    }
    renderAdBoards(stage) {
        const ad = this._ad;
        if (!ad || !ad.slots?.includes('goal') || !stage.adBoards?.length) return;
        const img = this.adImage(ad.creatives.goal);
        if (!img?.complete || img.naturalWidth === 0) return;
        try {
            this.ctx.save();
            for (const board of stage.adBoards){
                const w = board.w ?? 4;
                const h = board.h ?? 1;
                const x = board.x - w / 2;
                const y = board.y - h / 2;
                this.ctx.drawImage(img, x, y, w, h);
            }
        } catch (e) {
            console.error("[ads] \uAD11\uACE0\uD310 \uB80C\uB354\uB9C1 \uC2E4\uD328, \uC774\uBC88 \uAC8C\uC7AC\uB294 \uAC74\uB108\uB701\uB2C8\uB2E4", e);
            this._ad = null;
        } finally{
            this.ctx.restore();
        }
    }
    render(renderParameters, uiObjects) {
        this._theme = renderParameters.theme;
        this.ctx.fillStyle = this._theme.background;
        this.ctx.fillRect(0, 0, this._sceneCanvas.width, this._sceneCanvas.height);
        this.ctx.save();
        this.ctx.scale((0, $1d1927fc5b91d8b6$export$c2cc40734f29867c), (0, $1d1927fc5b91d8b6$export$c2cc40734f29867c));
        this.ctx.textAlign = 'left';
        this.ctx.textBaseline = 'top';
        this.ctx.font = '0.4pt sans-serif';
        this.ctx.lineWidth = 3 / (renderParameters.camera.zoom + (0, $1d1927fc5b91d8b6$export$c2cc40734f29867c));
        renderParameters.camera.renderScene(this.ctx, ()=>{
            this.renderAdBoards(renderParameters.stage);
            this.onBeforeEntities();
            this.debugDraw?.(this.ctx);
            this.renderEntities(renderParameters.entities);
            this.renderEffects(renderParameters);
            this.renderMarbles(renderParameters);
        });
        this.ctx.restore();
        this.onAfterScene();
        uiObjects.forEach((obj)=>obj.render(this.ctx, renderParameters, this._sceneCanvas.width, this._sceneCanvas.height));
        renderParameters.particleManager.render(this.ctx);
        this.renderWinnerProgress(renderParameters);
        this.renderResult(renderParameters);
        this._displayCtx.drawImage(this._sceneCanvas, 0, 0, this._canvas.width, this._canvas.height);
        this.renderAdOverlay(renderParameters);
    }
    renderEntities(entities) {
        this.ctx.save();
        entities.forEach((entity)=>{
            const transform = this.ctx.getTransform();
            this.ctx.translate(entity.x, entity.y);
            this.ctx.rotate(entity.angle);
            this.ctx.fillStyle = entity.shape.color ?? this._theme.entity[entity.shape.type].fill;
            this.ctx.strokeStyle = entity.shape.color ?? this._theme.entity[entity.shape.type].outline;
            this.ctx.shadowBlur = this._theme.entity[entity.shape.type].bloomRadius;
            this.ctx.shadowColor = entity.shape.bloomColor ?? entity.shape.color ?? this._theme.entity[entity.shape.type].bloom;
            const shape = entity.shape;
            switch(shape.type){
                case 'polyline':
                    if (shape.points.length > 0) {
                        this.ctx.beginPath();
                        this.ctx.moveTo(shape.points[0][0], shape.points[0][1]);
                        for(let i = 1; i < shape.points.length; i++)this.ctx.lineTo(shape.points[i][0], shape.points[i][1]);
                        this.ctx.stroke();
                    }
                    break;
                case 'box':
                    {
                        const w = shape.width * 2;
                        const h = shape.height * 2;
                        this.ctx.rotate(shape.rotation);
                        this.ctx.fillRect(-w / 2, -h / 2, w, h);
                        this.ctx.strokeRect(-w / 2, -h / 2, w, h);
                        break;
                    }
                case 'circle':
                    this.ctx.beginPath();
                    this.ctx.arc(0, 0, shape.radius, 0, Math.PI * 2, false);
                    this.ctx.stroke();
                    break;
            }
            this.ctx.setTransform(transform);
        });
        this.ctx.restore();
    }
    renderEffects({ effects: effects, camera: camera }) {
        effects.forEach((effect)=>effect.render(this.ctx, camera.zoom * (0, $1d1927fc5b91d8b6$export$c2cc40734f29867c), this._theme));
    }
    renderMarbles({ marbles: marbles, camera: camera, winnerRange: winnerRange, winners: winners, size: size }) {
        const firstIndex = winnerRange.start - winners.length;
        const lastIndex = winnerRange.end - winners.length;
        const viewPort = {
            x: camera.x,
            y: camera.y,
            w: size.x,
            h: size.y,
            zoom: camera.zoom * (0, $1d1927fc5b91d8b6$export$c2cc40734f29867c)
        };
        marbles.forEach((marble, i)=>{
            marble.render(this.ctx, camera.zoom * (0, $1d1927fc5b91d8b6$export$c2cc40734f29867c), i >= firstIndex && i <= lastIndex, false, this.getMarbleImage(marble.name), viewPort, this._theme);
        });
    }
    renderResult(params) {
        const result = params.result;
        // 새 결과가 나오면(또는 리셋되면) 닫힘 상태를 푼다. _result는 확정될 때마다 새 배열이다
        if (result !== this._lastResult) {
            this._lastResult = result;
            this._resultPopupClosed = false;
        }
        this._resultCloseRect = null;
        if (!result) return;
        // 1명이면 기존 하단 Winner 표시, 여러명이면 화면 중앙 당첨자 목록 팝업
        if (result.length === 1) this.renderWinner(result[0], params.theme);
        else if (!this._resultPopupClosed) this.renderWinnerList(result, params);
    }
    /** 결과 팝업 닫기 버튼을 눌렀는지 */ getResultCloseHitAt(x, y) {
        return $68facf3481e408fc$var$inRect(this._resultCloseRect ?? undefined, x, y);
    }
    closeResultPopup() {
        this._resultPopupClosed = true;
    }
    /**
   * 여러명 모드에서 확정된 당첨자를 좌측 상단에 상시 표시한다.
   * 우측은 랭킹 리스트가 구슬 수만큼 내려오므로 겹친다. 좌측은 미니맵이 세로로 긴
   * 스트립이라 그 오른쪽에 붙인다.
   */ renderWinnerProgress({ winners: winners, winnerRange: winnerRange, result: result, theme: theme }) {
        const { start: start, end: end } = winnerRange;
        if (end <= start) return; // 1명 추첨은 기존 하단 Winner 표시를 쓴다
        const ctx = this.ctx;
        const w = this._sceneCanvas.width;
        const h = this._sceneCanvas.height;
        const lineHeight = Math.min(24, Math.max(14, h * 0.042));
        const pad = lineHeight * 0.6;
        const rankWidth = lineHeight * 1.9;
        const headerFont = `bold ${lineHeight * 0.7}px sans-serif`;
        const rankFont = `${lineHeight * 0.6}px sans-serif`;
        const nameFont = `bold ${lineHeight * 0.72}px sans-serif`;
        // 확정 전에는 골인한 당첨자만, 확정 후에는 최종 명단(조기 확정분 포함)을 쓴다
        const confirmed = result ?? winners.slice(start, end + 1);
        const header = `Winners ${confirmed.length} / ${end - start + 1}`;
        // 화면을 넘기면 오래된 쪽을 접는다. 전체 명단은 어차피 중앙 팝업에서 보여준다
        const maxRows = Math.max(1, Math.floor(h * 0.55 / lineHeight) - 2);
        const hidden = Math.max(0, confirmed.length - maxRows);
        const shown = confirmed.slice(hidden);
        const foldLabel = `+${hidden} more`;
        ctx.save();
        ctx.font = headerFont;
        let contentW = ctx.measureText(header).width;
        ctx.font = nameFont;
        for (const marble of shown)contentW = Math.max(contentW, rankWidth + ctx.measureText(marble.name).width);
        if (hidden > 0) {
            ctx.font = rankFont;
            contentW = Math.max(contentW, ctx.measureText(foldLabel).width);
        }
        const panelW = Math.min(contentW + pad * 2, w * $68facf3481e408fc$var$PROGRESS_MAX_WIDTH_RATIO);
        const rows = shown.length + (hidden > 0 ? 1 : 0);
        // 헤더와 목록 사이 간격은 목록이 있을 때만 준다. 항상 주면 당첨자가 없을 때
        // 아래쪽에만 빈 공간이 남아 위아래 여백이 어긋난다
        const headerGap = rows > 0 ? lineHeight * 0.35 : 0;
        const panelH = pad * 2 + lineHeight + headerGap + rows * lineHeight;
        const panelX = (0, $c2ea39beabe51779$export$786d88d79d18d08b) + (0, $c2ea39beabe51779$export$cc97458872192ab6) + pad;
        const panelY = (0, $c2ea39beabe51779$export$786d88d79d18d08b); // 미니맵 상단과 맞춘다
        ctx.fillStyle = theme.winnerBackground;
        ctx.fillRect(panelX, panelY, panelW, panelH);
        ctx.strokeStyle = $68facf3481e408fc$var$PROGRESS_ACCENT;
        ctx.lineWidth = 2;
        ctx.strokeRect(panelX, panelY, panelW, panelH);
        ctx.textBaseline = 'middle';
        ctx.textAlign = 'left';
        ctx.font = headerFont;
        ctx.fillStyle = theme.winnerText;
        ctx.fillText(header, panelX + pad, panelY + pad + lineHeight / 2);
        let y = panelY + pad + lineHeight + headerGap + lineHeight / 2;
        if (hidden > 0) {
            ctx.font = rankFont;
            ctx.fillStyle = theme.winnerText;
            ctx.fillText(foldLabel, panelX + pad, y);
            y += lineHeight;
        }
        shown.forEach((marble, i)=>{
            ctx.save();
            ctx.beginPath();
            ctx.rect(panelX, y - lineHeight / 2, panelW, lineHeight);
            ctx.clip();
            ctx.font = rankFont;
            ctx.fillStyle = theme.winnerText;
            ctx.fillText(`#${start + hidden + i + 1}`, panelX + pad, y);
            ctx.font = nameFont;
            ctx.fillStyle = `hsl(${marble.hue} 100% ${theme.marbleLightness}%)`;
            ctx.fillText(marble.name, panelX + pad + rankWidth, y);
            ctx.restore();
            y += lineHeight;
        });
        ctx.restore();
    }
    /** 당첨자가 여러명일 때 화면 중앙에 목록 팝업을 그린다 */ renderWinnerList(winners, { theme: theme, winnerRange: winnerRange }) {
        const ctx = this.ctx;
        const w = this._sceneCanvas.width;
        const h = this._sceneCanvas.height;
        const lineHeight = Math.min(32, Math.max(16, h * 0.05));
        const padding = lineHeight;
        const titleHeight = lineHeight * 2;
        // 세로로 다 안 들어가면 열을 늘린다
        const maxRows = Math.max(1, Math.floor((h * $68facf3481e408fc$var$RESULT_PANEL_MAX_HEIGHT_RATIO - titleHeight - padding * 2) / lineHeight));
        const cols = Math.max(1, Math.ceil(winners.length / maxRows));
        const rows = Math.ceil(winners.length / cols);
        const colWidth = Math.min($68facf3481e408fc$var$RESULT_COLUMN_MAX_WIDTH, (w * $68facf3481e408fc$var$RESULT_PANEL_MAX_WIDTH_RATIO - padding * 2) / cols);
        const panelW = colWidth * cols + padding * 2;
        const panelH = titleHeight + rows * lineHeight + padding;
        const panelX = (w - panelW) / 2;
        const panelY = (h - panelH) / 2;
        ctx.save();
        ctx.fillStyle = theme.winnerBackground;
        ctx.fillRect(0, 0, w, h);
        ctx.fillStyle = theme.background;
        ctx.fillRect(panelX, panelY, panelW, panelH);
        ctx.strokeStyle = theme.winnerText;
        ctx.lineWidth = 2;
        ctx.strokeRect(panelX, panelY, panelW, panelH);
        ctx.textBaseline = 'middle';
        ctx.textAlign = 'center';
        ctx.fillStyle = theme.winnerText;
        ctx.font = `bold ${lineHeight * 1.1}px sans-serif`;
        ctx.fillText(`Winners (${winners.length})`, w / 2, panelY + titleHeight / 2);
        // 버튼 중심을 팝업 우상단 꼭지점에 맞춰 걸쳐놓는다. 뒤가 비치지 않게 불투명하게 채우되,
        // 검정으로 채우면 다크 테마에서 배경과 같아져 버튼으로 안 보이므로 대비되는 색을 쓴다
        this._resultCloseRect = (0, $f02253094c3bb7fd$export$1417b54d9380f8a2)(ctx, panelX + panelW, panelY, (0, $f02253094c3bb7fd$export$c24b81217f27d3fe)(h), '#222');
        const rankWidth = lineHeight * 1.8;
        winners.forEach((marble, i)=>{
            const col = Math.floor(i / rows);
            const row = i % rows;
            const x = panelX + padding + col * colWidth;
            const y = panelY + titleHeight + row * lineHeight + lineHeight / 2;
            ctx.save();
            ctx.beginPath();
            ctx.rect(x, y - lineHeight / 2, colWidth, lineHeight);
            ctx.clip();
            ctx.textAlign = 'right';
            ctx.fillStyle = theme.winnerText;
            ctx.font = `${lineHeight * 0.6}px sans-serif`;
            ctx.fillText(`#${winnerRange.start + i + 1}`, x + rankWidth * 0.8, y);
            ctx.textAlign = 'left';
            ctx.fillStyle = `hsl(${marble.hue} 100% ${theme.marbleLightness}%)`;
            ctx.font = `bold ${lineHeight * 0.75}px sans-serif`;
            ctx.fillText(marble.name, x + rankWidth, y);
            ctx.restore();
        });
        ctx.restore();
    }
    renderWinner(winner, theme) {
        this.ctx.save();
        this.ctx.fillStyle = theme.winnerBackground;
        this.ctx.fillRect(this._sceneCanvas.width / 2, this._sceneCanvas.height - (0, $1d1927fc5b91d8b6$export$3b636dc9ab9d92c7), this._sceneCanvas.width / 2, (0, $1d1927fc5b91d8b6$export$3b636dc9ab9d92c7));
        // Draw marble image or colored circle
        const marbleSize = 100;
        const marbleCenterX = this._sceneCanvas.width - marbleSize / 2 - 20;
        const marbleCenterY = this._sceneCanvas.height - (0, $1d1927fc5b91d8b6$export$3b636dc9ab9d92c7) / 2;
        const marbleImage = this.getMarbleImage(winner.name);
        if (marbleImage) this.ctx.drawImage(marbleImage, marbleCenterX - marbleSize / 2, marbleCenterY - marbleSize / 2, marbleSize, marbleSize);
        else {
            this.ctx.beginPath();
            this.ctx.arc(marbleCenterX, marbleCenterY, marbleSize / 2, 0, Math.PI * 2);
            this.ctx.fillStyle = `hsl(${winner.hue} 100% ${theme.marbleLightness})`;
            this.ctx.fill();
        }
        this.ctx.fillStyle = theme.winnerText;
        this.ctx.strokeStyle = theme.winnerOutline;
        this.ctx.font = 'bold 48px sans-serif';
        this.ctx.textAlign = 'right';
        this.ctx.lineWidth = 4;
        const textRightX = marbleCenterX - marbleSize / 2 - 20;
        if (theme.winnerOutline) this.ctx.strokeText('Winner', textRightX, this._sceneCanvas.height - 120 + $68facf3481e408fc$var$WINNER_TEXT_OFFSET);
        this.ctx.fillText('Winner', textRightX, this._sceneCanvas.height - 120 + $68facf3481e408fc$var$WINNER_TEXT_OFFSET);
        this.ctx.font = 'bold 72px sans-serif';
        this.ctx.fillStyle = `hsl(${winner.hue} 100% ${theme.marbleLightness})`;
        if (theme.winnerOutline) this.ctx.strokeText(winner.name, textRightX, this._sceneCanvas.height - 55 + $68facf3481e408fc$var$WINNER_TEXT_OFFSET);
        this.ctx.fillText(winner.name, textRightX, this._sceneCanvas.height - 55 + $68facf3481e408fc$var$WINNER_TEXT_OFFSET);
        this.ctx.restore();
    }
}


const $43c01f2b0f9df660$var$lifetime = 500;
class $43c01f2b0f9df660$export$2faf2590ac4901e1 {
    constructor(x, y){
        this._size = 0;
        this._elapsed = 0;
        this.isDestroy = false;
        this.position = {
            x: x,
            y: y
        };
    }
    update(deltaTime) {
        this._elapsed += deltaTime;
        this._size = this._elapsed / $43c01f2b0f9df660$var$lifetime * 10;
        if (this._elapsed > $43c01f2b0f9df660$var$lifetime) this.isDestroy = true;
    }
    render(ctx, zoom, theme) {
        ctx.save();
        const rate = this._elapsed / $43c01f2b0f9df660$var$lifetime;
        ctx.globalAlpha = 1 - rate * rate;
        ctx.strokeStyle = theme.skillColor;
        ctx.lineWidth = 1 / zoom;
        ctx.beginPath();
        ctx.arc(this.position.x, this.position.y, this._size, 0, Math.PI * 2);
        ctx.stroke();
        ctx.restore();
    }
}





class $ba1c8fec6a2b59e4$export$ec9e02cabe22c790 {
    constructor(canvas){
        this.chunks = [];
        this.targetCanvas = canvas;
        this.videoStream = this.targetCanvas.captureStream();
        this.mediaRecorder = new MediaRecorder(this.videoStream, {
            videoBitsPerSecond: 6000000
        });
    }
    get isRecording() {
        return this.mediaRecorder.state === 'recording';
    }
    async start() {
        if (this.isRecording) return;
        return new Promise((rs)=>{
            this.chunks = [];
            this.mediaRecorder.ondataavailable = (e)=>{
                this.chunks.push(e.data);
            };
            this.mediaRecorder.onstop = ()=>{
                const blob = new Blob(this.chunks, {
                    type: 'video/mp4'
                });
                const videoUrl = URL.createObjectURL(blob);
                const downloadLink = document.createElement('a');
                const d = new Date();
                downloadLink.href = videoUrl;
                downloadLink.download = `marble_roulette_${d.getFullYear()}${(0, $28770b279d7ab5b1$export$5d04458e2a6c373e)(d.getMonth() + 1)}${(0, $28770b279d7ab5b1$export$5d04458e2a6c373e)(d.getDate())}${(0, $28770b279d7ab5b1$export$5d04458e2a6c373e)(d.getHours())}${(0, $28770b279d7ab5b1$export$5d04458e2a6c373e)(d.getMinutes())}${(0, $28770b279d7ab5b1$export$5d04458e2a6c373e)(d.getSeconds())}.mp4`;
                downloadLink.click();
                downloadLink.remove();
                URL.revokeObjectURL(videoUrl);
            };
            this.mediaRecorder.onstart = ()=>{
                rs();
            };
            this.mediaRecorder.start();
        });
    }
    stop() {
        if (this.mediaRecorder.state === 'recording') this.mediaRecorder.stop();
    }
}


function $5158e3721225e8b3$export$bc9aca5f75edcd17(zones, x, y) {
    let best = 0;
    for (const z of zones){
        const hw = z.w / 2;
        const hh = z.h / 2;
        if (hw <= 0 || hh <= 0) continue;
        const t = 1 - Math.max(Math.abs(x - z.x) / hw, Math.abs(y - z.y) / hh);
        if (t > best) best = t;
    }
    return best;
}
function $5158e3721225e8b3$export$2673579b42000563(ctx, zones, rgb = '244, 114, 182') {
    ctx.save();
    ctx.lineWidth = 0.08;
    for (const z of zones){
        ctx.fillStyle = `rgba(${rgb}, 0.15)`;
        ctx.strokeStyle = `rgba(${rgb}, 0.9)`;
        ctx.fillRect(z.x - z.w / 2, z.y - z.h / 2, z.w, z.h);
        ctx.strokeRect(z.x - z.w / 2, z.y - z.h / 2, z.w, z.h);
    }
    ctx.restore();
}


/** 입력 범위를 실제 구슬 수에 맞춰 자른다. 범위를 넘기면 뒤쪽이 잘린다 */ function $7c756c59aac10daa$var$clipWinnerRange({ start: start, end: end }, marbleCount) {
    const last = Math.max(0, marbleCount - 1);
    const clippedStart = Math.min(Math.max(0, start), last);
    return {
        start: clippedStart,
        end: Math.min(Math.max(clippedStart, end), last)
    };
}
/**
 * 순위 흔들림 줄이기. 구슬마다 순위 값(결승까지 남은 거리) 을 이 시간(초) 동안 부드럽게 따라가고,
 * 앞 구슬보다 RANK_MARGIN 넘게 앞서야 자리를 바꾼다
 */ const $7c756c59aac10daa$var$RANK_EMA_SEC = 0.4;
const $7c756c59aac10daa$var$RANK_MARGIN = 0.25;
class $7c756c59aac10daa$export$4929751e8471403 extends EventTarget {
    get isReady() {
        return this._isReady;
    }
    createRenderer() {
        return new (0, $68facf3481e408fc$export$a1ed140729fa937)();
    }
    createFastForwader() {
        return new (0, $edfb0080e3205638$export$bdce5325d183ff94)();
    }
    constructor(){
        super(), this._marbles = [], this._lastTime = 0, this._elapsed = 0, this._updateInterval = 10, this._timeScale = 1, this._speed = 1, this._winners = [], this._particleManager = new (0, $69fffa06e2cc8da9$export$6658904c50100579)(), this._stage = null, /** 'builtin:{index}' | 'community:{id}'. 맵 공유마당에서 받은 맵은 stages 에 없어서 인덱스 대신 이 값으로 구분한다 */ this._mapId = 'builtin:0', this._camera = new (0, $238457a12dbae9c5$export$79f141de891a5fed)(), this._effects = [], this._winnerRange = {
            start: 0,
            end: 0
        }, this._goalDist = Infinity, /** 연출 구역이 있는 맵에서 커트라인을 다투는 두 구슬 중 센 쪽의 연출 강도 (0 ~ 1). 구역이 없으면 null 이고 zoomY 로 판단한다 */ this._zoomIntensity = null, /** 연출이 _targetIndex 구슬이 아니라 _rivalIndex 구슬 때문에 걸렸는지 */ this._focusOnRival = false, /** 구슬별 평활화한 순위 값 (결승까지 남은 거리) */ this._rankKeys = new Map(), /** 진행도 지도 그림 (setProgressDebug 로 켰을 때 맵마다 한 번 만든다) */ this._progressImage = null, this._isRunning = false, /** 진행 중에는 null, 당첨자가 모두 확정되면 당첨자 배열 */ this._result = null, /** 테스트 모드에서 실제 1등으로 통과시킬 구슬 */ this._testWinnerName = null, this._testWinnerMarbleId = null, /** 테스트 모드 전용 추격 보정 상태 */ this._testChaseElapsed = 0, this._testChaseLastAssist = -Infinity, this._testChaseAssists = 0, /** 첫 참가자보다 앞선 후순위 구슬의 감속 횟수 */ this._testSlowdownAssists = new Map(), // 구슬 id(= order)는 매 라운드 재사용된다. 리셋 시 취소하지 않으면 이 타이머가
        // 뒤늦게 발화해 같은 id를 가진 새 라운드의 구슬을 지워버린다
        this._pendingRemovals = [], this._uiObjects = [], this._autoRecording = false, this._isReady = false, this._theme = (0, $1d1927fc5b91d8b6$export$1d8e462b9ec86de2).dark;
        this._renderer = this.createRenderer();
        this._renderer.init().then(()=>{
            this._init().then(()=>{
                this._isReady = true;
                this._update();
            });
        });
    }
    getZoom() {
        return (0, $1d1927fc5b91d8b6$export$c2cc40734f29867c) * this._camera.zoom;
    }
    addUiObject(obj) {
        this._uiObjects.push(obj);
        if (obj.onWheel) this._renderer.canvas.addEventListener('wheel', obj.onWheel);
        if (obj.onMessage) obj.onMessage((msg)=>{
            console.log('onMessage', msg);
            this.dispatchEvent(new CustomEvent('message', {
                detail: msg
            }));
        });
    }
    _update() {
        if (!this._lastTime) this._lastTime = Date.now();
        const currentTime = Date.now();
        this._elapsed += (currentTime - this._lastTime) * this._speed * this.fastForwarder.speed;
        if (this._elapsed > 100) this._elapsed %= 100;
        this._lastTime = currentTime;
        // _timeScale 은 _updateMarbles 에서 갱신되지만 물리 스텝 크기는 이 프레임 시작값으로 고정된다.
        // 구슬 정지 판정도 같은 값을 써야 실제 진행된 물리 시간과 맞는다
        const timeScale = this._timeScale;
        const interval = this._updateInterval / 1000 * timeScale;
        let simSeconds = 0;
        while(this._elapsed >= this._updateInterval){
            simSeconds += interval;
            this.physics.step(interval);
            this._updateMarbles(this._updateInterval, timeScale);
            this._particleManager.update(this._updateInterval);
            this._updateEffects(this._updateInterval);
            this._elapsed -= this._updateInterval;
            this._uiObjects.forEach((obj)=>obj.update(this._updateInterval));
        }
        if (this._marbles.length > 1) this._sortMarbles(simSeconds);
        if (this._stage) {
            const cameraTargetIndex = this._winners.length > 0 ? this._targetIndex : 0;
            this._camera.update({
                marbles: this._marbles,
                stage: this._stage,
                intensity: this._zoomIntensity ?? Math.max(0, 1 - this._goalDist / (0, $1d1927fc5b91d8b6$export$677ef9a3ce6796cf)),
                targetIndex: cameraTargetIndex,
                // 첫 골인 전에는 카메라가 커트라인 대신 선두를 따라가므로 커트라인 쪽 판단을 넘기지 않는다
                focusOnRival: cameraTargetIndex === this._targetIndex && this._focusOnRival,
                viewSize: {
                    x: this._renderer.width / (0, $1d1927fc5b91d8b6$export$c2cc40734f29867c),
                    y: this._renderer.height / (0, $1d1927fc5b91d8b6$export$c2cc40734f29867c)
                }
            });
        }
        this._render();
        window.requestAnimationFrame(this._update);
    }
    /**
   * 순위대로 정렬한다. 순위 값은 진행도 지도의 "결승까지 남은 거리" (progressMap.ts).
   * dt = 이번 프레임에 진행된 물리 시간(초)
   */ _sortMarbles(dt) {
        if (!this._stage) return;
        const map = (0, $4359542a512d968a$export$c9027bf99da09021).for(this._stage);
        /** 지난 프레임 기록이 있는 구슬 수. 구슬을 새로 넣은 직후면 0 */ let known = 0;
        const alpha = 1 - Math.exp(-dt / $7c756c59aac10daa$var$RANK_EMA_SEC);
        const keys = new Map();
        for (const m of this._marbles){
            const raw = map.distanceAt(m.x, m.y);
            const prev = this._rankKeys.get(m);
            if (prev !== undefined) known++;
            keys.set(m, prev !== undefined ? prev + (raw - prev) * alpha : raw);
        }
        this._rankKeys = keys;
        // 구슬을 막 넣었을 때는 지난 순서가 없으니 그냥 정렬한다
        if (known < this._marbles.length / 2) {
            this._marbles.sort((a, b)=>keys.get(a) - keys.get(b) || b.y - a.y);
            return;
        }
        // 지난 프레임 순서에서 출발해, 앞 구슬보다 RANK_MARGIN 넘게 앞설 때만 앞으로 보낸다 (여유를 둔 삽입 정렬).
        // 순서가 거의 그대로라 일반 정렬보다 빠르다
        const list = this._marbles;
        for(let i = 1; i < list.length; i++){
            const m = list[i];
            const k = keys.get(m) + $7c756c59aac10daa$var$RANK_MARGIN;
            let j = i;
            while(j > 0 && k < keys.get(list[j - 1])){
                list[j] = list[j - 1];
                j--;
            }
            list[j] = m;
        }
    }
    /** 진행도 지도(순위 계산에 쓰는 남은 거리), 일방통행 선, 연출 구역, 카메라 구역을 맵 위에 그린다 (테스트 플레이에서 확인용) */ setProgressDebug(on) {
        this._renderer.debugDraw = on ? (ctx)=>{
            if (!this._stage) return;
            const map = (0, $4359542a512d968a$export$c9027bf99da09021).for(this._stage);
            if (this._progressImage?.map !== map) this._progressImage = {
                map: map,
                image: map.toCanvas()
            };
            map.drawDebug(ctx, this._progressImage.image);
            if (this._stage.zoomZones?.length) (0, $5158e3721225e8b3$export$2673579b42000563)(ctx, this._stage.zoomZones);
            if (this._stage.cameraZones?.length) (0, $5158e3721225e8b3$export$2673579b42000563)(ctx, this._stage.cameraZones, '200, 60, 255');
        } : null;
    }
    _updateMarbles(deltaTime, timeScale) {
        if (!this._stage) return;
        for(let i = 0; i < this._marbles.length; i++){
            const marble = this._marbles[i];
            marble.update(deltaTime, timeScale);
            if (marble.skill === (0, $1d1927fc5b91d8b6$export$bc572fe44976cfbc).Impact) {
                this._effects.push(new (0, $43c01f2b0f9df660$export$2faf2590ac4901e1)(marble.x, marble.y));
                this.physics.impact(marble.id);
            }
            if (marble.y > this._stage.goalY) {
                this._winners.push(marble);
                if (this._isRunning && this._isWinningRank(this._winners.length - 1)) this._particleManager.shot(this._renderer.width, this._renderer.height);
                this._pendingRemovals.push(window.setTimeout(()=>{
                    this.physics.removeMarble(marble.id);
                }, 500));
            }
        }
        // Wheel of fortune: 첫 번째 입력 참가자를 추격 가속하고, 그보다 앞선 후순위 구슬은 제한적으로 감속한다.
        if (this._mapId === 'builtin:0' && this._testWinnerMarbleId !== null) {
            this._testChaseElapsed += deltaTime / 1000 * timeScale;
            const target = this._marbles.find((m)=>m.id === this._testWinnerMarbleId);
            if (target) {
                const progress = (0, $4359542a512d968a$export$c9027bf99da09021).for(this._stage);
                const targetDistance = progress.distanceAt(target.x, target.y);
                const intervalReady = this._testChaseElapsed - this._testChaseLastAssist >= 0.25;
                if (intervalReady) {
                    // 첫 참가자가 선두보다 뒤처지면 기존 추격 가속을 적용한다.
                    const leader = this._marbles.reduce((best, marble)=>progress.distanceAt(marble.x, marble.y) < progress.distanceAt(best.x, best.y) ? marble : best, target);
                    if (leader !== target && targetDistance > progress.distanceAt(leader.x, leader.y) + 0.25 && this._testChaseAssists < 32) {
                        this.physics.adjustMarbleSpeed(target.id, 1.2);
                        this._testChaseAssists++;
                        this._testChaseLastAssist = this._testChaseElapsed;
                    }
                    // 첫 참가자보다 앞서 있든 뒤에 있든, 나머지 모든 구슬을 구슬별 최대 8회·회당 5% 감속한다.
                    for (const marble of this._marbles){
                        if (marble.id === target.id) continue;
                        const assists = this._testSlowdownAssists.get(marble.id) ?? 0;
                        if (assists >= 8) continue;
                        this.physics.adjustMarbleSpeed(marble.id, 0.95);
                        this._testSlowdownAssists.set(marble.id, assists + 1);
                        this._testChaseLastAssist = this._testChaseElapsed;
                    }
                }
            }
        }
        // 연출(줌인, 슬로모션) 은 커트라인을 다투는 두 구슬 중 연출이 더 센 쪽을 기준으로 건다.
        // 예: 꼴찌를 뽑을 때는 바로 앞 구슬이 골인하는 순간 꼴찌가 정해진다
        const stage = this._stage;
        const zones = stage.zoomZones?.length ? stage.zoomZones : null;
        const intensityOf = (m)=>zones ? (0, $5158e3721225e8b3$export$bc9aca5f75edcd17)(zones, m.x, m.y) : Math.max(0, 1 - Math.abs(stage.zoomY - m.y) / (0, $1d1927fc5b91d8b6$export$677ef9a3ce6796cf));
        const target = this._marbles[this._targetIndex];
        const rival = this._marbles[this._rivalIndex];
        this._focusOnRival = !!target && !!rival && intensityOf(rival) > intensityOf(target);
        const focus = this._focusOnRival ? rival : target;
        this._goalDist = Math.abs(stage.zoomY - (focus ? focus.y : 0));
        this._zoomIntensity = zones ? focus ? intensityOf(focus) : 0 : null;
        this._timeScale = this._calcTimeScale();
        this._marbles = this._marbles.filter((marble)=>marble.y <= this._stage?.goalY);
        this._checkFinish();
    }
    /** 카메라와 슬로우모션이 주목할 구슬 = 당첨 커트라인에 걸쳐있는 구슬 */ get _targetIndex() {
        return this._winnerRange.end - this._winners.length;
    }
    /** 커트라인을 두고 _targetIndex 구슬과 다투는 구슬 = 바로 뒤, 없으면 바로 앞 구슬 */ get _rivalIndex() {
        const i = this._targetIndex;
        return this._marbles[i + 1] ? i + 1 : i - 1;
    }
    _isWinningRank(rank) {
        return rank >= this._winnerRange.start && rank <= this._winnerRange.end;
    }
    _checkFinish() {
        if (!this._isRunning) return;
        const { start: start, end: end } = this._winnerRange;
        // 남은 구슬이 1개면 그 등수는 골인하지 않아도 확정된다. 2개 이상 남았다면 그들 사이의
        // 순위는 물리로만 정해지므로 예측하지 않는다 (당첨 범위 안에서도 순위는 의미를 가진다)
        const early = this._winners.length > 0 && this._marbles.length === 1;
        const ranked = early ? [
            ...this._winners,
            this._marbles[0]
        ] : this._winners;
        if (ranked.length <= end) return;
        if (early && this._isWinningRank(this._winners.length)) this._particleManager.shot(this._renderer.width, this._renderer.height);
        // 테스트 모드에서도 실제로 결승선을 통과한 구슬을 결과로 사용한다.
        this._result = ranked.slice(start, end + 1);
        this._isRunning = false;
        this.dispatchEvent(new CustomEvent('goal', {
            detail: {
                winner: this._result[0].name,
                winners: this._result.map((m)=>m.name)
            }
        }));
        setTimeout(()=>{
            this._recorder.stop();
        }, 1000);
    }
    _calcTimeScale() {
        if (!this._stage) return 1;
        const targetIndex = this._targetIndex;
        // 연출 구역: 커트라인 구슬이 구역 가운데로 갈수록 느려진다. 경쟁하는 구슬이 있을 때만
        if (this._zoomIntensity !== null) {
            if (this._winners.length < this._winnerRange.end + 1 && this._zoomIntensity > 0 && (this._marbles[targetIndex - 1] || this._marbles[targetIndex + 1])) return Math.max(0.2, 1 - this._zoomIntensity);
            return 1;
        }
        if (this._winners.length < this._winnerRange.end + 1 && this._goalDist < (0, $1d1927fc5b91d8b6$export$677ef9a3ce6796cf)) {
            if (this._marbles[this._focusOnRival ? this._rivalIndex : targetIndex].y > this._stage.zoomY - (0, $1d1927fc5b91d8b6$export$677ef9a3ce6796cf) * 1.2 && (this._marbles[targetIndex - 1] || this._marbles[targetIndex + 1])) return Math.max(0.2, this._goalDist / (0, $1d1927fc5b91d8b6$export$677ef9a3ce6796cf));
        }
        return 1;
    }
    _updateEffects(deltaTime) {
        this._effects.forEach((effect)=>effect.update(deltaTime));
        this._effects = this._effects.filter((effect)=>!effect.isDestroy);
    }
    _render() {
        if (!this._stage) return;
        const renderParams = {
            camera: this._camera,
            stage: this._stage,
            entities: this.physics.getEntities(),
            marbles: this._marbles,
            winners: this._winners,
            particleManager: this._particleManager,
            effects: this._effects,
            winnerRange: this._winnerRange,
            result: this._result,
            size: {
                x: this._renderer.width,
                y: this._renderer.height
            },
            theme: this._theme
        };
        this._renderer.render(renderParams, this._uiObjects);
    }
    async _init() {
        this._recorder = new (0, $ba1c8fec6a2b59e4$export$ec9e02cabe22c790)(this._renderer.canvas);
        this.physics = new (0, $fafe2abfa7f98b9f$export$81ba3d9458692cc2)();
        await this.physics.init();
        this.addUiObject(new (0, $e0350dec16bbe919$export$795f70ffe4ca76fc)());
        this.attachEvent();
        const minimap = new (0, $c2ea39beabe51779$export$a8b4308ba35ee473)();
        minimap.onViewportChange((pos)=>{
            if (pos) {
                this._camera.setPosition(pos, false);
                this._camera.lock(true);
            } else this._camera.lock(false);
        });
        this.addUiObject(minimap);
        this.fastForwarder = this.createFastForwader();
        this.addUiObject(this.fastForwarder);
        this._stage = (0, $b2abafc93d11a512$export$1bfcff8d7c4bf05)[0];
        this._loadMap();
    }
    mouseHandler(eventName, e) {
        const handlerName = `on${eventName}`;
        const sizeFactor = this._renderer.sizeFactor;
        const pos = {
            x: e.offsetX * sizeFactor,
            y: e.offsetY * sizeFactor
        };
        this._uiObjects.forEach((obj)=>{
            if (!obj[handlerName]) return;
            const bounds = obj.getBoundingBox();
            if (!bounds) obj[handlerName]({
                ...pos,
                button: e.button
            });
            else if (bounds && pos.x >= bounds.x && pos.y >= bounds.y && pos.x <= bounds.x + bounds.w && pos.y <= bounds.y + bounds.h) obj[handlerName]({
                x: pos.x - bounds.x,
                y: pos.y - bounds.y,
                button: e.button
            });
            else obj[handlerName](undefined);
        });
    }
    attachEvent() {
        const canvas = this._renderer.canvas;
        const onPointerRelease = (e)=>{
            this.mouseHandler('MouseUp', e);
            window.removeEventListener('pointerup', onPointerRelease);
            window.removeEventListener('pointercancel', onPointerRelease);
        };
        canvas.addEventListener('pointerdown', (e)=>{
            this.mouseHandler('MouseDown', e);
            window.addEventListener('pointerup', onPointerRelease);
            window.addEventListener('pointercancel', onPointerRelease);
        });
        [
            'MouseMove',
            'DblClick'
        ].forEach((ev)=>{
            // @ts-expect-error
            canvas.addEventListener(ev.toLowerCase().replace('mouse', 'pointer'), this.mouseHandler.bind(this, ev));
        });
        canvas.addEventListener('contextmenu', (e)=>{
            e.preventDefault();
        });
        canvas.addEventListener('click', (e)=>{
            // 광고 오버레이가 팝업 위에 그려지므로 먼저 검사한다
            const hit = this.adHitAt(e);
            if (hit) {
                if (hit.type === 'close') this.hideAdOverlay();
                else window.open(hit.url, '_blank', 'noopener');
                return;
            }
            if (this.resultCloseHitAt(e)) this._renderer.closeResultPopup();
        });
        canvas.addEventListener('pointermove', (e)=>{
            canvas.style.cursor = this.adHitAt(e) || this.resultCloseHitAt(e) ? 'pointer' : '';
        });
    }
    _loadMap() {
        if (!this._stage) throw new Error('No map has been selected');
        this.physics.createStage(this._stage);
        this._camera.initializePosition();
    }
    clearMarbles() {
        this._pendingRemovals.forEach((id)=>window.clearTimeout(id));
        this._pendingRemovals = [];
        this.physics.clearMarbles();
        this._result = null;
        this._winners = [];
        this._marbles = [];
    }
    async startRecording() {
        if (!this._autoRecording) return;
        try {
            await this._recorder.start();
        } catch (e) {
            console.error('recording failed to start', e);
        }
    }
    _startPhysics() {
        this.physics.start();
        this._marbles.forEach((marble)=>marble.isActive = true);
        // 출발 순간의 추가 가속은 제거한다. 지정 구슬도 다른 구슬과 같은 조건에서 출발한다.
        if (this._mapId === 'builtin:0' && this._testWinnerMarbleId !== null) {
            this._testChaseElapsed = 0;
            this._testChaseLastAssist = -Infinity;
            this._testChaseAssists = 0;
            this._testSlowdownAssists.clear();
        }
    }
    start() {
        this._isRunning = true;
        this._winnerRange = $7c756c59aac10daa$var$clipWinnerRange((0, $2573268c577c952d$export$2e2bcd8739ae039).winnerRange, this._marbles.length);
        this._camera.startFollowingMarbles();
        if (this._autoRecording) this._recorder.start().then(()=>this._startPhysics());
        else this._startPhysics();
    }
    setSpeed(value) {
        if (value <= 0) throw new Error('Speed multiplier must larger than 0');
        this._speed = value;
    }
    setAd(ad) {
        this._renderer.setAd(ad);
    }
    preloadAdImages(srcs) {
        this._renderer.preloadAdImages(srcs);
    }
    showAdOverlay(mode) {
        this._renderer.showAdOverlay(mode);
    }
    hideAdOverlay() {
        this._renderer.hideAdOverlay();
    }
    adHitAt(e) {
        const sizeFactor = this._renderer.sizeFactor;
        return this._renderer.getAdHitAt(e.offsetX * sizeFactor, e.offsetY * sizeFactor);
    }
    resultCloseHitAt(e) {
        const sizeFactor = this._renderer.sizeFactor;
        return this._renderer.getResultCloseHitAt(e.offsetX * sizeFactor, e.offsetY * sizeFactor);
    }
    setTheme(themeName) {
        this._theme = (0, $1d1927fc5b91d8b6$export$1d8e462b9ec86de2)[themeName];
    }
    getSpeed() {
        return this._speed;
    }
    /** 테스트 모드에서 실제 1등으로 통과시킬 참가자를 지정한다. */ setTestWinner(name) {
        this._testWinnerName = name;
        this._testWinnerMarbleId = name ? this._marbles.find((marble)=>marble.name === name)?.id ?? null : null;
    }
    setWinningRank(rank) {
        this.setWinnerRange(rank, rank);
    }
    setWinnerRange(start, end) {
        (0, $2573268c577c952d$export$2e2bcd8739ae039).winnerRange = {
            start: start,
            end: end
        };
        this._winnerRange = $7c756c59aac10daa$var$clipWinnerRange((0, $2573268c577c952d$export$2e2bcd8739ae039).winnerRange, this._marbles.length);
    }
    /** 실제 구슬 수에 맞춰 잘린 범위 (0-based, 양끝 포함) */ getWinnerRange() {
        return {
            ...this._winnerRange
        };
    }
    setAutoRecording(value) {
        this._autoRecording = value;
    }
    setMarbles(names) {
        this.reset();
        const arr = names.slice();
        let maxWeight = -Infinity;
        let minWeight = Infinity;
        const members = arr.map((nameString)=>{
            const result = (0, $28770b279d7ab5b1$export$5d945868514965a9)(nameString);
            if (!result) return null;
            const { name: name, weight: weight, count: count } = result;
            if (weight > maxWeight) maxWeight = weight;
            if (weight < minWeight) minWeight = weight;
            return {
                name: name,
                weight: weight,
                count: count
            };
        }).filter((member)=>!!member);
        const gap = maxWeight - minWeight;
        let totalCount = 0;
        members.forEach((member)=>{
            if (member) {
                member.weight = 0.1 + (gap ? (member.weight - minWeight) / gap : 0);
                totalCount += member.count;
            }
        });
        const orders = (0, $28770b279d7ab5b1$export$448332262467e042)(Array(totalCount).fill(0).map((_, i)=>i));
        members.forEach((member)=>{
            if (member) for(let j = 0; j < member.count; j++){
                const order = orders.pop() || 0;
                this._marbles.push(new (0, $e7b6517817360fee$export$e91dba6fa3f67f68)(this.physics, order, totalCount, member.name, member.weight));
            }
        });
        // 첫 번째로 입력된 유효 참가자를 자동 보정 대상으로 지정한다.
        this._testWinnerName = members[0]?.name ?? null;
        // 참가자 구슬 생성 이후 첫 참가자 이름에 해당하는 실제 구슬 ID를 연결한다.
        this._testWinnerMarbleId = this._testWinnerName ? this._marbles.find((marble)=>marble.name === this._testWinnerName)?.id ?? null : null;
        // 카메라를 구슬 생성 위치 중앙으로 이동 + 줌인
        if (totalCount > 0) {
            const cols = Math.min(totalCount, 10);
            const rows = Math.ceil(totalCount / 10);
            const lineDelta = -Math.max(0, Math.ceil(rows - 5));
            const centerX = 10.25 + (cols - 1) * 0.3;
            const centerY = (1 + rows) / 2 + lineDelta;
            const spawnWidth = Math.max((cols - 1) * 0.6, 1);
            const spawnHeight = Math.max(rows - 1, 1);
            const margin = 3;
            const viewW = (0, $1d1927fc5b91d8b6$export$1cd840e6ecaab774) / (0, $1d1927fc5b91d8b6$export$c2cc40734f29867c);
            const viewH = (0, $1d1927fc5b91d8b6$export$3d795bc15e02aca) / (0, $1d1927fc5b91d8b6$export$c2cc40734f29867c);
            const zoom = Math.max(1.5, Math.min(Math.min(viewW / (spawnWidth + margin * 2), viewH / (spawnHeight + margin * 2)), 3));
            this._camera.initializePosition({
                x: centerX,
                y: centerY
            }, zoom);
        }
    }
    _clearMap() {
        this.physics.clear();
        this._marbles = [];
    }
    reset() {
        this.clearMarbles();
        this._clearMap();
        this._loadMap();
        this._goalDist = Infinity;
        this._focusOnRival = false;
    }
    getCount() {
        return this._marbles.length;
    }
    getMaps() {
        return (0, $b2abafc93d11a512$export$1bfcff8d7c4bf05).map((stage, index)=>{
            return {
                index: index,
                title: stage.title
            };
        });
    }
    /** index 는 기본 맵의 인덱스, 다운로드한 맵이면 -1 */ getCurrentMap() {
        if (!this._stage) return null;
        return {
            index: (0, $b2abafc93d11a512$export$1bfcff8d7c4bf05).indexOf(this._stage),
            title: this._stage.title,
            id: this._mapId
        };
    }
    setMap(index) {
        if (index < 0 || index > (0, $b2abafc93d11a512$export$1bfcff8d7c4bf05).length - 1) throw new Error('Incorrect map number');
        this.setStage((0, $b2abafc93d11a512$export$1bfcff8d7c4bf05)[index], `builtin:${index}`);
    }
    /** 기본 맵 목록에 없는 맵(맵 공유마당에서 받은 맵) 을 쓴다 */ setStage(stage, id) {
        const names = this._marbles.map((marble)=>marble.name);
        this._stage = stage;
        this._mapId = id;
        this.setMarbles(names);
        this._camera.initializePosition();
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $5d9d2ddcc4e90c63$export$adf7c0fe6059d774)
], $7c756c59aac10daa$export$4929751e8471403.prototype, "_update", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $5d9d2ddcc4e90c63$export$adf7c0fe6059d774)
], $7c756c59aac10daa$export$4929751e8471403.prototype, "mouseHandler", null);


// 어떤 버전이 실제로 돌고 있는지 관측한다. 옛 서비스워커에 고착된 클라이언트는
// 이 코드가 없는 번들을 쓰므로 이벤트를 보내지 않는다. 즉 전체 pageview 대비
// 이 이벤트의 비율이 곧 회수율이다.
//
// 번들 파일명의 content hash를 그대로 버전으로 쓴다. 빌드 시 주입이 필요 없고,
// 실제로 내용이 달라졌을 때만 값이 바뀌므로 커밋 해시보다 정확하다.
// import.meta.url은 못 쓴다. Parcel이 번들 URL이 아니라 소스 경로 리터럴로 치환한다.
// dev 서버는 파일명에 해시가 없어 'dev'로 떨어진다.
const $b4e14b6b8da86996$var$bundleSrc = document.querySelector('script[type="module"]')?.src ?? '';
const $b4e14b6b8da86996$var$version = $b4e14b6b8da86996$var$bundleSrc.match(/\.([0-9a-f]{6,})\.js/)?.[1] ?? 'dev';
// umami는 defer로 로드되므로 load 시점이면 이미 준비돼 있다.
window.addEventListener('load', ()=>{
    window.umami?.track('version', {
        v: $b4e14b6b8da86996$var$version
    });
});
const $b4e14b6b8da86996$var$roulette = new (0, $7c756c59aac10daa$export$4929751e8471403)();
const $b4e14b6b8da86996$var$isLocalhost = [
    'localhost',
    '127.0.0.1'
].includes(location.hostname);
const $b4e14b6b8da86996$var$adService = new (0, $48ba836f20a6b5e8$export$32c78522a0310c00)($b4e14b6b8da86996$var$isLocalhost ? 'http://localhost:3000' : 'https://marblerouletteshop.com');
// 소재를 시작 버튼 누른 뒤에 받으면 프리롤이 로고 없이 떴다가 늦게 채워진다. 미리 받아둔다
const $b4e14b6b8da86996$var$preloadNextAd = ()=>$b4e14b6b8da86996$var$roulette.preloadAdImages($b4e14b6b8da86996$var$adService.nextUrls());
$b4e14b6b8da86996$var$adService.onUpdate = $b4e14b6b8da86996$var$preloadNextAd;
$b4e14b6b8da86996$var$adService.init();
window.roulette = $b4e14b6b8da86996$var$roulette;
// 맵 공유마당 API 는 광고와 같은 서버에 있다
const $b4e14b6b8da86996$var$mapApiBase = $b4e14b6b8da86996$var$isLocalhost ? 'http://localhost:3000' : 'https://marblerouletteshop.com';
// index.html 이 초기화할 때 부른다
window.initMapSelector = (onMapChange, toast)=>(0, $5c130f6cdf6e8890$export$5e49f212e4e2b5d5)({
        roulette: $b4e14b6b8da86996$var$roulette,
        apiBase: $b4e14b6b8da86996$var$mapApiBase,
        onMapChange: onMapChange,
        toast: toast
    });
// 시작 버튼. 받은 맵이면 플레이 1회를 알린다
window.reportMapPlay = ()=>(0, $bc803f7cdb25c6b1$export$34d4b327ebc3ab)($b4e14b6b8da86996$var$mapApiBase, $b4e14b6b8da86996$var$roulette.getCurrentMap()?.id ?? '');
window.options = (0, $2573268c577c952d$export$2e2bcd8739ae039);
const $b4e14b6b8da86996$var$PREROLL_MS = 1500;
function $b4e14b6b8da86996$var$once(fn) {
    let called = false;
    return ()=>{
        if (called) return;
        called = true;
        fn();
    };
}
window.ads = {
    beginRound (onStart) {
        const start = $b4e14b6b8da86996$var$once(onStart);
        let ad = null;
        try {
            // 실제 광고가 있으면 우선 노출하고, 없거나 서버 연결에 실패하면 기본 광고 카드를 표시한다.
            ad = $b4e14b6b8da86996$var$adService.pickForRound() ?? {
                id: 'marble-dash-house-preroll',
                slots: [
                    'preroll'
                ],
                advertiser: 'Marble Dash',
                tagline: "\uC990\uAC70\uC6B4 \uB8F0\uB81B\uC744 \uC2DC\uC791\uD569\uB2C8\uB2E4",
                house: true,
                creatives: {}
            };
            $b4e14b6b8da86996$var$roulette.setAd(ad);
            if (!ad.house) $b4e14b6b8da86996$var$adService.trackImpression();
            $b4e14b6b8da86996$var$preloadNextAd();
        } catch (e) {
            console.error("[ads] \uAD11\uACE0 \uC900\uBE44 \uC2E4\uD328, \uAD11\uACE0 \uC5C6\uC774 \uC9C4\uD589\uD569\uB2C8\uB2E4", e);
            ad = null;
        }
        $b4e14b6b8da86996$var$roulette.startRecording().then(()=>{
            if (!ad) {
                start();
                return;
            }
            try {
                $b4e14b6b8da86996$var$roulette.showAdOverlay('preroll');
            } catch (e) {
                console.error("[ads] \uD504\uB9AC\uB864 \uD45C\uC2DC \uC2E4\uD328, \uBC14\uB85C \uC2DC\uC791\uD569\uB2C8\uB2E4", e);
                start();
                return;
            }
            window.setTimeout(()=>{
                $b4e14b6b8da86996$var$roulette.hideAdOverlay();
                start();
            }, $b4e14b6b8da86996$var$PREROLL_MS);
        });
    },
    showResult () {
        try {
            $b4e14b6b8da86996$var$roulette.showAdOverlay('result');
        } catch (e) {
            console.error("[ads] \uACB0\uACFC \uD654\uBA74 \uAD11\uACE0 \uD45C\uC2DC \uC2E4\uD328", e);
        }
    }
};


//# sourceMappingURL=repo.dce36858.js.map
